/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar type represents a date and time with time zone offset information. */
  DateTime: { input: any; output: any; }
  /** The `UUID` scalar type represents a Universally Unique Identifier (UUID) as defined by RFC 9562. */
  UUID: { input: string; output: string; }
  bigint: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** columns and relationships of "ApiKey" */
export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  device?: Maybe<Device>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['bigint']['output'];
  key: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "ApiKey" */
export type ApiKeyAggregate = {
  __typename?: 'ApiKeyAggregate';
  aggregate?: Maybe<ApiKeyAggregateFields>;
  nodes: Array<ApiKey>;
};

export type ApiKeyAggregateBoolExp = {
  count?: InputMaybe<ApiKeyAggregateBoolExpCount>;
};

/** aggregate fields of "ApiKey" */
export type ApiKeyAggregateFields = {
  __typename?: 'ApiKeyAggregateFields';
  avg?: Maybe<ApiKeyAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ApiKeyMaxFields>;
  min?: Maybe<ApiKeyMinFields>;
  stddev?: Maybe<ApiKeyStddevFields>;
  stddevPop?: Maybe<ApiKeyStddevPopFields>;
  stddevSamp?: Maybe<ApiKeyStddevSampFields>;
  sum?: Maybe<ApiKeySumFields>;
  varPop?: Maybe<ApiKeyVarPopFields>;
  varSamp?: Maybe<ApiKeyVarSampFields>;
  variance?: Maybe<ApiKeyVarianceFields>;
};


/** aggregate fields of "ApiKey" */
export type ApiKeyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ApiKeySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ApiKey" */
export type ApiKeyAggregateOrderBy = {
  avg?: InputMaybe<ApiKeyAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ApiKeyMaxOrderBy>;
  min?: InputMaybe<ApiKeyMinOrderBy>;
  stddev?: InputMaybe<ApiKeyStddevOrderBy>;
  stddevPop?: InputMaybe<ApiKeyStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ApiKeyStddevSampOrderBy>;
  sum?: InputMaybe<ApiKeySumOrderBy>;
  varPop?: InputMaybe<ApiKeyVarPopOrderBy>;
  varSamp?: InputMaybe<ApiKeyVarSampOrderBy>;
  variance?: InputMaybe<ApiKeyVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ApiKey" */
export type ApiKeyArrRelInsertInput = {
  data: Array<ApiKeyInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ApiKeyOnConflict>;
};

/** aggregate avg on columns */
export type ApiKeyAvgFields = {
  __typename?: 'ApiKeyAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ApiKey" */
export type ApiKeyAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ApiKey". All fields are combined with a logical 'AND'. */
export type ApiKeyBoolExp = {
  _and?: InputMaybe<Array<ApiKeyBoolExp>>;
  _not?: InputMaybe<ApiKeyBoolExp>;
  _or?: InputMaybe<Array<ApiKeyBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customer?: InputMaybe<CustomerBoolExp>;
  customerId?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  device?: InputMaybe<DeviceBoolExp>;
  deviceId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  reference?: InputMaybe<StringComparisonExp>;
  roleId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "ApiKey" */
export enum ApiKeyConstraint {
  /** unique or primary key constraint on columns "Key" */
  IxApiKeyKey = 'IX_ApiKey_Key',
  /** unique or primary key constraint on columns "Id" */
  PkApiKey = 'PK_ApiKey'
}

/** input type for incrementing numeric columns in table "ApiKey" */
export type ApiKeyIncInput = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ApiKey" */
export type ApiKeyInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<CustomerObjRelInsertInput>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<DeviceObjRelInsertInput>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ApiKeyMaxFields = {
  __typename?: 'ApiKeyMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customerId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "ApiKey" */
export type ApiKeyMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  reference?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ApiKeyMinFields = {
  __typename?: 'ApiKeyMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customerId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "ApiKey" */
export type ApiKeyMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  reference?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ApiKey" */
export type ApiKeyMutationResponse = {
  __typename?: 'ApiKeyMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ApiKey>;
};

/** on_conflict condition type for table "ApiKey" */
export type ApiKeyOnConflict = {
  constraint: ApiKeyConstraint;
  updateColumns?: Array<ApiKeyUpdateColumn>;
  where?: InputMaybe<ApiKeyBoolExp>;
};

/** Ordering options when selecting data from "ApiKey". */
export type ApiKeyOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customer?: InputMaybe<CustomerOrderBy>;
  customerId?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  device?: InputMaybe<DeviceOrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  reference?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ApiKey */
export type ApiKeyPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "ApiKey" */
export enum ApiKeySelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Description = 'description',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Reference = 'reference',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "ApiKey" */
export type ApiKeySetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ApiKeyStddevFields = {
  __typename?: 'ApiKeyStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ApiKey" */
export type ApiKeyStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ApiKeyStddevPopFields = {
  __typename?: 'ApiKeyStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "ApiKey" */
export type ApiKeyStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ApiKeyStddevSampFields = {
  __typename?: 'ApiKeyStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "ApiKey" */
export type ApiKeyStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ApiKey" */
export type ApiKeyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ApiKeyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ApiKeyStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ApiKeySumFields = {
  __typename?: 'ApiKeySumFields';
  id?: Maybe<Scalars['bigint']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "ApiKey" */
export type ApiKeySumOrderBy = {
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** update columns of table "ApiKey" */
export enum ApiKeyUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Description = 'description',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Reference = 'reference',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

export type ApiKeyUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApiKeyIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApiKeySetInput>;
  /** filter the rows which have to be updated */
  where: ApiKeyBoolExp;
};

/** aggregate varPop on columns */
export type ApiKeyVarPopFields = {
  __typename?: 'ApiKeyVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "ApiKey" */
export type ApiKeyVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ApiKeyVarSampFields = {
  __typename?: 'ApiKeyVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "ApiKey" */
export type ApiKeyVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ApiKeyVarianceFields = {
  __typename?: 'ApiKeyVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ApiKey" */
export type ApiKeyVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** columns and relationships of "AspNetRoleClaims" */
export type AspNetRoleClaims = {
  __typename?: 'AspNetRoleClaims';
  claimType?: Maybe<Scalars['String']['output']>;
  claimValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  roleId: Scalars['String']['output'];
};

/** aggregated selection of "AspNetRoleClaims" */
export type AspNetRoleClaimsAggregate = {
  __typename?: 'AspNetRoleClaimsAggregate';
  aggregate?: Maybe<AspNetRoleClaimsAggregateFields>;
  nodes: Array<AspNetRoleClaims>;
};

/** aggregate fields of "AspNetRoleClaims" */
export type AspNetRoleClaimsAggregateFields = {
  __typename?: 'AspNetRoleClaimsAggregateFields';
  avg?: Maybe<AspNetRoleClaimsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AspNetRoleClaimsMaxFields>;
  min?: Maybe<AspNetRoleClaimsMinFields>;
  stddev?: Maybe<AspNetRoleClaimsStddevFields>;
  stddevPop?: Maybe<AspNetRoleClaimsStddevPopFields>;
  stddevSamp?: Maybe<AspNetRoleClaimsStddevSampFields>;
  sum?: Maybe<AspNetRoleClaimsSumFields>;
  varPop?: Maybe<AspNetRoleClaimsVarPopFields>;
  varSamp?: Maybe<AspNetRoleClaimsVarSampFields>;
  variance?: Maybe<AspNetRoleClaimsVarianceFields>;
};


/** aggregate fields of "AspNetRoleClaims" */
export type AspNetRoleClaimsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AspNetRoleClaimsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AspNetRoleClaimsAvgFields = {
  __typename?: 'AspNetRoleClaimsAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "AspNetRoleClaims". All fields are combined with a logical 'AND'. */
export type AspNetRoleClaimsBoolExp = {
  _and?: InputMaybe<Array<AspNetRoleClaimsBoolExp>>;
  _not?: InputMaybe<AspNetRoleClaimsBoolExp>;
  _or?: InputMaybe<Array<AspNetRoleClaimsBoolExp>>;
  claimType?: InputMaybe<StringComparisonExp>;
  claimValue?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  roleId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "AspNetRoleClaims" */
export enum AspNetRoleClaimsConstraint {
  /** unique or primary key constraint on columns "Id" */
  PkAspNetRoleClaims = 'PK_AspNetRoleClaims'
}

/** input type for incrementing numeric columns in table "AspNetRoleClaims" */
export type AspNetRoleClaimsIncInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "AspNetRoleClaims" */
export type AspNetRoleClaimsInsertInput = {
  claimType?: InputMaybe<Scalars['String']['input']>;
  claimValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AspNetRoleClaimsMaxFields = {
  __typename?: 'AspNetRoleClaimsMaxFields';
  claimType?: Maybe<Scalars['String']['output']>;
  claimValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AspNetRoleClaimsMinFields = {
  __typename?: 'AspNetRoleClaimsMinFields';
  claimType?: Maybe<Scalars['String']['output']>;
  claimValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AspNetRoleClaims" */
export type AspNetRoleClaimsMutationResponse = {
  __typename?: 'AspNetRoleClaimsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AspNetRoleClaims>;
};

/** on_conflict condition type for table "AspNetRoleClaims" */
export type AspNetRoleClaimsOnConflict = {
  constraint: AspNetRoleClaimsConstraint;
  updateColumns?: Array<AspNetRoleClaimsUpdateColumn>;
  where?: InputMaybe<AspNetRoleClaimsBoolExp>;
};

/** Ordering options when selecting data from "AspNetRoleClaims". */
export type AspNetRoleClaimsOrderBy = {
  claimType?: InputMaybe<OrderBy>;
  claimValue?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: AspNetRoleClaims */
export type AspNetRoleClaimsPkColumnsInput = {
  id: Scalars['Int']['input'];
};

/** select columns of table "AspNetRoleClaims" */
export enum AspNetRoleClaimsSelectColumn {
  /** column name */
  ClaimType = 'claimType',
  /** column name */
  ClaimValue = 'claimValue',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId'
}

/** input type for updating data in table "AspNetRoleClaims" */
export type AspNetRoleClaimsSetInput = {
  claimType?: InputMaybe<Scalars['String']['input']>;
  claimValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type AspNetRoleClaimsStddevFields = {
  __typename?: 'AspNetRoleClaimsStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type AspNetRoleClaimsStddevPopFields = {
  __typename?: 'AspNetRoleClaimsStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type AspNetRoleClaimsStddevSampFields = {
  __typename?: 'AspNetRoleClaimsStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "AspNetRoleClaims" */
export type AspNetRoleClaimsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AspNetRoleClaimsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AspNetRoleClaimsStreamCursorValueInput = {
  claimType?: InputMaybe<Scalars['String']['input']>;
  claimValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type AspNetRoleClaimsSumFields = {
  __typename?: 'AspNetRoleClaimsSumFields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "AspNetRoleClaims" */
export enum AspNetRoleClaimsUpdateColumn {
  /** column name */
  ClaimType = 'claimType',
  /** column name */
  ClaimValue = 'claimValue',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId'
}

export type AspNetRoleClaimsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AspNetRoleClaimsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AspNetRoleClaimsSetInput>;
  /** filter the rows which have to be updated */
  where: AspNetRoleClaimsBoolExp;
};

/** aggregate varPop on columns */
export type AspNetRoleClaimsVarPopFields = {
  __typename?: 'AspNetRoleClaimsVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type AspNetRoleClaimsVarSampFields = {
  __typename?: 'AspNetRoleClaimsVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AspNetRoleClaimsVarianceFields = {
  __typename?: 'AspNetRoleClaimsVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "AspNetRoles" */
export type AspNetRoles = {
  __typename?: 'AspNetRoles';
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  normalizedName?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "AspNetRoles" */
export type AspNetRolesAggregate = {
  __typename?: 'AspNetRolesAggregate';
  aggregate?: Maybe<AspNetRolesAggregateFields>;
  nodes: Array<AspNetRoles>;
};

/** aggregate fields of "AspNetRoles" */
export type AspNetRolesAggregateFields = {
  __typename?: 'AspNetRolesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<AspNetRolesMaxFields>;
  min?: Maybe<AspNetRolesMinFields>;
};


/** aggregate fields of "AspNetRoles" */
export type AspNetRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AspNetRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AspNetRoles". All fields are combined with a logical 'AND'. */
export type AspNetRolesBoolExp = {
  _and?: InputMaybe<Array<AspNetRolesBoolExp>>;
  _not?: InputMaybe<AspNetRolesBoolExp>;
  _or?: InputMaybe<Array<AspNetRolesBoolExp>>;
  concurrencyStamp?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  normalizedName?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "AspNetRoles" */
export enum AspNetRolesConstraint {
  /** unique or primary key constraint on columns "Id" */
  PkAspNetRoles = 'PK_AspNetRoles',
  /** unique or primary key constraint on columns "NormalizedName" */
  RoleNameIndex = 'RoleNameIndex'
}

/** input type for inserting data into table "AspNetRoles" */
export type AspNetRolesInsertInput = {
  concurrencyStamp?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalizedName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AspNetRolesMaxFields = {
  __typename?: 'AspNetRolesMaxFields';
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  normalizedName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AspNetRolesMinFields = {
  __typename?: 'AspNetRolesMinFields';
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  normalizedName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AspNetRoles" */
export type AspNetRolesMutationResponse = {
  __typename?: 'AspNetRolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AspNetRoles>;
};

/** input type for inserting object relation for remote table "AspNetRoles" */
export type AspNetRolesObjRelInsertInput = {
  data: AspNetRolesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AspNetRolesOnConflict>;
};

/** on_conflict condition type for table "AspNetRoles" */
export type AspNetRolesOnConflict = {
  constraint: AspNetRolesConstraint;
  updateColumns?: Array<AspNetRolesUpdateColumn>;
  where?: InputMaybe<AspNetRolesBoolExp>;
};

/** Ordering options when selecting data from "AspNetRoles". */
export type AspNetRolesOrderBy = {
  concurrencyStamp?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  normalizedName?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: AspNetRoles */
export type AspNetRolesPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "AspNetRoles" */
export enum AspNetRolesSelectColumn {
  /** column name */
  ConcurrencyStamp = 'concurrencyStamp',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NormalizedName = 'normalizedName'
}

/** input type for updating data in table "AspNetRoles" */
export type AspNetRolesSetInput = {
  concurrencyStamp?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalizedName?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "AspNetRoles" */
export type AspNetRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AspNetRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AspNetRolesStreamCursorValueInput = {
  concurrencyStamp?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalizedName?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "AspNetRoles" */
export enum AspNetRolesUpdateColumn {
  /** column name */
  ConcurrencyStamp = 'concurrencyStamp',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NormalizedName = 'normalizedName'
}

export type AspNetRolesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AspNetRolesSetInput>;
  /** filter the rows which have to be updated */
  where: AspNetRolesBoolExp;
};

/** columns and relationships of "AspNetUserClaims" */
export type AspNetUserClaims = {
  __typename?: 'AspNetUserClaims';
  claimType?: Maybe<Scalars['String']['output']>;
  claimValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

/** aggregated selection of "AspNetUserClaims" */
export type AspNetUserClaimsAggregate = {
  __typename?: 'AspNetUserClaimsAggregate';
  aggregate?: Maybe<AspNetUserClaimsAggregateFields>;
  nodes: Array<AspNetUserClaims>;
};

/** aggregate fields of "AspNetUserClaims" */
export type AspNetUserClaimsAggregateFields = {
  __typename?: 'AspNetUserClaimsAggregateFields';
  avg?: Maybe<AspNetUserClaimsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AspNetUserClaimsMaxFields>;
  min?: Maybe<AspNetUserClaimsMinFields>;
  stddev?: Maybe<AspNetUserClaimsStddevFields>;
  stddevPop?: Maybe<AspNetUserClaimsStddevPopFields>;
  stddevSamp?: Maybe<AspNetUserClaimsStddevSampFields>;
  sum?: Maybe<AspNetUserClaimsSumFields>;
  varPop?: Maybe<AspNetUserClaimsVarPopFields>;
  varSamp?: Maybe<AspNetUserClaimsVarSampFields>;
  variance?: Maybe<AspNetUserClaimsVarianceFields>;
};


/** aggregate fields of "AspNetUserClaims" */
export type AspNetUserClaimsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AspNetUserClaimsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AspNetUserClaimsAvgFields = {
  __typename?: 'AspNetUserClaimsAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "AspNetUserClaims". All fields are combined with a logical 'AND'. */
export type AspNetUserClaimsBoolExp = {
  _and?: InputMaybe<Array<AspNetUserClaimsBoolExp>>;
  _not?: InputMaybe<AspNetUserClaimsBoolExp>;
  _or?: InputMaybe<Array<AspNetUserClaimsBoolExp>>;
  claimType?: InputMaybe<StringComparisonExp>;
  claimValue?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  userId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "AspNetUserClaims" */
export enum AspNetUserClaimsConstraint {
  /** unique or primary key constraint on columns "Id" */
  PkAspNetUserClaims = 'PK_AspNetUserClaims'
}

/** input type for incrementing numeric columns in table "AspNetUserClaims" */
export type AspNetUserClaimsIncInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "AspNetUserClaims" */
export type AspNetUserClaimsInsertInput = {
  claimType?: InputMaybe<Scalars['String']['input']>;
  claimValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AspNetUserClaimsMaxFields = {
  __typename?: 'AspNetUserClaimsMaxFields';
  claimType?: Maybe<Scalars['String']['output']>;
  claimValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AspNetUserClaimsMinFields = {
  __typename?: 'AspNetUserClaimsMinFields';
  claimType?: Maybe<Scalars['String']['output']>;
  claimValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AspNetUserClaims" */
export type AspNetUserClaimsMutationResponse = {
  __typename?: 'AspNetUserClaimsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AspNetUserClaims>;
};

/** on_conflict condition type for table "AspNetUserClaims" */
export type AspNetUserClaimsOnConflict = {
  constraint: AspNetUserClaimsConstraint;
  updateColumns?: Array<AspNetUserClaimsUpdateColumn>;
  where?: InputMaybe<AspNetUserClaimsBoolExp>;
};

/** Ordering options when selecting data from "AspNetUserClaims". */
export type AspNetUserClaimsOrderBy = {
  claimType?: InputMaybe<OrderBy>;
  claimValue?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: AspNetUserClaims */
export type AspNetUserClaimsPkColumnsInput = {
  id: Scalars['Int']['input'];
};

/** select columns of table "AspNetUserClaims" */
export enum AspNetUserClaimsSelectColumn {
  /** column name */
  ClaimType = 'claimType',
  /** column name */
  ClaimValue = 'claimValue',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "AspNetUserClaims" */
export type AspNetUserClaimsSetInput = {
  claimType?: InputMaybe<Scalars['String']['input']>;
  claimValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type AspNetUserClaimsStddevFields = {
  __typename?: 'AspNetUserClaimsStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type AspNetUserClaimsStddevPopFields = {
  __typename?: 'AspNetUserClaimsStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type AspNetUserClaimsStddevSampFields = {
  __typename?: 'AspNetUserClaimsStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "AspNetUserClaims" */
export type AspNetUserClaimsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AspNetUserClaimsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AspNetUserClaimsStreamCursorValueInput = {
  claimType?: InputMaybe<Scalars['String']['input']>;
  claimValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type AspNetUserClaimsSumFields = {
  __typename?: 'AspNetUserClaimsSumFields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "AspNetUserClaims" */
export enum AspNetUserClaimsUpdateColumn {
  /** column name */
  ClaimType = 'claimType',
  /** column name */
  ClaimValue = 'claimValue',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'userId'
}

export type AspNetUserClaimsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AspNetUserClaimsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AspNetUserClaimsSetInput>;
  /** filter the rows which have to be updated */
  where: AspNetUserClaimsBoolExp;
};

/** aggregate varPop on columns */
export type AspNetUserClaimsVarPopFields = {
  __typename?: 'AspNetUserClaimsVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type AspNetUserClaimsVarSampFields = {
  __typename?: 'AspNetUserClaimsVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AspNetUserClaimsVarianceFields = {
  __typename?: 'AspNetUserClaimsVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "AspNetUserLogins" */
export type AspNetUserLogins = {
  __typename?: 'AspNetUserLogins';
  loginProvider: Scalars['String']['output'];
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerKey: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** aggregated selection of "AspNetUserLogins" */
export type AspNetUserLoginsAggregate = {
  __typename?: 'AspNetUserLoginsAggregate';
  aggregate?: Maybe<AspNetUserLoginsAggregateFields>;
  nodes: Array<AspNetUserLogins>;
};

/** aggregate fields of "AspNetUserLogins" */
export type AspNetUserLoginsAggregateFields = {
  __typename?: 'AspNetUserLoginsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<AspNetUserLoginsMaxFields>;
  min?: Maybe<AspNetUserLoginsMinFields>;
};


/** aggregate fields of "AspNetUserLogins" */
export type AspNetUserLoginsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AspNetUserLoginsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AspNetUserLogins". All fields are combined with a logical 'AND'. */
export type AspNetUserLoginsBoolExp = {
  _and?: InputMaybe<Array<AspNetUserLoginsBoolExp>>;
  _not?: InputMaybe<AspNetUserLoginsBoolExp>;
  _or?: InputMaybe<Array<AspNetUserLoginsBoolExp>>;
  loginProvider?: InputMaybe<StringComparisonExp>;
  providerDisplayName?: InputMaybe<StringComparisonExp>;
  providerKey?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "AspNetUserLogins" */
export enum AspNetUserLoginsConstraint {
  /** unique or primary key constraint on columns "ProviderKey", "LoginProvider" */
  PkAspNetUserLogins = 'PK_AspNetUserLogins'
}

/** input type for inserting data into table "AspNetUserLogins" */
export type AspNetUserLoginsInsertInput = {
  loginProvider?: InputMaybe<Scalars['String']['input']>;
  providerDisplayName?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AspNetUserLoginsMaxFields = {
  __typename?: 'AspNetUserLoginsMaxFields';
  loginProvider?: Maybe<Scalars['String']['output']>;
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerKey?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AspNetUserLoginsMinFields = {
  __typename?: 'AspNetUserLoginsMinFields';
  loginProvider?: Maybe<Scalars['String']['output']>;
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerKey?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AspNetUserLogins" */
export type AspNetUserLoginsMutationResponse = {
  __typename?: 'AspNetUserLoginsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AspNetUserLogins>;
};

/** on_conflict condition type for table "AspNetUserLogins" */
export type AspNetUserLoginsOnConflict = {
  constraint: AspNetUserLoginsConstraint;
  updateColumns?: Array<AspNetUserLoginsUpdateColumn>;
  where?: InputMaybe<AspNetUserLoginsBoolExp>;
};

/** Ordering options when selecting data from "AspNetUserLogins". */
export type AspNetUserLoginsOrderBy = {
  loginProvider?: InputMaybe<OrderBy>;
  providerDisplayName?: InputMaybe<OrderBy>;
  providerKey?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: AspNetUserLogins */
export type AspNetUserLoginsPkColumnsInput = {
  loginProvider: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
};

/** select columns of table "AspNetUserLogins" */
export enum AspNetUserLoginsSelectColumn {
  /** column name */
  LoginProvider = 'loginProvider',
  /** column name */
  ProviderDisplayName = 'providerDisplayName',
  /** column name */
  ProviderKey = 'providerKey',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "AspNetUserLogins" */
export type AspNetUserLoginsSetInput = {
  loginProvider?: InputMaybe<Scalars['String']['input']>;
  providerDisplayName?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "AspNetUserLogins" */
export type AspNetUserLoginsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AspNetUserLoginsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AspNetUserLoginsStreamCursorValueInput = {
  loginProvider?: InputMaybe<Scalars['String']['input']>;
  providerDisplayName?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "AspNetUserLogins" */
export enum AspNetUserLoginsUpdateColumn {
  /** column name */
  LoginProvider = 'loginProvider',
  /** column name */
  ProviderDisplayName = 'providerDisplayName',
  /** column name */
  ProviderKey = 'providerKey',
  /** column name */
  UserId = 'userId'
}

export type AspNetUserLoginsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AspNetUserLoginsSetInput>;
  /** filter the rows which have to be updated */
  where: AspNetUserLoginsBoolExp;
};

/** columns and relationships of "AspNetUserRoles" */
export type AspNetUserRoles = {
  __typename?: 'AspNetUserRoles';
  /** An object relationship */
  aspNetRole: AspNetRoles;
  roleId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** aggregated selection of "AspNetUserRoles" */
export type AspNetUserRolesAggregate = {
  __typename?: 'AspNetUserRolesAggregate';
  aggregate?: Maybe<AspNetUserRolesAggregateFields>;
  nodes: Array<AspNetUserRoles>;
};

export type AspNetUserRolesAggregateBoolExp = {
  count?: InputMaybe<AspNetUserRolesAggregateBoolExpCount>;
};

/** aggregate fields of "AspNetUserRoles" */
export type AspNetUserRolesAggregateFields = {
  __typename?: 'AspNetUserRolesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<AspNetUserRolesMaxFields>;
  min?: Maybe<AspNetUserRolesMinFields>;
};


/** aggregate fields of "AspNetUserRoles" */
export type AspNetUserRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AspNetUserRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "AspNetUserRoles" */
export type AspNetUserRolesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AspNetUserRolesMaxOrderBy>;
  min?: InputMaybe<AspNetUserRolesMinOrderBy>;
};

/** input type for inserting array relation for remote table "AspNetUserRoles" */
export type AspNetUserRolesArrRelInsertInput = {
  data: Array<AspNetUserRolesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AspNetUserRolesOnConflict>;
};

/** Boolean expression to filter rows from the table "AspNetUserRoles". All fields are combined with a logical 'AND'. */
export type AspNetUserRolesBoolExp = {
  _and?: InputMaybe<Array<AspNetUserRolesBoolExp>>;
  _not?: InputMaybe<AspNetUserRolesBoolExp>;
  _or?: InputMaybe<Array<AspNetUserRolesBoolExp>>;
  aspNetRole?: InputMaybe<AspNetRolesBoolExp>;
  roleId?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "AspNetUserRoles" */
export enum AspNetUserRolesConstraint {
  /** unique or primary key constraint on columns "RoleId", "UserId" */
  PkAspNetUserRoles = 'PK_AspNetUserRoles'
}

/** input type for inserting data into table "AspNetUserRoles" */
export type AspNetUserRolesInsertInput = {
  aspNetRole?: InputMaybe<AspNetRolesObjRelInsertInput>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AspNetUserRolesMaxFields = {
  __typename?: 'AspNetUserRolesMaxFields';
  roleId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "AspNetUserRoles" */
export type AspNetUserRolesMaxOrderBy = {
  roleId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AspNetUserRolesMinFields = {
  __typename?: 'AspNetUserRolesMinFields';
  roleId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "AspNetUserRoles" */
export type AspNetUserRolesMinOrderBy = {
  roleId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "AspNetUserRoles" */
export type AspNetUserRolesMutationResponse = {
  __typename?: 'AspNetUserRolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AspNetUserRoles>;
};

/** on_conflict condition type for table "AspNetUserRoles" */
export type AspNetUserRolesOnConflict = {
  constraint: AspNetUserRolesConstraint;
  updateColumns?: Array<AspNetUserRolesUpdateColumn>;
  where?: InputMaybe<AspNetUserRolesBoolExp>;
};

/** Ordering options when selecting data from "AspNetUserRoles". */
export type AspNetUserRolesOrderBy = {
  aspNetRole?: InputMaybe<AspNetRolesOrderBy>;
  roleId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: AspNetUserRoles */
export type AspNetUserRolesPkColumnsInput = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** select columns of table "AspNetUserRoles" */
export enum AspNetUserRolesSelectColumn {
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "AspNetUserRoles" */
export type AspNetUserRolesSetInput = {
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "AspNetUserRoles" */
export type AspNetUserRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AspNetUserRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AspNetUserRolesStreamCursorValueInput = {
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "AspNetUserRoles" */
export enum AspNetUserRolesUpdateColumn {
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UserId = 'userId'
}

export type AspNetUserRolesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AspNetUserRolesSetInput>;
  /** filter the rows which have to be updated */
  where: AspNetUserRolesBoolExp;
};

/** columns and relationships of "AspNetUserTokens" */
export type AspNetUserTokens = {
  __typename?: 'AspNetUserTokens';
  loginProvider: Scalars['String']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "AspNetUserTokens" */
export type AspNetUserTokensAggregate = {
  __typename?: 'AspNetUserTokensAggregate';
  aggregate?: Maybe<AspNetUserTokensAggregateFields>;
  nodes: Array<AspNetUserTokens>;
};

/** aggregate fields of "AspNetUserTokens" */
export type AspNetUserTokensAggregateFields = {
  __typename?: 'AspNetUserTokensAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<AspNetUserTokensMaxFields>;
  min?: Maybe<AspNetUserTokensMinFields>;
};


/** aggregate fields of "AspNetUserTokens" */
export type AspNetUserTokensAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AspNetUserTokensSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AspNetUserTokens". All fields are combined with a logical 'AND'. */
export type AspNetUserTokensBoolExp = {
  _and?: InputMaybe<Array<AspNetUserTokensBoolExp>>;
  _not?: InputMaybe<AspNetUserTokensBoolExp>;
  _or?: InputMaybe<Array<AspNetUserTokensBoolExp>>;
  loginProvider?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "AspNetUserTokens" */
export enum AspNetUserTokensConstraint {
  /** unique or primary key constraint on columns "LoginProvider", "Name", "UserId" */
  PkAspNetUserTokens = 'PK_AspNetUserTokens'
}

/** input type for inserting data into table "AspNetUserTokens" */
export type AspNetUserTokensInsertInput = {
  loginProvider?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AspNetUserTokensMaxFields = {
  __typename?: 'AspNetUserTokensMaxFields';
  loginProvider?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AspNetUserTokensMinFields = {
  __typename?: 'AspNetUserTokensMinFields';
  loginProvider?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AspNetUserTokens" */
export type AspNetUserTokensMutationResponse = {
  __typename?: 'AspNetUserTokensMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AspNetUserTokens>;
};

/** on_conflict condition type for table "AspNetUserTokens" */
export type AspNetUserTokensOnConflict = {
  constraint: AspNetUserTokensConstraint;
  updateColumns?: Array<AspNetUserTokensUpdateColumn>;
  where?: InputMaybe<AspNetUserTokensBoolExp>;
};

/** Ordering options when selecting data from "AspNetUserTokens". */
export type AspNetUserTokensOrderBy = {
  loginProvider?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: AspNetUserTokens */
export type AspNetUserTokensPkColumnsInput = {
  loginProvider: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** select columns of table "AspNetUserTokens" */
export enum AspNetUserTokensSelectColumn {
  /** column name */
  LoginProvider = 'loginProvider',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "AspNetUserTokens" */
export type AspNetUserTokensSetInput = {
  loginProvider?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "AspNetUserTokens" */
export type AspNetUserTokensStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AspNetUserTokensStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AspNetUserTokensStreamCursorValueInput = {
  loginProvider?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "AspNetUserTokens" */
export enum AspNetUserTokensUpdateColumn {
  /** column name */
  LoginProvider = 'loginProvider',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
}

export type AspNetUserTokensUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AspNetUserTokensSetInput>;
  /** filter the rows which have to be updated */
  where: AspNetUserTokensBoolExp;
};

/** columns and relationships of "AspNetUsers" */
export type AspNetUsers = {
  __typename?: 'AspNetUsers';
  accessFailedCount: Scalars['Int']['output'];
  /** An array relationship */
  aspNetUserRoles: Array<AspNetUserRoles>;
  /** An aggregate relationship */
  aspNetUserRolesAggregate: AspNetUserRolesAggregate;
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lockoutEnabled: Scalars['Boolean']['output'];
  lockoutEnd?: Maybe<Scalars['timestamptz']['output']>;
  normalizedEmail?: Maybe<Scalars['String']['output']>;
  normalizedUserName?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberConfirmed: Scalars['Boolean']['output'];
  securityStamp?: Maybe<Scalars['String']['output']>;
  sub: Scalars['String']['output'];
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** An array relationship */
  userDeviceLinks: Array<UserDeviceLink>;
  /** An aggregate relationship */
  userDeviceLinksAggregate: UserDeviceLinkAggregate;
  userName?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "AspNetUsers" */
export type AspNetUsersAspNetUserRolesArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserRolesOrderBy>>;
  where?: InputMaybe<AspNetUserRolesBoolExp>;
};


/** columns and relationships of "AspNetUsers" */
export type AspNetUsersAspNetUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserRolesOrderBy>>;
  where?: InputMaybe<AspNetUserRolesBoolExp>;
};


/** columns and relationships of "AspNetUsers" */
export type AspNetUsersUserDeviceLinksArgs = {
  distinctOn?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserDeviceLinkOrderBy>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};


/** columns and relationships of "AspNetUsers" */
export type AspNetUsersUserDeviceLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserDeviceLinkOrderBy>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};

/** aggregated selection of "AspNetUsers" */
export type AspNetUsersAggregate = {
  __typename?: 'AspNetUsersAggregate';
  aggregate?: Maybe<AspNetUsersAggregateFields>;
  nodes: Array<AspNetUsers>;
};

/** aggregate fields of "AspNetUsers" */
export type AspNetUsersAggregateFields = {
  __typename?: 'AspNetUsersAggregateFields';
  avg?: Maybe<AspNetUsersAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AspNetUsersMaxFields>;
  min?: Maybe<AspNetUsersMinFields>;
  stddev?: Maybe<AspNetUsersStddevFields>;
  stddevPop?: Maybe<AspNetUsersStddevPopFields>;
  stddevSamp?: Maybe<AspNetUsersStddevSampFields>;
  sum?: Maybe<AspNetUsersSumFields>;
  varPop?: Maybe<AspNetUsersVarPopFields>;
  varSamp?: Maybe<AspNetUsersVarSampFields>;
  variance?: Maybe<AspNetUsersVarianceFields>;
};


/** aggregate fields of "AspNetUsers" */
export type AspNetUsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AspNetUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AspNetUsersAvgFields = {
  __typename?: 'AspNetUsersAvgFields';
  accessFailedCount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "AspNetUsers". All fields are combined with a logical 'AND'. */
export type AspNetUsersBoolExp = {
  _and?: InputMaybe<Array<AspNetUsersBoolExp>>;
  _not?: InputMaybe<AspNetUsersBoolExp>;
  _or?: InputMaybe<Array<AspNetUsersBoolExp>>;
  accessFailedCount?: InputMaybe<IntComparisonExp>;
  aspNetUserRoles?: InputMaybe<AspNetUserRolesBoolExp>;
  aspNetUserRolesAggregate?: InputMaybe<AspNetUserRolesAggregateBoolExp>;
  concurrencyStamp?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  emailConfirmed?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  lockoutEnabled?: InputMaybe<BooleanComparisonExp>;
  lockoutEnd?: InputMaybe<TimestamptzComparisonExp>;
  normalizedEmail?: InputMaybe<StringComparisonExp>;
  normalizedUserName?: InputMaybe<StringComparisonExp>;
  passwordHash?: InputMaybe<StringComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneNumberConfirmed?: InputMaybe<BooleanComparisonExp>;
  securityStamp?: InputMaybe<StringComparisonExp>;
  sub?: InputMaybe<StringComparisonExp>;
  syncedAt?: InputMaybe<TimestamptzComparisonExp>;
  twoFactorEnabled?: InputMaybe<BooleanComparisonExp>;
  userDeviceLinks?: InputMaybe<UserDeviceLinkBoolExp>;
  userDeviceLinksAggregate?: InputMaybe<UserDeviceLinkAggregateBoolExp>;
  userName?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "AspNetUsers" */
export enum AspNetUsersConstraint {
  /** unique or primary key constraint on columns "Sub" */
  AkAspNetUsersSub = 'AK_AspNetUsers_Sub',
  /** unique or primary key constraint on columns "Sub" */
  IxAspNetUsersSub = 'IX_AspNetUsers_Sub',
  /** unique or primary key constraint on columns "Id" */
  PkAspNetUsers = 'PK_AspNetUsers',
  /** unique or primary key constraint on columns "NormalizedUserName" */
  UserNameIndex = 'UserNameIndex'
}

/** input type for incrementing numeric columns in table "AspNetUsers" */
export type AspNetUsersIncInput = {
  accessFailedCount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "AspNetUsers" */
export type AspNetUsersInsertInput = {
  accessFailedCount?: InputMaybe<Scalars['Int']['input']>;
  aspNetUserRoles?: InputMaybe<AspNetUserRolesArrRelInsertInput>;
  concurrencyStamp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lockoutEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lockoutEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  normalizedEmail?: InputMaybe<Scalars['String']['input']>;
  normalizedUserName?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  securityStamp?: InputMaybe<Scalars['String']['input']>;
  sub?: InputMaybe<Scalars['String']['input']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  userDeviceLinks?: InputMaybe<UserDeviceLinkArrRelInsertInput>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AspNetUsersMaxFields = {
  __typename?: 'AspNetUsersMaxFields';
  accessFailedCount?: Maybe<Scalars['Int']['output']>;
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lockoutEnd?: Maybe<Scalars['timestamptz']['output']>;
  normalizedEmail?: Maybe<Scalars['String']['output']>;
  normalizedUserName?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  securityStamp?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AspNetUsersMinFields = {
  __typename?: 'AspNetUsersMinFields';
  accessFailedCount?: Maybe<Scalars['Int']['output']>;
  concurrencyStamp?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lockoutEnd?: Maybe<Scalars['timestamptz']['output']>;
  normalizedEmail?: Maybe<Scalars['String']['output']>;
  normalizedUserName?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  securityStamp?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AspNetUsers" */
export type AspNetUsersMutationResponse = {
  __typename?: 'AspNetUsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AspNetUsers>;
};

/** input type for inserting object relation for remote table "AspNetUsers" */
export type AspNetUsersObjRelInsertInput = {
  data: AspNetUsersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AspNetUsersOnConflict>;
};

/** on_conflict condition type for table "AspNetUsers" */
export type AspNetUsersOnConflict = {
  constraint: AspNetUsersConstraint;
  updateColumns?: Array<AspNetUsersUpdateColumn>;
  where?: InputMaybe<AspNetUsersBoolExp>;
};

/** Ordering options when selecting data from "AspNetUsers". */
export type AspNetUsersOrderBy = {
  accessFailedCount?: InputMaybe<OrderBy>;
  aspNetUserRolesAggregate?: InputMaybe<AspNetUserRolesAggregateOrderBy>;
  concurrencyStamp?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  emailConfirmed?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lockoutEnabled?: InputMaybe<OrderBy>;
  lockoutEnd?: InputMaybe<OrderBy>;
  normalizedEmail?: InputMaybe<OrderBy>;
  normalizedUserName?: InputMaybe<OrderBy>;
  passwordHash?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberConfirmed?: InputMaybe<OrderBy>;
  securityStamp?: InputMaybe<OrderBy>;
  sub?: InputMaybe<OrderBy>;
  syncedAt?: InputMaybe<OrderBy>;
  twoFactorEnabled?: InputMaybe<OrderBy>;
  userDeviceLinksAggregate?: InputMaybe<UserDeviceLinkAggregateOrderBy>;
  userName?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: AspNetUsers */
export type AspNetUsersPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "AspNetUsers" */
export enum AspNetUsersSelectColumn {
  /** column name */
  AccessFailedCount = 'accessFailedCount',
  /** column name */
  ConcurrencyStamp = 'concurrencyStamp',
  /** column name */
  Email = 'email',
  /** column name */
  EmailConfirmed = 'emailConfirmed',
  /** column name */
  Id = 'id',
  /** column name */
  LockoutEnabled = 'lockoutEnabled',
  /** column name */
  LockoutEnd = 'lockoutEnd',
  /** column name */
  NormalizedEmail = 'normalizedEmail',
  /** column name */
  NormalizedUserName = 'normalizedUserName',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberConfirmed = 'phoneNumberConfirmed',
  /** column name */
  SecurityStamp = 'securityStamp',
  /** column name */
  Sub = 'sub',
  /** column name */
  SyncedAt = 'syncedAt',
  /** column name */
  TwoFactorEnabled = 'twoFactorEnabled',
  /** column name */
  UserName = 'userName'
}

/** input type for updating data in table "AspNetUsers" */
export type AspNetUsersSetInput = {
  accessFailedCount?: InputMaybe<Scalars['Int']['input']>;
  concurrencyStamp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lockoutEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lockoutEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  normalizedEmail?: InputMaybe<Scalars['String']['input']>;
  normalizedUserName?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  securityStamp?: InputMaybe<Scalars['String']['input']>;
  sub?: InputMaybe<Scalars['String']['input']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type AspNetUsersStddevFields = {
  __typename?: 'AspNetUsersStddevFields';
  accessFailedCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type AspNetUsersStddevPopFields = {
  __typename?: 'AspNetUsersStddevPopFields';
  accessFailedCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type AspNetUsersStddevSampFields = {
  __typename?: 'AspNetUsersStddevSampFields';
  accessFailedCount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "AspNetUsers" */
export type AspNetUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AspNetUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AspNetUsersStreamCursorValueInput = {
  accessFailedCount?: InputMaybe<Scalars['Int']['input']>;
  concurrencyStamp?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lockoutEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lockoutEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  normalizedEmail?: InputMaybe<Scalars['String']['input']>;
  normalizedUserName?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  securityStamp?: InputMaybe<Scalars['String']['input']>;
  sub?: InputMaybe<Scalars['String']['input']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type AspNetUsersSumFields = {
  __typename?: 'AspNetUsersSumFields';
  accessFailedCount?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "AspNetUsers" */
export enum AspNetUsersUpdateColumn {
  /** column name */
  AccessFailedCount = 'accessFailedCount',
  /** column name */
  ConcurrencyStamp = 'concurrencyStamp',
  /** column name */
  Email = 'email',
  /** column name */
  EmailConfirmed = 'emailConfirmed',
  /** column name */
  Id = 'id',
  /** column name */
  LockoutEnabled = 'lockoutEnabled',
  /** column name */
  LockoutEnd = 'lockoutEnd',
  /** column name */
  NormalizedEmail = 'normalizedEmail',
  /** column name */
  NormalizedUserName = 'normalizedUserName',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberConfirmed = 'phoneNumberConfirmed',
  /** column name */
  SecurityStamp = 'securityStamp',
  /** column name */
  Sub = 'sub',
  /** column name */
  SyncedAt = 'syncedAt',
  /** column name */
  TwoFactorEnabled = 'twoFactorEnabled',
  /** column name */
  UserName = 'userName'
}

export type AspNetUsersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AspNetUsersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AspNetUsersSetInput>;
  /** filter the rows which have to be updated */
  where: AspNetUsersBoolExp;
};

/** aggregate varPop on columns */
export type AspNetUsersVarPopFields = {
  __typename?: 'AspNetUsersVarPopFields';
  accessFailedCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type AspNetUsersVarSampFields = {
  __typename?: 'AspNetUsersVarSampFields';
  accessFailedCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AspNetUsersVarianceFields = {
  __typename?: 'AspNetUsersVarianceFields';
  accessFailedCount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "AuditLog" */
export type AuditLog = {
  __typename?: 'AuditLog';
  action: Scalars['String']['output'];
  actorId?: Maybe<Scalars['String']['output']>;
  actorType: Scalars['String']['output'];
  /** An object relationship */
  aspNetUser?: Maybe<AspNetUsers>;
  createdAt: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  entities?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
};


/** columns and relationships of "AuditLog" */
export type AuditLogDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "AuditLog" */
export type AuditLogEntitiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "AuditLog" */
export type AuditLogAggregate = {
  __typename?: 'AuditLogAggregate';
  aggregate?: Maybe<AuditLogAggregateFields>;
  nodes: Array<AuditLog>;
};

/** aggregate fields of "AuditLog" */
export type AuditLogAggregateFields = {
  __typename?: 'AuditLogAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuditLogMaxFields>;
  min?: Maybe<AuditLogMinFields>;
};


/** aggregate fields of "AuditLog" */
export type AuditLogAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AuditLogSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuditLogAppendInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  entities?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "AuditLog". All fields are combined with a logical 'AND'. */
export type AuditLogBoolExp = {
  _and?: InputMaybe<Array<AuditLogBoolExp>>;
  _not?: InputMaybe<AuditLogBoolExp>;
  _or?: InputMaybe<Array<AuditLogBoolExp>>;
  action?: InputMaybe<StringComparisonExp>;
  actorId?: InputMaybe<StringComparisonExp>;
  actorType?: InputMaybe<StringComparisonExp>;
  aspNetUser?: InputMaybe<AspNetUsersBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  data?: InputMaybe<JsonbComparisonExp>;
  entities?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "AuditLog" */
export enum AuditLogConstraint {
  /** unique or primary key constraint on columns "Id" */
  PkAuditLog = 'PK_AuditLog'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuditLogDeleteAtPathInput = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  entities?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuditLogDeleteElemInput = {
  data?: InputMaybe<Scalars['Int']['input']>;
  entities?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuditLogDeleteKeyInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  entities?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "AuditLog" */
export type AuditLogInsertInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  actorId?: InputMaybe<Scalars['String']['input']>;
  actorType?: InputMaybe<Scalars['String']['input']>;
  aspNetUser?: InputMaybe<AspNetUsersObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  entities?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuditLogMaxFields = {
  __typename?: 'AuditLogMaxFields';
  action?: Maybe<Scalars['String']['output']>;
  actorId?: Maybe<Scalars['String']['output']>;
  actorType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AuditLogMinFields = {
  __typename?: 'AuditLogMinFields';
  action?: Maybe<Scalars['String']['output']>;
  actorId?: Maybe<Scalars['String']['output']>;
  actorType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "AuditLog" */
export type AuditLogMutationResponse = {
  __typename?: 'AuditLogMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuditLog>;
};

/** on_conflict condition type for table "AuditLog" */
export type AuditLogOnConflict = {
  constraint: AuditLogConstraint;
  updateColumns?: Array<AuditLogUpdateColumn>;
  where?: InputMaybe<AuditLogBoolExp>;
};

/** Ordering options when selecting data from "AuditLog". */
export type AuditLogOrderBy = {
  action?: InputMaybe<OrderBy>;
  actorId?: InputMaybe<OrderBy>;
  actorType?: InputMaybe<OrderBy>;
  aspNetUser?: InputMaybe<AspNetUsersOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  data?: InputMaybe<OrderBy>;
  entities?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: AuditLog */
export type AuditLogPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuditLogPrependInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  entities?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "AuditLog" */
export enum AuditLogSelectColumn {
  /** column name */
  Action = 'action',
  /** column name */
  ActorId = 'actorId',
  /** column name */
  ActorType = 'actorType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Entities = 'entities',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "AuditLog" */
export type AuditLogSetInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  actorId?: InputMaybe<Scalars['String']['input']>;
  actorType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  entities?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "AuditLog" */
export type AuditLogStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AuditLogStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AuditLogStreamCursorValueInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  actorId?: InputMaybe<Scalars['String']['input']>;
  actorType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  entities?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "AuditLog" */
export enum AuditLogUpdateColumn {
  /** column name */
  Action = 'action',
  /** column name */
  ActorId = 'actorId',
  /** column name */
  ActorType = 'actorType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Entities = 'entities',
  /** column name */
  Id = 'id'
}

export type AuditLogUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuditLogAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<AuditLogDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<AuditLogDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<AuditLogDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuditLogPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuditLogSetInput>;
  /** filter the rows which have to be updated */
  where: AuditLogBoolExp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CreateCustomerApiKeyInput = {
  customerId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerApiKeysInput = {
  createCustomerApiKeys: Array<CreateCustomerApiKeyInput>;
};

export type CreateCustomerApiKeysPayload = {
  __typename?: 'CreateCustomerApiKeysPayload';
  apiKeys: Array<CreateCustomerApiKeysPayloadItem>;
};

export type CreateCustomerApiKeysPayloadItem = {
  __typename?: 'CreateCustomerApiKeysPayloadItem';
  customerId: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerS3BucketInput = {
  customerId: Scalars['UUID']['input'];
  expiries?: InputMaybe<Array<ExpiryInput>>;
};

export type CreateDeviceApiKeyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['UUID']['input'];
};

export type CreateDeviceApiKeysInput = {
  createDeviceApiKeys: Array<CreateDeviceApiKeyInput>;
};

export type CreateDeviceApiKeysPayload = {
  __typename?: 'CreateDeviceApiKeysPayload';
  apiKeys: Array<CreateDeviceApiKeysPayloadItem>;
};

export type CreateDeviceApiKeysPayloadItem = {
  __typename?: 'CreateDeviceApiKeysPayloadItem';
  description?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "Customer" */
export type Customer = {
  __typename?: 'Customer';
  /** An array relationship */
  apiKeys: Array<ApiKey>;
  /** An aggregate relationship */
  apiKeysAggregate: ApiKeyAggregate;
  config: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  imagePath: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rowVersion: Scalars['uuid']['output'];
  /** An array relationship */
  sites: Array<Site>;
  /** An aggregate relationship */
  sitesAggregate: SiteAggregate;
  storagePath: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Customer" */
export type CustomerApiKeysArgs = {
  distinctOn?: InputMaybe<Array<ApiKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderBy>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


/** columns and relationships of "Customer" */
export type CustomerApiKeysAggregateArgs = {
  distinctOn?: InputMaybe<Array<ApiKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderBy>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


/** columns and relationships of "Customer" */
export type CustomerConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Customer" */
export type CustomerSitesArgs = {
  distinctOn?: InputMaybe<Array<SiteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SiteOrderBy>>;
  where?: InputMaybe<SiteBoolExp>;
};


/** columns and relationships of "Customer" */
export type CustomerSitesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SiteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SiteOrderBy>>;
  where?: InputMaybe<SiteBoolExp>;
};

/** aggregated selection of "Customer" */
export type CustomerAggregate = {
  __typename?: 'CustomerAggregate';
  aggregate?: Maybe<CustomerAggregateFields>;
  nodes: Array<Customer>;
};

/** aggregate fields of "Customer" */
export type CustomerAggregateFields = {
  __typename?: 'CustomerAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CustomerMaxFields>;
  min?: Maybe<CustomerMinFields>;
};


/** aggregate fields of "Customer" */
export type CustomerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CustomerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CustomerAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "Customer". All fields are combined with a logical 'AND'. */
export type CustomerBoolExp = {
  _and?: InputMaybe<Array<CustomerBoolExp>>;
  _not?: InputMaybe<CustomerBoolExp>;
  _or?: InputMaybe<Array<CustomerBoolExp>>;
  apiKeys?: InputMaybe<ApiKeyBoolExp>;
  apiKeysAggregate?: InputMaybe<ApiKeyAggregateBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  imagePath?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  rowVersion?: InputMaybe<UuidComparisonExp>;
  sites?: InputMaybe<SiteBoolExp>;
  sitesAggregate?: InputMaybe<SiteAggregateBoolExp>;
  storagePath?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "Customer" */
export enum CustomerConstraint {
  /** unique or primary key constraint on columns "Name" */
  IxCustomerName = 'IX_Customer_Name',
  /** unique or primary key constraint on columns "Id" */
  PkCustomer = 'PK_Customer'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CustomerDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CustomerDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CustomerDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Customer" */
export type CustomerInsertInput = {
  apiKeys?: InputMaybe<ApiKeyArrRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  sites?: InputMaybe<SiteArrRelInsertInput>;
  storagePath?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CustomerMaxFields = {
  __typename?: 'CustomerMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowVersion?: Maybe<Scalars['uuid']['output']>;
  storagePath?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type CustomerMinFields = {
  __typename?: 'CustomerMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowVersion?: Maybe<Scalars['uuid']['output']>;
  storagePath?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Customer" */
export type CustomerMutationResponse = {
  __typename?: 'CustomerMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer>;
};

/** input type for inserting object relation for remote table "Customer" */
export type CustomerObjRelInsertInput = {
  data: CustomerInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CustomerOnConflict>;
};

/** on_conflict condition type for table "Customer" */
export type CustomerOnConflict = {
  constraint: CustomerConstraint;
  updateColumns?: Array<CustomerUpdateColumn>;
  where?: InputMaybe<CustomerBoolExp>;
};

/** Ordering options when selecting data from "Customer". */
export type CustomerOrderBy = {
  apiKeysAggregate?: InputMaybe<ApiKeyAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagePath?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  sitesAggregate?: InputMaybe<SiteAggregateOrderBy>;
  storagePath?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: Customer */
export type CustomerPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CustomerPrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Customer" */
export enum CustomerSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  Name = 'name',
  /** column name */
  RowVersion = 'rowVersion',
  /** column name */
  StoragePath = 'storagePath',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "Customer" */
export type CustomerSetInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  storagePath?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Customer" */
export type CustomerStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CustomerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomerStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  storagePath?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Customer" */
export enum CustomerUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ImagePath = 'imagePath',
  /** column name */
  Name = 'name',
  /** column name */
  RowVersion = 'rowVersion',
  /** column name */
  StoragePath = 'storagePath',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CustomerUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CustomerAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<CustomerDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<CustomerDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<CustomerDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CustomerPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomerSetInput>;
  /** filter the rows which have to be updated */
  where: CustomerBoolExp;
};

export type DeleteCustomerSecretInput = {
  customerId: Scalars['UUID']['input'];
  pathTail: Scalars['String']['input'];
};

export type DeleteCustomerSecretPayload = {
  __typename?: 'DeleteCustomerSecretPayload';
  deletionDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

/** columns and relationships of "Device" */
export type Device = {
  __typename?: 'Device';
  /** An array relationship */
  apiKeys: Array<ApiKey>;
  /** An aggregate relationship */
  apiKeysAggregate: ApiKeyAggregate;
  config: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  /** An array relationship */
  deviceStatuses: Array<DeviceStatus>;
  /** An aggregate relationship */
  deviceStatusesAggregate: DeviceStatusAggregate;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lastImage?: Maybe<DeviceLastImage>;
  /** An object relationship */
  lastMedia?: Maybe<DeviceLastMedia>;
  /** An array relationship */
  media: Array<Media>;
  /** An aggregate relationship */
  mediaAggregate: MediaAggregate;
  name?: Maybe<Scalars['String']['output']>;
  products: Scalars['jsonb']['output'];
  /** An array relationship */
  rois: Array<Roi>;
  /** An aggregate relationship */
  roisAggregate: RoiAggregate;
  rowVersion: Scalars['uuid']['output'];
  serial: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
  /** An object relationship */
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userDeviceLinks: Array<UserDeviceLink>;
  /** An aggregate relationship */
  userDeviceLinksAggregate: UserDeviceLinkAggregate;
};


/** columns and relationships of "Device" */
export type DeviceApiKeysArgs = {
  distinctOn?: InputMaybe<Array<ApiKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderBy>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceApiKeysAggregateArgs = {
  distinctOn?: InputMaybe<Array<ApiKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderBy>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Device" */
export type DeviceDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Device" */
export type DeviceDeviceStatusesArgs = {
  distinctOn?: InputMaybe<Array<DeviceStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceStatusOrderBy>>;
  where?: InputMaybe<DeviceStatusBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceDeviceStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceStatusOrderBy>>;
  where?: InputMaybe<DeviceStatusBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceMediaArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceProductsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Device" */
export type DeviceRoisArgs = {
  distinctOn?: InputMaybe<Array<RoiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoiOrderBy>>;
  where?: InputMaybe<RoiBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceRoisAggregateArgs = {
  distinctOn?: InputMaybe<Array<RoiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoiOrderBy>>;
  where?: InputMaybe<RoiBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceUserDeviceLinksArgs = {
  distinctOn?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserDeviceLinkOrderBy>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};


/** columns and relationships of "Device" */
export type DeviceUserDeviceLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserDeviceLinkOrderBy>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};

/** aggregated selection of "Device" */
export type DeviceAggregate = {
  __typename?: 'DeviceAggregate';
  aggregate?: Maybe<DeviceAggregateFields>;
  nodes: Array<Device>;
};

export type DeviceAggregateBoolExp = {
  count?: InputMaybe<DeviceAggregateBoolExpCount>;
};

/** aggregate fields of "Device" */
export type DeviceAggregateFields = {
  __typename?: 'DeviceAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DeviceMaxFields>;
  min?: Maybe<DeviceMinFields>;
};


/** aggregate fields of "Device" */
export type DeviceAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DeviceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Device" */
export type DeviceAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DeviceMaxOrderBy>;
  min?: InputMaybe<DeviceMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DeviceAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  products?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Device" */
export type DeviceArrRelInsertInput = {
  data: Array<DeviceInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DeviceOnConflict>;
};

/** Boolean expression to filter rows from the table "Device". All fields are combined with a logical 'AND'. */
export type DeviceBoolExp = {
  _and?: InputMaybe<Array<DeviceBoolExp>>;
  _not?: InputMaybe<DeviceBoolExp>;
  _or?: InputMaybe<Array<DeviceBoolExp>>;
  apiKeys?: InputMaybe<ApiKeyBoolExp>;
  apiKeysAggregate?: InputMaybe<ApiKeyAggregateBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  data?: InputMaybe<JsonbComparisonExp>;
  deviceStatuses?: InputMaybe<DeviceStatusBoolExp>;
  deviceStatusesAggregate?: InputMaybe<DeviceStatusAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastImage?: InputMaybe<DeviceLastImageBoolExp>;
  lastMedia?: InputMaybe<DeviceLastMediaBoolExp>;
  media?: InputMaybe<MediaBoolExp>;
  mediaAggregate?: InputMaybe<MediaAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  products?: InputMaybe<JsonbComparisonExp>;
  rois?: InputMaybe<RoiBoolExp>;
  roisAggregate?: InputMaybe<RoiAggregateBoolExp>;
  rowVersion?: InputMaybe<UuidComparisonExp>;
  serial?: InputMaybe<StringComparisonExp>;
  shortId?: InputMaybe<StringComparisonExp>;
  site?: InputMaybe<SiteBoolExp>;
  siteId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userDeviceLinks?: InputMaybe<UserDeviceLinkBoolExp>;
  userDeviceLinksAggregate?: InputMaybe<UserDeviceLinkAggregateBoolExp>;
};

/** unique or primary key constraints on table "Device" */
export enum DeviceConstraint {
  /** unique or primary key constraint on columns "Name" */
  IxDeviceName = 'IX_Device_Name',
  /** unique or primary key constraint on columns "ShortId" */
  IxDeviceShortId = 'IX_Device_ShortId',
  /** unique or primary key constraint on columns "Id" */
  PkDevice = 'PK_Device'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DeviceDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DeviceDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DeviceDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Device" */
export type DeviceInsertInput = {
  apiKeys?: InputMaybe<ApiKeyArrRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deviceStatuses?: InputMaybe<DeviceStatusArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastImage?: InputMaybe<DeviceLastImageObjRelInsertInput>;
  lastMedia?: InputMaybe<DeviceLastMediaObjRelInsertInput>;
  media?: InputMaybe<MediaArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Scalars['jsonb']['input']>;
  rois?: InputMaybe<RoiArrRelInsertInput>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<SiteObjRelInsertInput>;
  siteId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userDeviceLinks?: InputMaybe<UserDeviceLinkArrRelInsertInput>;
};

/** columns and relationships of "DeviceLastImage" */
export type DeviceLastImage = {
  __typename?: 'DeviceLastImage';
  /** An object relationship */
  device?: Maybe<Device>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaTime?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  media?: Maybe<Media>;
};

/** aggregated selection of "DeviceLastImage" */
export type DeviceLastImageAggregate = {
  __typename?: 'DeviceLastImageAggregate';
  aggregate?: Maybe<DeviceLastImageAggregateFields>;
  nodes: Array<DeviceLastImage>;
};

/** aggregate fields of "DeviceLastImage" */
export type DeviceLastImageAggregateFields = {
  __typename?: 'DeviceLastImageAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DeviceLastImageMaxFields>;
  min?: Maybe<DeviceLastImageMinFields>;
};


/** aggregate fields of "DeviceLastImage" */
export type DeviceLastImageAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DeviceLastImageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "DeviceLastImage". All fields are combined with a logical 'AND'. */
export type DeviceLastImageBoolExp = {
  _and?: InputMaybe<Array<DeviceLastImageBoolExp>>;
  _not?: InputMaybe<DeviceLastImageBoolExp>;
  _or?: InputMaybe<Array<DeviceLastImageBoolExp>>;
  device?: InputMaybe<DeviceBoolExp>;
  deviceId?: InputMaybe<UuidComparisonExp>;
  lastOriginalMediaId?: InputMaybe<UuidComparisonExp>;
  lastOriginalMediaTime?: InputMaybe<TimestamptzComparisonExp>;
  media?: InputMaybe<MediaBoolExp>;
};

/** input type for inserting data into table "DeviceLastImage" */
export type DeviceLastImageInsertInput = {
  device?: InputMaybe<DeviceObjRelInsertInput>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  lastOriginalMediaId?: InputMaybe<Scalars['uuid']['input']>;
  lastOriginalMediaTime?: InputMaybe<Scalars['timestamptz']['input']>;
  media?: InputMaybe<MediaObjRelInsertInput>;
};

/** aggregate max on columns */
export type DeviceLastImageMaxFields = {
  __typename?: 'DeviceLastImageMaxFields';
  deviceId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaTime?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DeviceLastImageMinFields = {
  __typename?: 'DeviceLastImageMinFields';
  deviceId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaTime?: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "DeviceLastImage" */
export type DeviceLastImageObjRelInsertInput = {
  data: DeviceLastImageInsertInput;
};

/** Ordering options when selecting data from "DeviceLastImage". */
export type DeviceLastImageOrderBy = {
  device?: InputMaybe<DeviceOrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  lastOriginalMediaId?: InputMaybe<OrderBy>;
  lastOriginalMediaTime?: InputMaybe<OrderBy>;
  media?: InputMaybe<MediaOrderBy>;
};

/** select columns of table "DeviceLastImage" */
export enum DeviceLastImageSelectColumn {
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  LastOriginalMediaId = 'lastOriginalMediaId',
  /** column name */
  LastOriginalMediaTime = 'lastOriginalMediaTime'
}

/** Streaming cursor of the table "DeviceLastImage" */
export type DeviceLastImageStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DeviceLastImageStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeviceLastImageStreamCursorValueInput = {
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  lastOriginalMediaId?: InputMaybe<Scalars['uuid']['input']>;
  lastOriginalMediaTime?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "DeviceLastMedia" */
export type DeviceLastMedia = {
  __typename?: 'DeviceLastMedia';
  /** An object relationship */
  device?: Maybe<Device>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaTime?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  media?: Maybe<Media>;
};

/** aggregated selection of "DeviceLastMedia" */
export type DeviceLastMediaAggregate = {
  __typename?: 'DeviceLastMediaAggregate';
  aggregate?: Maybe<DeviceLastMediaAggregateFields>;
  nodes: Array<DeviceLastMedia>;
};

/** aggregate fields of "DeviceLastMedia" */
export type DeviceLastMediaAggregateFields = {
  __typename?: 'DeviceLastMediaAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DeviceLastMediaMaxFields>;
  min?: Maybe<DeviceLastMediaMinFields>;
};


/** aggregate fields of "DeviceLastMedia" */
export type DeviceLastMediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DeviceLastMediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "DeviceLastMedia". All fields are combined with a logical 'AND'. */
export type DeviceLastMediaBoolExp = {
  _and?: InputMaybe<Array<DeviceLastMediaBoolExp>>;
  _not?: InputMaybe<DeviceLastMediaBoolExp>;
  _or?: InputMaybe<Array<DeviceLastMediaBoolExp>>;
  device?: InputMaybe<DeviceBoolExp>;
  deviceId?: InputMaybe<UuidComparisonExp>;
  lastOriginalMediaId?: InputMaybe<UuidComparisonExp>;
  lastOriginalMediaTime?: InputMaybe<TimestamptzComparisonExp>;
  media?: InputMaybe<MediaBoolExp>;
};

/** input type for inserting data into table "DeviceLastMedia" */
export type DeviceLastMediaInsertInput = {
  device?: InputMaybe<DeviceObjRelInsertInput>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  lastOriginalMediaId?: InputMaybe<Scalars['uuid']['input']>;
  lastOriginalMediaTime?: InputMaybe<Scalars['timestamptz']['input']>;
  media?: InputMaybe<MediaObjRelInsertInput>;
};

/** aggregate max on columns */
export type DeviceLastMediaMaxFields = {
  __typename?: 'DeviceLastMediaMaxFields';
  deviceId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaTime?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DeviceLastMediaMinFields = {
  __typename?: 'DeviceLastMediaMinFields';
  deviceId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaId?: Maybe<Scalars['uuid']['output']>;
  lastOriginalMediaTime?: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "DeviceLastMedia" */
export type DeviceLastMediaObjRelInsertInput = {
  data: DeviceLastMediaInsertInput;
};

/** Ordering options when selecting data from "DeviceLastMedia". */
export type DeviceLastMediaOrderBy = {
  device?: InputMaybe<DeviceOrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  lastOriginalMediaId?: InputMaybe<OrderBy>;
  lastOriginalMediaTime?: InputMaybe<OrderBy>;
  media?: InputMaybe<MediaOrderBy>;
};

/** select columns of table "DeviceLastMedia" */
export enum DeviceLastMediaSelectColumn {
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  LastOriginalMediaId = 'lastOriginalMediaId',
  /** column name */
  LastOriginalMediaTime = 'lastOriginalMediaTime'
}

/** Streaming cursor of the table "DeviceLastMedia" */
export type DeviceLastMediaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DeviceLastMediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeviceLastMediaStreamCursorValueInput = {
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  lastOriginalMediaId?: InputMaybe<Scalars['uuid']['input']>;
  lastOriginalMediaTime?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DeviceMaxFields = {
  __typename?: 'DeviceMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowVersion?: Maybe<Scalars['uuid']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Device" */
export type DeviceMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  serial?: InputMaybe<OrderBy>;
  shortId?: InputMaybe<OrderBy>;
  siteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DeviceMinFields = {
  __typename?: 'DeviceMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowVersion?: Maybe<Scalars['uuid']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Device" */
export type DeviceMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  serial?: InputMaybe<OrderBy>;
  shortId?: InputMaybe<OrderBy>;
  siteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "Device" */
export type DeviceMutationResponse = {
  __typename?: 'DeviceMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Device>;
};

/** input type for inserting object relation for remote table "Device" */
export type DeviceObjRelInsertInput = {
  data: DeviceInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DeviceOnConflict>;
};

/** on_conflict condition type for table "Device" */
export type DeviceOnConflict = {
  constraint: DeviceConstraint;
  updateColumns?: Array<DeviceUpdateColumn>;
  where?: InputMaybe<DeviceBoolExp>;
};

/** Ordering options when selecting data from "Device". */
export type DeviceOrderBy = {
  apiKeysAggregate?: InputMaybe<ApiKeyAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  data?: InputMaybe<OrderBy>;
  deviceStatusesAggregate?: InputMaybe<DeviceStatusAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  lastImage?: InputMaybe<DeviceLastImageOrderBy>;
  lastMedia?: InputMaybe<DeviceLastMediaOrderBy>;
  mediaAggregate?: InputMaybe<MediaAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  products?: InputMaybe<OrderBy>;
  roisAggregate?: InputMaybe<RoiAggregateOrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  serial?: InputMaybe<OrderBy>;
  shortId?: InputMaybe<OrderBy>;
  site?: InputMaybe<SiteOrderBy>;
  siteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userDeviceLinksAggregate?: InputMaybe<UserDeviceLinkAggregateOrderBy>;
};

/** primary key columns input for table: Device */
export type DevicePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DevicePrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  products?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Device" */
export enum DeviceSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Products = 'products',
  /** column name */
  RowVersion = 'rowVersion',
  /** column name */
  Serial = 'serial',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "Device" */
export type DeviceSetInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Scalars['jsonb']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "DeviceStatus" */
export type DeviceStatus = {
  __typename?: 'DeviceStatus';
  data: Scalars['jsonb']['output'];
  /** An object relationship */
  device: Device;
  deviceId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  timestamp: Scalars['timestamptz']['output'];
};


/** columns and relationships of "DeviceStatus" */
export type DeviceStatusDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "DeviceStatus" */
export type DeviceStatusAggregate = {
  __typename?: 'DeviceStatusAggregate';
  aggregate?: Maybe<DeviceStatusAggregateFields>;
  nodes: Array<DeviceStatus>;
};

export type DeviceStatusAggregateBoolExp = {
  count?: InputMaybe<DeviceStatusAggregateBoolExpCount>;
};

/** aggregate fields of "DeviceStatus" */
export type DeviceStatusAggregateFields = {
  __typename?: 'DeviceStatusAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DeviceStatusMaxFields>;
  min?: Maybe<DeviceStatusMinFields>;
};


/** aggregate fields of "DeviceStatus" */
export type DeviceStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DeviceStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "DeviceStatus" */
export type DeviceStatusAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DeviceStatusMaxOrderBy>;
  min?: InputMaybe<DeviceStatusMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DeviceStatusAppendInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "DeviceStatus" */
export type DeviceStatusArrRelInsertInput = {
  data: Array<DeviceStatusInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DeviceStatusOnConflict>;
};

/** Boolean expression to filter rows from the table "DeviceStatus". All fields are combined with a logical 'AND'. */
export type DeviceStatusBoolExp = {
  _and?: InputMaybe<Array<DeviceStatusBoolExp>>;
  _not?: InputMaybe<DeviceStatusBoolExp>;
  _or?: InputMaybe<Array<DeviceStatusBoolExp>>;
  data?: InputMaybe<JsonbComparisonExp>;
  device?: InputMaybe<DeviceBoolExp>;
  deviceId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "DeviceStatus" */
export enum DeviceStatusConstraint {
  /** unique or primary key constraint on columns "Id" */
  PkDeviceStatus = 'PK_DeviceStatus'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DeviceStatusDeleteAtPathInput = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DeviceStatusDeleteElemInput = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DeviceStatusDeleteKeyInput = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "DeviceStatus" */
export type DeviceStatusInsertInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  device?: InputMaybe<DeviceObjRelInsertInput>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DeviceStatusMaxFields = {
  __typename?: 'DeviceStatusMaxFields';
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "DeviceStatus" */
export type DeviceStatusMaxOrderBy = {
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DeviceStatusMinFields = {
  __typename?: 'DeviceStatusMinFields';
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "DeviceStatus" */
export type DeviceStatusMinOrderBy = {
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "DeviceStatus" */
export type DeviceStatusMutationResponse = {
  __typename?: 'DeviceStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DeviceStatus>;
};

/** on_conflict condition type for table "DeviceStatus" */
export type DeviceStatusOnConflict = {
  constraint: DeviceStatusConstraint;
  updateColumns?: Array<DeviceStatusUpdateColumn>;
  where?: InputMaybe<DeviceStatusBoolExp>;
};

/** Ordering options when selecting data from "DeviceStatus". */
export type DeviceStatusOrderBy = {
  data?: InputMaybe<OrderBy>;
  device?: InputMaybe<DeviceOrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: DeviceStatus */
export type DeviceStatusPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DeviceStatusPrependInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "DeviceStatus" */
export enum DeviceStatusSelectColumn {
  /** column name */
  Data = 'data',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "DeviceStatus" */
export type DeviceStatusSetInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "DeviceStatus" */
export type DeviceStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DeviceStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeviceStatusStreamCursorValueInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "DeviceStatus" */
export enum DeviceStatusUpdateColumn {
  /** column name */
  Data = 'data',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp'
}

export type DeviceStatusUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DeviceStatusAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<DeviceStatusDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<DeviceStatusDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<DeviceStatusDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DeviceStatusPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DeviceStatusSetInput>;
  /** filter the rows which have to be updated */
  where: DeviceStatusBoolExp;
};

/** Streaming cursor of the table "Device" */
export type DeviceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DeviceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeviceStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Scalars['jsonb']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Device" */
export enum DeviceUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Products = 'products',
  /** column name */
  RowVersion = 'rowVersion',
  /** column name */
  Serial = 'serial',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DeviceUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DeviceAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<DeviceDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<DeviceDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<DeviceDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DevicePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DeviceSetInput>;
  /** filter the rows which have to be updated */
  where: DeviceBoolExp;
};

export type ExpiryInput = {
  days: Scalars['Int']['input'];
  prefix: Scalars['String']['input'];
};

export type GeographyCastExp = {
  geometry?: InputMaybe<GeometryComparisonExp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type GeographyComparisonExp = {
  _cast?: InputMaybe<GeographyCastExp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _stDWithin?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _stIntersects?: InputMaybe<Scalars['geography']['input']>;
};

export type GeometryCastExp = {
  geography?: InputMaybe<GeographyComparisonExp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type GeometryComparisonExp = {
  _cast?: InputMaybe<GeometryCastExp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st3dDWithin?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st3dIntersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _stContains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _stCrosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _stDWithin?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _stEquals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _stIntersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _stOverlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _stTouches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _stWithin?: InputMaybe<Scalars['geometry']['input']>;
};

export type HcTestCreateInput = {
  name: Scalars['String']['input'];
};

export type HcTestCreatePayload = {
  __typename?: 'HcTestCreatePayload';
  message: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvalidateCustomerSecretCacheInput = {
  customerId: Scalars['UUID']['input'];
  pathTail: Scalars['String']['input'];
};

export type InvalidateCustomerSecretCachePayload = {
  __typename?: 'InvalidateCustomerSecretCachePayload';
  success: Scalars['Boolean']['output'];
};

export type InvalidateDeviceCacheInput = {
  deviceIds: Array<Scalars['UUID']['input']>;
};

export type InvalidateDeviceCachePayload = {
  __typename?: 'InvalidateDeviceCachePayload';
  items: Array<InvalidateDeviceCachePayloadItem>;
};

export type InvalidateDeviceCachePayloadItem = {
  __typename?: 'InvalidateDeviceCachePayloadItem';
  deviceId: Scalars['UUID']['output'];
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "Media" */
export type Media = {
  __typename?: 'Media';
  /** An object relationship */
  device: Device;
  deviceId: Scalars['uuid']['output'];
  id: Scalars['bigint']['output'];
  kind: Scalars['String']['output'];
  mediaId?: Maybe<Scalars['uuid']['output']>;
  mimeRootType?: Maybe<Scalars['String']['output']>;
  mimeSubType?: Maybe<Scalars['String']['output']>;
  time: Scalars['timestamptz']['output'];
  uri: Scalars['String']['output'];
};

/** aggregated selection of "Media" */
export type MediaAggregate = {
  __typename?: 'MediaAggregate';
  aggregate?: Maybe<MediaAggregateFields>;
  nodes: Array<Media>;
};

export type MediaAggregateBoolExp = {
  count?: InputMaybe<MediaAggregateBoolExpCount>;
};

/** aggregate fields of "Media" */
export type MediaAggregateFields = {
  __typename?: 'MediaAggregateFields';
  avg?: Maybe<MediaAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MediaMaxFields>;
  min?: Maybe<MediaMinFields>;
  stddev?: Maybe<MediaStddevFields>;
  stddevPop?: Maybe<MediaStddevPopFields>;
  stddevSamp?: Maybe<MediaStddevSampFields>;
  sum?: Maybe<MediaSumFields>;
  varPop?: Maybe<MediaVarPopFields>;
  varSamp?: Maybe<MediaVarSampFields>;
  variance?: Maybe<MediaVarianceFields>;
};


/** aggregate fields of "Media" */
export type MediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Media" */
export type MediaAggregateOrderBy = {
  avg?: InputMaybe<MediaAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MediaMaxOrderBy>;
  min?: InputMaybe<MediaMinOrderBy>;
  stddev?: InputMaybe<MediaStddevOrderBy>;
  stddevPop?: InputMaybe<MediaStddevPopOrderBy>;
  stddevSamp?: InputMaybe<MediaStddevSampOrderBy>;
  sum?: InputMaybe<MediaSumOrderBy>;
  varPop?: InputMaybe<MediaVarPopOrderBy>;
  varSamp?: InputMaybe<MediaVarSampOrderBy>;
  variance?: InputMaybe<MediaVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "Media" */
export type MediaArrRelInsertInput = {
  data: Array<MediaInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MediaOnConflict>;
};

/** aggregate avg on columns */
export type MediaAvgFields = {
  __typename?: 'MediaAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Media" */
export type MediaAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "Media". All fields are combined with a logical 'AND'. */
export type MediaBoolExp = {
  _and?: InputMaybe<Array<MediaBoolExp>>;
  _not?: InputMaybe<MediaBoolExp>;
  _or?: InputMaybe<Array<MediaBoolExp>>;
  device?: InputMaybe<DeviceBoolExp>;
  deviceId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  kind?: InputMaybe<StringComparisonExp>;
  mediaId?: InputMaybe<UuidComparisonExp>;
  mimeRootType?: InputMaybe<StringComparisonExp>;
  mimeSubType?: InputMaybe<StringComparisonExp>;
  time?: InputMaybe<TimestamptzComparisonExp>;
  uri?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "Media" */
export enum MediaConstraint {
  /** unique or primary key constraint on columns "Id" */
  PkMedia = 'PK_Media'
}

/** input type for incrementing numeric columns in table "Media" */
export type MediaIncInput = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "Media" */
export type MediaInsertInput = {
  device?: InputMaybe<DeviceObjRelInsertInput>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['uuid']['input']>;
  mimeRootType?: InputMaybe<Scalars['String']['input']>;
  mimeSubType?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['timestamptz']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MediaMaxFields = {
  __typename?: 'MediaMaxFields';
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  mediaId?: Maybe<Scalars['uuid']['output']>;
  mimeRootType?: Maybe<Scalars['String']['output']>;
  mimeSubType?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['timestamptz']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Media" */
export type MediaMaxOrderBy = {
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  mimeRootType?: InputMaybe<OrderBy>;
  mimeSubType?: InputMaybe<OrderBy>;
  time?: InputMaybe<OrderBy>;
  uri?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MediaMinFields = {
  __typename?: 'MediaMinFields';
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  mediaId?: Maybe<Scalars['uuid']['output']>;
  mimeRootType?: Maybe<Scalars['String']['output']>;
  mimeSubType?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['timestamptz']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Media" */
export type MediaMinOrderBy = {
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  mimeRootType?: InputMaybe<OrderBy>;
  mimeSubType?: InputMaybe<OrderBy>;
  time?: InputMaybe<OrderBy>;
  uri?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "Media" */
export type MediaMutationResponse = {
  __typename?: 'MediaMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Media>;
};

/** input type for inserting object relation for remote table "Media" */
export type MediaObjRelInsertInput = {
  data: MediaInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MediaOnConflict>;
};

/** on_conflict condition type for table "Media" */
export type MediaOnConflict = {
  constraint: MediaConstraint;
  updateColumns?: Array<MediaUpdateColumn>;
  where?: InputMaybe<MediaBoolExp>;
};

/** Ordering options when selecting data from "Media". */
export type MediaOrderBy = {
  device?: InputMaybe<DeviceOrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  mimeRootType?: InputMaybe<OrderBy>;
  mimeSubType?: InputMaybe<OrderBy>;
  time?: InputMaybe<OrderBy>;
  uri?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: Media */
export type MediaPkColumnsInput = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "Media" */
export enum MediaSelectColumn {
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  MimeRootType = 'mimeRootType',
  /** column name */
  MimeSubType = 'mimeSubType',
  /** column name */
  Time = 'time',
  /** column name */
  Uri = 'uri'
}

/** input type for updating data in table "Media" */
export type MediaSetInput = {
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['uuid']['input']>;
  mimeRootType?: InputMaybe<Scalars['String']['input']>;
  mimeSubType?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['timestamptz']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MediaStddevFields = {
  __typename?: 'MediaStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Media" */
export type MediaStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type MediaStddevPopFields = {
  __typename?: 'MediaStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "Media" */
export type MediaStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type MediaStddevSampFields = {
  __typename?: 'MediaStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "Media" */
export type MediaStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "Media" */
export type MediaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MediaStreamCursorValueInput = {
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['uuid']['input']>;
  mimeRootType?: InputMaybe<Scalars['String']['input']>;
  mimeSubType?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['timestamptz']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MediaSumFields = {
  __typename?: 'MediaSumFields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "Media" */
export type MediaSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "Media" */
export enum MediaUpdateColumn {
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MediaId = 'mediaId',
  /** column name */
  MimeRootType = 'mimeRootType',
  /** column name */
  MimeSubType = 'mimeSubType',
  /** column name */
  Time = 'time',
  /** column name */
  Uri = 'uri'
}

export type MediaUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MediaIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MediaSetInput>;
  /** filter the rows which have to be updated */
  where: MediaBoolExp;
};

/** aggregate varPop on columns */
export type MediaVarPopFields = {
  __typename?: 'MediaVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "Media" */
export type MediaVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type MediaVarSampFields = {
  __typename?: 'MediaVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "Media" */
export type MediaVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MediaVarianceFields = {
  __typename?: 'MediaVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Media" */
export type MediaVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc = 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast = 'DESC_NULLS_LAST'
}

/** columns and relationships of "Roi" */
export type Roi = {
  __typename?: 'Roi';
  config: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  device: Device;
  deviceId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  rowVersion: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "Roi" */
export type RoiConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Roi" */
export type RoiAggregate = {
  __typename?: 'RoiAggregate';
  aggregate?: Maybe<RoiAggregateFields>;
  nodes: Array<Roi>;
};

export type RoiAggregateBoolExp = {
  count?: InputMaybe<RoiAggregateBoolExpCount>;
};

/** aggregate fields of "Roi" */
export type RoiAggregateFields = {
  __typename?: 'RoiAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RoiMaxFields>;
  min?: Maybe<RoiMinFields>;
};


/** aggregate fields of "Roi" */
export type RoiAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RoiSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Roi" */
export type RoiAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RoiMaxOrderBy>;
  min?: InputMaybe<RoiMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RoiAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Roi" */
export type RoiArrRelInsertInput = {
  data: Array<RoiInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RoiOnConflict>;
};

/** Boolean expression to filter rows from the table "Roi". All fields are combined with a logical 'AND'. */
export type RoiBoolExp = {
  _and?: InputMaybe<Array<RoiBoolExp>>;
  _not?: InputMaybe<RoiBoolExp>;
  _or?: InputMaybe<Array<RoiBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  device?: InputMaybe<DeviceBoolExp>;
  deviceId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  rowVersion?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  zone?: InputMaybe<ZoneBoolExp>;
  zoneId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "Roi" */
export enum RoiConstraint {
  /** unique or primary key constraint on columns "Id" */
  PkRoi = 'PK_Roi'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RoiDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RoiDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RoiDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Roi" */
export type RoiInsertInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  device?: InputMaybe<DeviceObjRelInsertInput>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  zone?: InputMaybe<ZoneObjRelInsertInput>;
  zoneId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RoiMaxFields = {
  __typename?: 'RoiMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowVersion?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  zoneId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "Roi" */
export type RoiMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zoneId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RoiMinFields = {
  __typename?: 'RoiMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowVersion?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  zoneId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "Roi" */
export type RoiMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zoneId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "Roi" */
export type RoiMutationResponse = {
  __typename?: 'RoiMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Roi>;
};

/** on_conflict condition type for table "Roi" */
export type RoiOnConflict = {
  constraint: RoiConstraint;
  updateColumns?: Array<RoiUpdateColumn>;
  where?: InputMaybe<RoiBoolExp>;
};

/** Ordering options when selecting data from "Roi". */
export type RoiOrderBy = {
  config?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  device?: InputMaybe<DeviceOrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zone?: InputMaybe<ZoneOrderBy>;
  zoneId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: Roi */
export type RoiPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RoiPrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Roi" */
export enum RoiSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RowVersion = 'rowVersion',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ZoneId = 'zoneId'
}

/** input type for updating data in table "Roi" */
export type RoiSetInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  zoneId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "Roi" */
export type RoiStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RoiStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RoiStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  zoneId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "Roi" */
export enum RoiUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RowVersion = 'rowVersion',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ZoneId = 'zoneId'
}

export type RoiUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RoiAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RoiDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RoiDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RoiDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RoiPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoiSetInput>;
  /** filter the rows which have to be updated */
  where: RoiBoolExp;
};

/** columns and relationships of "Site" */
export type Site = {
  __typename?: 'Site';
  config: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer: Customer;
  customerId: Scalars['uuid']['output'];
  /** An array relationship */
  devices: Array<Device>;
  /** An aggregate relationship */
  devicesAggregate: DeviceAggregate;
  geometry?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  rowVersion: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userData?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "Site" */
export type SiteConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Site" */
export type SiteDevicesArgs = {
  distinctOn?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


/** columns and relationships of "Site" */
export type SiteDevicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


/** columns and relationships of "Site" */
export type SiteUserDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Site" */
export type SiteAggregate = {
  __typename?: 'SiteAggregate';
  aggregate?: Maybe<SiteAggregateFields>;
  nodes: Array<Site>;
};

export type SiteAggregateBoolExp = {
  count?: InputMaybe<SiteAggregateBoolExpCount>;
};

/** aggregate fields of "Site" */
export type SiteAggregateFields = {
  __typename?: 'SiteAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<SiteMaxFields>;
  min?: Maybe<SiteMinFields>;
};


/** aggregate fields of "Site" */
export type SiteAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SiteSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Site" */
export type SiteAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SiteMaxOrderBy>;
  min?: InputMaybe<SiteMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SiteAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  userData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Site" */
export type SiteArrRelInsertInput = {
  data: Array<SiteInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<SiteOnConflict>;
};

/** Boolean expression to filter rows from the table "Site". All fields are combined with a logical 'AND'. */
export type SiteBoolExp = {
  _and?: InputMaybe<Array<SiteBoolExp>>;
  _not?: InputMaybe<SiteBoolExp>;
  _or?: InputMaybe<Array<SiteBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customer?: InputMaybe<CustomerBoolExp>;
  customerId?: InputMaybe<UuidComparisonExp>;
  devices?: InputMaybe<DeviceBoolExp>;
  devicesAggregate?: InputMaybe<DeviceAggregateBoolExp>;
  geometry?: InputMaybe<GeometryComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  rowVersion?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userData?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "Site" */
export enum SiteConstraint {
  /** unique or primary key constraint on columns "CustomerId", "Name" */
  IxSiteCustomerIdName = 'IX_Site_CustomerId_Name',
  /** unique or primary key constraint on columns "Id" */
  PkSite = 'PK_Site'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SiteDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
  userData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SiteDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
  userData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SiteDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Site" */
export type SiteInsertInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<CustomerObjRelInsertInput>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  devices?: InputMaybe<DeviceArrRelInsertInput>;
  geometry?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type SiteMaxFields = {
  __typename?: 'SiteMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customerId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowVersion?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Site" */
export type SiteMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SiteMinFields = {
  __typename?: 'SiteMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customerId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rowVersion?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Site" */
export type SiteMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "Site" */
export type SiteMutationResponse = {
  __typename?: 'SiteMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Site>;
};

/** input type for inserting object relation for remote table "Site" */
export type SiteObjRelInsertInput = {
  data: SiteInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<SiteOnConflict>;
};

/** on_conflict condition type for table "Site" */
export type SiteOnConflict = {
  constraint: SiteConstraint;
  updateColumns?: Array<SiteUpdateColumn>;
  where?: InputMaybe<SiteBoolExp>;
};

/** Ordering options when selecting data from "Site". */
export type SiteOrderBy = {
  config?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customer?: InputMaybe<CustomerOrderBy>;
  customerId?: InputMaybe<OrderBy>;
  devicesAggregate?: InputMaybe<DeviceAggregateOrderBy>;
  geometry?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rowVersion?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userData?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: Site */
export type SitePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SitePrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  userData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Site" */
export enum SiteSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RowVersion = 'rowVersion',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserData = 'userData'
}

/** input type for updating data in table "Site" */
export type SiteSetInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  geometry?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "Site" */
export type SiteStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SiteStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SiteStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerId?: InputMaybe<Scalars['uuid']['input']>;
  geometry?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rowVersion?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "Site" */
export enum SiteUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomerId = 'customerId',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RowVersion = 'rowVersion',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserData = 'userData'
}

export type SiteUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SiteAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<SiteDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<SiteDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<SiteDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SitePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SiteSetInput>;
  /** filter the rows which have to be updated */
  where: SiteBoolExp;
};

export type SnZone = {
  __typename?: 'SnZone';
  polygon: Scalars['String']['output'];
  polygonId: Scalars['Int']['output'];
  zoneKey: Scalars['String']['output'];
  zoneName: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type UpsertCustomerSecretInput = {
  customerId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  pathTail: Scalars['String']['input'];
  secretJson: Scalars['String']['input'];
};

export type UpsertCustomerSecretPayload = {
  __typename?: 'UpsertCustomerSecretPayload';
  name: Scalars['String']['output'];
  uri: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

/** columns and relationships of "UserDeviceLink" */
export type UserDeviceLink = {
  __typename?: 'UserDeviceLink';
  /** An object relationship */
  aspNetUser: AspNetUsers;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  device: Device;
  deviceId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['String']['output'];
};

/** aggregated selection of "UserDeviceLink" */
export type UserDeviceLinkAggregate = {
  __typename?: 'UserDeviceLinkAggregate';
  aggregate?: Maybe<UserDeviceLinkAggregateFields>;
  nodes: Array<UserDeviceLink>;
};

export type UserDeviceLinkAggregateBoolExp = {
  count?: InputMaybe<UserDeviceLinkAggregateBoolExpCount>;
};

/** aggregate fields of "UserDeviceLink" */
export type UserDeviceLinkAggregateFields = {
  __typename?: 'UserDeviceLinkAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserDeviceLinkMaxFields>;
  min?: Maybe<UserDeviceLinkMinFields>;
};


/** aggregate fields of "UserDeviceLink" */
export type UserDeviceLinkAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "UserDeviceLink" */
export type UserDeviceLinkAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserDeviceLinkMaxOrderBy>;
  min?: InputMaybe<UserDeviceLinkMinOrderBy>;
};

/** input type for inserting array relation for remote table "UserDeviceLink" */
export type UserDeviceLinkArrRelInsertInput = {
  data: Array<UserDeviceLinkInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserDeviceLinkOnConflict>;
};

/** Boolean expression to filter rows from the table "UserDeviceLink". All fields are combined with a logical 'AND'. */
export type UserDeviceLinkBoolExp = {
  _and?: InputMaybe<Array<UserDeviceLinkBoolExp>>;
  _not?: InputMaybe<UserDeviceLinkBoolExp>;
  _or?: InputMaybe<Array<UserDeviceLinkBoolExp>>;
  aspNetUser?: InputMaybe<AspNetUsersBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  device?: InputMaybe<DeviceBoolExp>;
  deviceId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "UserDeviceLink" */
export enum UserDeviceLinkConstraint {
  /** unique or primary key constraint on columns "UserId", "DeviceId" */
  IxUserDeviceLinkUserIdDeviceId = 'IX_UserDeviceLink_UserId_DeviceId',
  /** unique or primary key constraint on columns "Id" */
  PkUserDeviceLink = 'PK_UserDeviceLink'
}

/** input type for inserting data into table "UserDeviceLink" */
export type UserDeviceLinkInsertInput = {
  aspNetUser?: InputMaybe<AspNetUsersObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  device?: InputMaybe<DeviceObjRelInsertInput>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserDeviceLinkMaxFields = {
  __typename?: 'UserDeviceLinkMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "UserDeviceLink" */
export type UserDeviceLinkMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserDeviceLinkMinFields = {
  __typename?: 'UserDeviceLinkMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "UserDeviceLink" */
export type UserDeviceLinkMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "UserDeviceLink" */
export type UserDeviceLinkMutationResponse = {
  __typename?: 'UserDeviceLinkMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserDeviceLink>;
};

/** on_conflict condition type for table "UserDeviceLink" */
export type UserDeviceLinkOnConflict = {
  constraint: UserDeviceLinkConstraint;
  updateColumns?: Array<UserDeviceLinkUpdateColumn>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};

/** Ordering options when selecting data from "UserDeviceLink". */
export type UserDeviceLinkOrderBy = {
  aspNetUser?: InputMaybe<AspNetUsersOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  device?: InputMaybe<DeviceOrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: UserDeviceLink */
export type UserDeviceLinkPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "UserDeviceLink" */
export enum UserDeviceLinkSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "UserDeviceLink" */
export type UserDeviceLinkSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "UserDeviceLink" */
export type UserDeviceLinkStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserDeviceLinkStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserDeviceLinkStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "UserDeviceLink" */
export enum UserDeviceLinkUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserDeviceLinkUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserDeviceLinkSetInput>;
  /** filter the rows which have to be updated */
  where: UserDeviceLinkBoolExp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "Zone" */
export type Zone = {
  __typename?: 'Zone';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  /** An array relationship */
  rois: Array<Roi>;
  /** An aggregate relationship */
  roisAggregate: RoiAggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Zone" */
export type ZoneRoisArgs = {
  distinctOn?: InputMaybe<Array<RoiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoiOrderBy>>;
  where?: InputMaybe<RoiBoolExp>;
};


/** columns and relationships of "Zone" */
export type ZoneRoisAggregateArgs = {
  distinctOn?: InputMaybe<Array<RoiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoiOrderBy>>;
  where?: InputMaybe<RoiBoolExp>;
};

/** aggregated selection of "Zone" */
export type ZoneAggregate = {
  __typename?: 'ZoneAggregate';
  aggregate?: Maybe<ZoneAggregateFields>;
  nodes: Array<Zone>;
};

/** aggregate fields of "Zone" */
export type ZoneAggregateFields = {
  __typename?: 'ZoneAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ZoneMaxFields>;
  min?: Maybe<ZoneMinFields>;
};


/** aggregate fields of "Zone" */
export type ZoneAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ZoneSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Zone". All fields are combined with a logical 'AND'. */
export type ZoneBoolExp = {
  _and?: InputMaybe<Array<ZoneBoolExp>>;
  _not?: InputMaybe<ZoneBoolExp>;
  _or?: InputMaybe<Array<ZoneBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  rois?: InputMaybe<RoiBoolExp>;
  roisAggregate?: InputMaybe<RoiAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "Zone" */
export enum ZoneConstraint {
  /** unique or primary key constraint on columns "Id" */
  PkZone = 'PK_Zone'
}

/** input type for inserting data into table "Zone" */
export type ZoneInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  rois?: InputMaybe<RoiArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ZoneMaxFields = {
  __typename?: 'ZoneMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type ZoneMinFields = {
  __typename?: 'ZoneMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Zone" */
export type ZoneMutationResponse = {
  __typename?: 'ZoneMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Zone>;
};

/** input type for inserting object relation for remote table "Zone" */
export type ZoneObjRelInsertInput = {
  data: ZoneInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ZoneOnConflict>;
};

/** on_conflict condition type for table "Zone" */
export type ZoneOnConflict = {
  constraint: ZoneConstraint;
  updateColumns?: Array<ZoneUpdateColumn>;
  where?: InputMaybe<ZoneBoolExp>;
};

/** Ordering options when selecting data from "Zone". */
export type ZoneOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  roisAggregate?: InputMaybe<RoiAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: Zone */
export type ZonePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Zone" */
export enum ZoneSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "Zone" */
export type ZoneSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Zone" */
export type ZoneStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ZoneStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ZoneStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Zone" */
export enum ZoneUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ZoneUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ZoneSetInput>;
  /** filter the rows which have to be updated */
  where: ZoneBoolExp;
};

export type ApiKeyAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ApiKeySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ApiKeyBoolExp>;
  predicate: IntComparisonExp;
};

export type AspNetUserRolesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AspNetUserRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AspNetUserRolesBoolExp>;
  predicate: IntComparisonExp;
};

export type DeviceAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DeviceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DeviceBoolExp>;
  predicate: IntComparisonExp;
};

export type DeviceStatusAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DeviceStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DeviceStatusBoolExp>;
  predicate: IntComparisonExp;
};

export type MediaAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MediaBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  createCustomerApiKeys: CreateCustomerApiKeysPayload;
  createDeviceApiKeys: CreateDeviceApiKeysPayload;
  /** delete data from the table: "ApiKey" */
  deleteApiKey?: Maybe<ApiKeyMutationResponse>;
  /** delete single row from the table: "ApiKey" */
  deleteApiKeyByPk?: Maybe<ApiKey>;
  /** delete data from the table: "AspNetRoleClaims" */
  deleteAspNetRoleClaims?: Maybe<AspNetRoleClaimsMutationResponse>;
  /** delete single row from the table: "AspNetRoleClaims" */
  deleteAspNetRoleClaimsByPk?: Maybe<AspNetRoleClaims>;
  /** delete data from the table: "AspNetRoles" */
  deleteAspNetRoles?: Maybe<AspNetRolesMutationResponse>;
  /** delete single row from the table: "AspNetRoles" */
  deleteAspNetRolesByPk?: Maybe<AspNetRoles>;
  /** delete data from the table: "AspNetUserClaims" */
  deleteAspNetUserClaims?: Maybe<AspNetUserClaimsMutationResponse>;
  /** delete single row from the table: "AspNetUserClaims" */
  deleteAspNetUserClaimsByPk?: Maybe<AspNetUserClaims>;
  /** delete data from the table: "AspNetUserLogins" */
  deleteAspNetUserLogins?: Maybe<AspNetUserLoginsMutationResponse>;
  /** delete single row from the table: "AspNetUserLogins" */
  deleteAspNetUserLoginsByPk?: Maybe<AspNetUserLogins>;
  /** delete data from the table: "AspNetUserRoles" */
  deleteAspNetUserRoles?: Maybe<AspNetUserRolesMutationResponse>;
  /** delete single row from the table: "AspNetUserRoles" */
  deleteAspNetUserRolesByPk?: Maybe<AspNetUserRoles>;
  /** delete data from the table: "AspNetUserTokens" */
  deleteAspNetUserTokens?: Maybe<AspNetUserTokensMutationResponse>;
  /** delete single row from the table: "AspNetUserTokens" */
  deleteAspNetUserTokensByPk?: Maybe<AspNetUserTokens>;
  /** delete data from the table: "AspNetUsers" */
  deleteAspNetUsers?: Maybe<AspNetUsersMutationResponse>;
  /** delete single row from the table: "AspNetUsers" */
  deleteAspNetUsersByPk?: Maybe<AspNetUsers>;
  /** delete data from the table: "AuditLog" */
  deleteAuditLog?: Maybe<AuditLogMutationResponse>;
  /** delete single row from the table: "AuditLog" */
  deleteAuditLogByPk?: Maybe<AuditLog>;
  /** delete data from the table: "Customer" */
  deleteCustomer?: Maybe<CustomerMutationResponse>;
  /** delete single row from the table: "Customer" */
  deleteCustomerByPk?: Maybe<Customer>;
  /** Delete an existing customer-scoped secret in AWS Secrets Manager using force delete without recovery. */
  deleteCustomerSecret: DeleteCustomerSecretPayload;
  /** delete data from the table: "Device" */
  deleteDevice?: Maybe<DeviceMutationResponse>;
  /** delete single row from the table: "Device" */
  deleteDeviceByPk?: Maybe<Device>;
  /** delete data from the table: "DeviceStatus" */
  deleteDeviceStatus?: Maybe<DeviceStatusMutationResponse>;
  /** delete single row from the table: "DeviceStatus" */
  deleteDeviceStatusByPk?: Maybe<DeviceStatus>;
  /** delete data from the table: "Media" */
  deleteMedia?: Maybe<MediaMutationResponse>;
  /** delete single row from the table: "Media" */
  deleteMediaByPk?: Maybe<Media>;
  /** delete data from the table: "Roi" */
  deleteRoi?: Maybe<RoiMutationResponse>;
  /** delete single row from the table: "Roi" */
  deleteRoiByPk?: Maybe<Roi>;
  /** delete data from the table: "Site" */
  deleteSite?: Maybe<SiteMutationResponse>;
  /** delete single row from the table: "Site" */
  deleteSiteByPk?: Maybe<Site>;
  /** delete data from the table: "UserDeviceLink" */
  deleteUserDeviceLink?: Maybe<UserDeviceLinkMutationResponse>;
  /** delete single row from the table: "UserDeviceLink" */
  deleteUserDeviceLinkByPk?: Maybe<UserDeviceLink>;
  /** delete data from the table: "Zone" */
  deleteZone?: Maybe<ZoneMutationResponse>;
  /** delete single row from the table: "Zone" */
  deleteZoneByPk?: Maybe<Zone>;
  hcTestCreate: HcTestCreatePayload;
  /** insert data into the table: "ApiKey" */
  insertApiKey?: Maybe<ApiKeyMutationResponse>;
  /** insert a single row into the table: "ApiKey" */
  insertApiKeyOne?: Maybe<ApiKey>;
  /** insert data into the table: "AspNetRoleClaims" */
  insertAspNetRoleClaims?: Maybe<AspNetRoleClaimsMutationResponse>;
  /** insert a single row into the table: "AspNetRoleClaims" */
  insertAspNetRoleClaimsOne?: Maybe<AspNetRoleClaims>;
  /** insert data into the table: "AspNetRoles" */
  insertAspNetRoles?: Maybe<AspNetRolesMutationResponse>;
  /** insert a single row into the table: "AspNetRoles" */
  insertAspNetRolesOne?: Maybe<AspNetRoles>;
  /** insert data into the table: "AspNetUserClaims" */
  insertAspNetUserClaims?: Maybe<AspNetUserClaimsMutationResponse>;
  /** insert a single row into the table: "AspNetUserClaims" */
  insertAspNetUserClaimsOne?: Maybe<AspNetUserClaims>;
  /** insert data into the table: "AspNetUserLogins" */
  insertAspNetUserLogins?: Maybe<AspNetUserLoginsMutationResponse>;
  /** insert a single row into the table: "AspNetUserLogins" */
  insertAspNetUserLoginsOne?: Maybe<AspNetUserLogins>;
  /** insert data into the table: "AspNetUserRoles" */
  insertAspNetUserRoles?: Maybe<AspNetUserRolesMutationResponse>;
  /** insert a single row into the table: "AspNetUserRoles" */
  insertAspNetUserRolesOne?: Maybe<AspNetUserRoles>;
  /** insert data into the table: "AspNetUserTokens" */
  insertAspNetUserTokens?: Maybe<AspNetUserTokensMutationResponse>;
  /** insert a single row into the table: "AspNetUserTokens" */
  insertAspNetUserTokensOne?: Maybe<AspNetUserTokens>;
  /** insert data into the table: "AspNetUsers" */
  insertAspNetUsers?: Maybe<AspNetUsersMutationResponse>;
  /** insert a single row into the table: "AspNetUsers" */
  insertAspNetUsersOne?: Maybe<AspNetUsers>;
  /** insert data into the table: "AuditLog" */
  insertAuditLog?: Maybe<AuditLogMutationResponse>;
  /** insert a single row into the table: "AuditLog" */
  insertAuditLogOne?: Maybe<AuditLog>;
  /** insert data into the table: "Customer" */
  insertCustomer?: Maybe<CustomerMutationResponse>;
  /** insert a single row into the table: "Customer" */
  insertCustomerOne?: Maybe<Customer>;
  /** insert data into the table: "Device" */
  insertDevice?: Maybe<DeviceMutationResponse>;
  /** insert a single row into the table: "Device" */
  insertDeviceOne?: Maybe<Device>;
  /** insert data into the table: "DeviceStatus" */
  insertDeviceStatus?: Maybe<DeviceStatusMutationResponse>;
  /** insert a single row into the table: "DeviceStatus" */
  insertDeviceStatusOne?: Maybe<DeviceStatus>;
  /** insert data into the table: "Media" */
  insertMedia?: Maybe<MediaMutationResponse>;
  /** insert a single row into the table: "Media" */
  insertMediaOne?: Maybe<Media>;
  /** insert data into the table: "Roi" */
  insertRoi?: Maybe<RoiMutationResponse>;
  /** insert a single row into the table: "Roi" */
  insertRoiOne?: Maybe<Roi>;
  /** insert data into the table: "Site" */
  insertSite?: Maybe<SiteMutationResponse>;
  /** insert a single row into the table: "Site" */
  insertSiteOne?: Maybe<Site>;
  /** insert data into the table: "UserDeviceLink" */
  insertUserDeviceLink?: Maybe<UserDeviceLinkMutationResponse>;
  /** insert a single row into the table: "UserDeviceLink" */
  insertUserDeviceLinkOne?: Maybe<UserDeviceLink>;
  /** insert data into the table: "Zone" */
  insertZone?: Maybe<ZoneMutationResponse>;
  /** insert a single row into the table: "Zone" */
  insertZoneOne?: Maybe<Zone>;
  invalidateCustomerSecretCache: InvalidateCustomerSecretCachePayload;
  invalidateDeviceCache: InvalidateDeviceCachePayload;
  /** update data of the table: "ApiKey" */
  updateApiKey?: Maybe<ApiKeyMutationResponse>;
  /** update single row of the table: "ApiKey" */
  updateApiKeyByPk?: Maybe<ApiKey>;
  /** update multiples rows of table: "ApiKey" */
  updateApiKeyMany?: Maybe<Array<Maybe<ApiKeyMutationResponse>>>;
  /** update data of the table: "AspNetRoleClaims" */
  updateAspNetRoleClaims?: Maybe<AspNetRoleClaimsMutationResponse>;
  /** update single row of the table: "AspNetRoleClaims" */
  updateAspNetRoleClaimsByPk?: Maybe<AspNetRoleClaims>;
  /** update multiples rows of table: "AspNetRoleClaims" */
  updateAspNetRoleClaimsMany?: Maybe<Array<Maybe<AspNetRoleClaimsMutationResponse>>>;
  /** update data of the table: "AspNetRoles" */
  updateAspNetRoles?: Maybe<AspNetRolesMutationResponse>;
  /** update single row of the table: "AspNetRoles" */
  updateAspNetRolesByPk?: Maybe<AspNetRoles>;
  /** update multiples rows of table: "AspNetRoles" */
  updateAspNetRolesMany?: Maybe<Array<Maybe<AspNetRolesMutationResponse>>>;
  /** update data of the table: "AspNetUserClaims" */
  updateAspNetUserClaims?: Maybe<AspNetUserClaimsMutationResponse>;
  /** update single row of the table: "AspNetUserClaims" */
  updateAspNetUserClaimsByPk?: Maybe<AspNetUserClaims>;
  /** update multiples rows of table: "AspNetUserClaims" */
  updateAspNetUserClaimsMany?: Maybe<Array<Maybe<AspNetUserClaimsMutationResponse>>>;
  /** update data of the table: "AspNetUserLogins" */
  updateAspNetUserLogins?: Maybe<AspNetUserLoginsMutationResponse>;
  /** update single row of the table: "AspNetUserLogins" */
  updateAspNetUserLoginsByPk?: Maybe<AspNetUserLogins>;
  /** update multiples rows of table: "AspNetUserLogins" */
  updateAspNetUserLoginsMany?: Maybe<Array<Maybe<AspNetUserLoginsMutationResponse>>>;
  /** update data of the table: "AspNetUserRoles" */
  updateAspNetUserRoles?: Maybe<AspNetUserRolesMutationResponse>;
  /** update single row of the table: "AspNetUserRoles" */
  updateAspNetUserRolesByPk?: Maybe<AspNetUserRoles>;
  /** update multiples rows of table: "AspNetUserRoles" */
  updateAspNetUserRolesMany?: Maybe<Array<Maybe<AspNetUserRolesMutationResponse>>>;
  /** update data of the table: "AspNetUserTokens" */
  updateAspNetUserTokens?: Maybe<AspNetUserTokensMutationResponse>;
  /** update single row of the table: "AspNetUserTokens" */
  updateAspNetUserTokensByPk?: Maybe<AspNetUserTokens>;
  /** update multiples rows of table: "AspNetUserTokens" */
  updateAspNetUserTokensMany?: Maybe<Array<Maybe<AspNetUserTokensMutationResponse>>>;
  /** update data of the table: "AspNetUsers" */
  updateAspNetUsers?: Maybe<AspNetUsersMutationResponse>;
  /** update single row of the table: "AspNetUsers" */
  updateAspNetUsersByPk?: Maybe<AspNetUsers>;
  /** update multiples rows of table: "AspNetUsers" */
  updateAspNetUsersMany?: Maybe<Array<Maybe<AspNetUsersMutationResponse>>>;
  /** update data of the table: "AuditLog" */
  updateAuditLog?: Maybe<AuditLogMutationResponse>;
  /** update single row of the table: "AuditLog" */
  updateAuditLogByPk?: Maybe<AuditLog>;
  /** update multiples rows of table: "AuditLog" */
  updateAuditLogMany?: Maybe<Array<Maybe<AuditLogMutationResponse>>>;
  /** update data of the table: "Customer" */
  updateCustomer?: Maybe<CustomerMutationResponse>;
  /** update single row of the table: "Customer" */
  updateCustomerByPk?: Maybe<Customer>;
  /** update multiples rows of table: "Customer" */
  updateCustomerMany?: Maybe<Array<Maybe<CustomerMutationResponse>>>;
  /** update data of the table: "Device" */
  updateDevice?: Maybe<DeviceMutationResponse>;
  /** update single row of the table: "Device" */
  updateDeviceByPk?: Maybe<Device>;
  /** update multiples rows of table: "Device" */
  updateDeviceMany?: Maybe<Array<Maybe<DeviceMutationResponse>>>;
  /** update data of the table: "DeviceStatus" */
  updateDeviceStatus?: Maybe<DeviceStatusMutationResponse>;
  /** update single row of the table: "DeviceStatus" */
  updateDeviceStatusByPk?: Maybe<DeviceStatus>;
  /** update multiples rows of table: "DeviceStatus" */
  updateDeviceStatusMany?: Maybe<Array<Maybe<DeviceStatusMutationResponse>>>;
  /** update data of the table: "Media" */
  updateMedia?: Maybe<MediaMutationResponse>;
  /** update single row of the table: "Media" */
  updateMediaByPk?: Maybe<Media>;
  /** update multiples rows of table: "Media" */
  updateMediaMany?: Maybe<Array<Maybe<MediaMutationResponse>>>;
  /** update data of the table: "Roi" */
  updateRoi?: Maybe<RoiMutationResponse>;
  /** update single row of the table: "Roi" */
  updateRoiByPk?: Maybe<Roi>;
  /** update multiples rows of table: "Roi" */
  updateRoiMany?: Maybe<Array<Maybe<RoiMutationResponse>>>;
  /** update data of the table: "Site" */
  updateSite?: Maybe<SiteMutationResponse>;
  /** update single row of the table: "Site" */
  updateSiteByPk?: Maybe<Site>;
  /** update multiples rows of table: "Site" */
  updateSiteMany?: Maybe<Array<Maybe<SiteMutationResponse>>>;
  /** update data of the table: "UserDeviceLink" */
  updateUserDeviceLink?: Maybe<UserDeviceLinkMutationResponse>;
  /** update single row of the table: "UserDeviceLink" */
  updateUserDeviceLinkByPk?: Maybe<UserDeviceLink>;
  /** update multiples rows of table: "UserDeviceLink" */
  updateUserDeviceLinkMany?: Maybe<Array<Maybe<UserDeviceLinkMutationResponse>>>;
  /** update data of the table: "Zone" */
  updateZone?: Maybe<ZoneMutationResponse>;
  /** update single row of the table: "Zone" */
  updateZoneByPk?: Maybe<Zone>;
  /** update multiples rows of table: "Zone" */
  updateZoneMany?: Maybe<Array<Maybe<ZoneMutationResponse>>>;
  /** Create a S3 bucket for a customer or update the config of the bucket if it already exists. Also updates the customer's StoragePath to point to the S3 bucket. Fail if customer's StoragePath is already set to a different value. */
  upsertCustomerS3Bucket: Scalars['String']['output'];
  /** Create or update a customer-scoped secret in AWS Secrets Manager and return uri. */
  upsertCustomerSecret: UpsertCustomerSecretPayload;
};


/** mutation root */
export type Mutation_RootCreateCustomerApiKeysArgs = {
  input: CreateCustomerApiKeysInput;
};


/** mutation root */
export type Mutation_RootCreateDeviceApiKeysArgs = {
  input: CreateDeviceApiKeysInput;
};


/** mutation root */
export type Mutation_RootDeleteApiKeyArgs = {
  where: ApiKeyBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteApiKeyByPkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAspNetRoleClaimsArgs = {
  where: AspNetRoleClaimsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAspNetRoleClaimsByPkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAspNetRolesArgs = {
  where: AspNetRolesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAspNetRolesByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAspNetUserClaimsArgs = {
  where: AspNetUserClaimsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAspNetUserClaimsByPkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAspNetUserLoginsArgs = {
  where: AspNetUserLoginsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAspNetUserLoginsByPkArgs = {
  loginProvider: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAspNetUserRolesArgs = {
  where: AspNetUserRolesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAspNetUserRolesByPkArgs = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAspNetUserTokensArgs = {
  where: AspNetUserTokensBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAspNetUserTokensByPkArgs = {
  loginProvider: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAspNetUsersArgs = {
  where: AspNetUsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAspNetUsersByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuditLogArgs = {
  where: AuditLogBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAuditLogByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCustomerArgs = {
  where: CustomerBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCustomerByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCustomerSecretArgs = {
  input: DeleteCustomerSecretInput;
};


/** mutation root */
export type Mutation_RootDeleteDeviceArgs = {
  where: DeviceBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDeviceByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDeviceStatusArgs = {
  where: DeviceStatusBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDeviceStatusByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteMediaArgs = {
  where: MediaBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMediaByPkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRoiArgs = {
  where: RoiBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRoiByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteSiteArgs = {
  where: SiteBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSiteByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUserDeviceLinkArgs = {
  where: UserDeviceLinkBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserDeviceLinkByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteZoneArgs = {
  where: ZoneBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteZoneByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootHcTestCreateArgs = {
  input: HcTestCreateInput;
};


/** mutation root */
export type Mutation_RootInsertApiKeyArgs = {
  objects: Array<ApiKeyInsertInput>;
  onConflict?: InputMaybe<ApiKeyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertApiKeyOneArgs = {
  object: ApiKeyInsertInput;
  onConflict?: InputMaybe<ApiKeyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetRoleClaimsArgs = {
  objects: Array<AspNetRoleClaimsInsertInput>;
  onConflict?: InputMaybe<AspNetRoleClaimsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetRoleClaimsOneArgs = {
  object: AspNetRoleClaimsInsertInput;
  onConflict?: InputMaybe<AspNetRoleClaimsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetRolesArgs = {
  objects: Array<AspNetRolesInsertInput>;
  onConflict?: InputMaybe<AspNetRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetRolesOneArgs = {
  object: AspNetRolesInsertInput;
  onConflict?: InputMaybe<AspNetRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUserClaimsArgs = {
  objects: Array<AspNetUserClaimsInsertInput>;
  onConflict?: InputMaybe<AspNetUserClaimsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUserClaimsOneArgs = {
  object: AspNetUserClaimsInsertInput;
  onConflict?: InputMaybe<AspNetUserClaimsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUserLoginsArgs = {
  objects: Array<AspNetUserLoginsInsertInput>;
  onConflict?: InputMaybe<AspNetUserLoginsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUserLoginsOneArgs = {
  object: AspNetUserLoginsInsertInput;
  onConflict?: InputMaybe<AspNetUserLoginsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUserRolesArgs = {
  objects: Array<AspNetUserRolesInsertInput>;
  onConflict?: InputMaybe<AspNetUserRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUserRolesOneArgs = {
  object: AspNetUserRolesInsertInput;
  onConflict?: InputMaybe<AspNetUserRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUserTokensArgs = {
  objects: Array<AspNetUserTokensInsertInput>;
  onConflict?: InputMaybe<AspNetUserTokensOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUserTokensOneArgs = {
  object: AspNetUserTokensInsertInput;
  onConflict?: InputMaybe<AspNetUserTokensOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUsersArgs = {
  objects: Array<AspNetUsersInsertInput>;
  onConflict?: InputMaybe<AspNetUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAspNetUsersOneArgs = {
  object: AspNetUsersInsertInput;
  onConflict?: InputMaybe<AspNetUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAuditLogArgs = {
  objects: Array<AuditLogInsertInput>;
  onConflict?: InputMaybe<AuditLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAuditLogOneArgs = {
  object: AuditLogInsertInput;
  onConflict?: InputMaybe<AuditLogOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomerArgs = {
  objects: Array<CustomerInsertInput>;
  onConflict?: InputMaybe<CustomerOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomerOneArgs = {
  object: CustomerInsertInput;
  onConflict?: InputMaybe<CustomerOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDeviceArgs = {
  objects: Array<DeviceInsertInput>;
  onConflict?: InputMaybe<DeviceOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDeviceOneArgs = {
  object: DeviceInsertInput;
  onConflict?: InputMaybe<DeviceOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDeviceStatusArgs = {
  objects: Array<DeviceStatusInsertInput>;
  onConflict?: InputMaybe<DeviceStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDeviceStatusOneArgs = {
  object: DeviceStatusInsertInput;
  onConflict?: InputMaybe<DeviceStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMediaArgs = {
  objects: Array<MediaInsertInput>;
  onConflict?: InputMaybe<MediaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMediaOneArgs = {
  object: MediaInsertInput;
  onConflict?: InputMaybe<MediaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRoiArgs = {
  objects: Array<RoiInsertInput>;
  onConflict?: InputMaybe<RoiOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRoiOneArgs = {
  object: RoiInsertInput;
  onConflict?: InputMaybe<RoiOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSiteArgs = {
  objects: Array<SiteInsertInput>;
  onConflict?: InputMaybe<SiteOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSiteOneArgs = {
  object: SiteInsertInput;
  onConflict?: InputMaybe<SiteOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserDeviceLinkArgs = {
  objects: Array<UserDeviceLinkInsertInput>;
  onConflict?: InputMaybe<UserDeviceLinkOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserDeviceLinkOneArgs = {
  object: UserDeviceLinkInsertInput;
  onConflict?: InputMaybe<UserDeviceLinkOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertZoneArgs = {
  objects: Array<ZoneInsertInput>;
  onConflict?: InputMaybe<ZoneOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertZoneOneArgs = {
  object: ZoneInsertInput;
  onConflict?: InputMaybe<ZoneOnConflict>;
};


/** mutation root */
export type Mutation_RootInvalidateCustomerSecretCacheArgs = {
  input: InvalidateCustomerSecretCacheInput;
};


/** mutation root */
export type Mutation_RootInvalidateDeviceCacheArgs = {
  input: InvalidateDeviceCacheInput;
};


/** mutation root */
export type Mutation_RootUpdateApiKeyArgs = {
  _inc?: InputMaybe<ApiKeyIncInput>;
  _set?: InputMaybe<ApiKeySetInput>;
  where: ApiKeyBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateApiKeyByPkArgs = {
  _inc?: InputMaybe<ApiKeyIncInput>;
  _set?: InputMaybe<ApiKeySetInput>;
  pkColumns: ApiKeyPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateApiKeyManyArgs = {
  updates: Array<ApiKeyUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAspNetRoleClaimsArgs = {
  _inc?: InputMaybe<AspNetRoleClaimsIncInput>;
  _set?: InputMaybe<AspNetRoleClaimsSetInput>;
  where: AspNetRoleClaimsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAspNetRoleClaimsByPkArgs = {
  _inc?: InputMaybe<AspNetRoleClaimsIncInput>;
  _set?: InputMaybe<AspNetRoleClaimsSetInput>;
  pkColumns: AspNetRoleClaimsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAspNetRoleClaimsManyArgs = {
  updates: Array<AspNetRoleClaimsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAspNetRolesArgs = {
  _set?: InputMaybe<AspNetRolesSetInput>;
  where: AspNetRolesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAspNetRolesByPkArgs = {
  _set?: InputMaybe<AspNetRolesSetInput>;
  pkColumns: AspNetRolesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAspNetRolesManyArgs = {
  updates: Array<AspNetRolesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserClaimsArgs = {
  _inc?: InputMaybe<AspNetUserClaimsIncInput>;
  _set?: InputMaybe<AspNetUserClaimsSetInput>;
  where: AspNetUserClaimsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserClaimsByPkArgs = {
  _inc?: InputMaybe<AspNetUserClaimsIncInput>;
  _set?: InputMaybe<AspNetUserClaimsSetInput>;
  pkColumns: AspNetUserClaimsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserClaimsManyArgs = {
  updates: Array<AspNetUserClaimsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserLoginsArgs = {
  _set?: InputMaybe<AspNetUserLoginsSetInput>;
  where: AspNetUserLoginsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserLoginsByPkArgs = {
  _set?: InputMaybe<AspNetUserLoginsSetInput>;
  pkColumns: AspNetUserLoginsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserLoginsManyArgs = {
  updates: Array<AspNetUserLoginsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserRolesArgs = {
  _set?: InputMaybe<AspNetUserRolesSetInput>;
  where: AspNetUserRolesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserRolesByPkArgs = {
  _set?: InputMaybe<AspNetUserRolesSetInput>;
  pkColumns: AspNetUserRolesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserRolesManyArgs = {
  updates: Array<AspNetUserRolesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserTokensArgs = {
  _set?: InputMaybe<AspNetUserTokensSetInput>;
  where: AspNetUserTokensBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserTokensByPkArgs = {
  _set?: InputMaybe<AspNetUserTokensSetInput>;
  pkColumns: AspNetUserTokensPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUserTokensManyArgs = {
  updates: Array<AspNetUserTokensUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUsersArgs = {
  _inc?: InputMaybe<AspNetUsersIncInput>;
  _set?: InputMaybe<AspNetUsersSetInput>;
  where: AspNetUsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUsersByPkArgs = {
  _inc?: InputMaybe<AspNetUsersIncInput>;
  _set?: InputMaybe<AspNetUsersSetInput>;
  pkColumns: AspNetUsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAspNetUsersManyArgs = {
  updates: Array<AspNetUsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAuditLogArgs = {
  _append?: InputMaybe<AuditLogAppendInput>;
  _deleteAtPath?: InputMaybe<AuditLogDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AuditLogDeleteElemInput>;
  _deleteKey?: InputMaybe<AuditLogDeleteKeyInput>;
  _prepend?: InputMaybe<AuditLogPrependInput>;
  _set?: InputMaybe<AuditLogSetInput>;
  where: AuditLogBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAuditLogByPkArgs = {
  _append?: InputMaybe<AuditLogAppendInput>;
  _deleteAtPath?: InputMaybe<AuditLogDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AuditLogDeleteElemInput>;
  _deleteKey?: InputMaybe<AuditLogDeleteKeyInput>;
  _prepend?: InputMaybe<AuditLogPrependInput>;
  _set?: InputMaybe<AuditLogSetInput>;
  pkColumns: AuditLogPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAuditLogManyArgs = {
  updates: Array<AuditLogUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCustomerArgs = {
  _append?: InputMaybe<CustomerAppendInput>;
  _deleteAtPath?: InputMaybe<CustomerDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CustomerDeleteElemInput>;
  _deleteKey?: InputMaybe<CustomerDeleteKeyInput>;
  _prepend?: InputMaybe<CustomerPrependInput>;
  _set?: InputMaybe<CustomerSetInput>;
  where: CustomerBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCustomerByPkArgs = {
  _append?: InputMaybe<CustomerAppendInput>;
  _deleteAtPath?: InputMaybe<CustomerDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CustomerDeleteElemInput>;
  _deleteKey?: InputMaybe<CustomerDeleteKeyInput>;
  _prepend?: InputMaybe<CustomerPrependInput>;
  _set?: InputMaybe<CustomerSetInput>;
  pkColumns: CustomerPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCustomerManyArgs = {
  updates: Array<CustomerUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDeviceArgs = {
  _append?: InputMaybe<DeviceAppendInput>;
  _deleteAtPath?: InputMaybe<DeviceDeleteAtPathInput>;
  _deleteElem?: InputMaybe<DeviceDeleteElemInput>;
  _deleteKey?: InputMaybe<DeviceDeleteKeyInput>;
  _prepend?: InputMaybe<DevicePrependInput>;
  _set?: InputMaybe<DeviceSetInput>;
  where: DeviceBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDeviceByPkArgs = {
  _append?: InputMaybe<DeviceAppendInput>;
  _deleteAtPath?: InputMaybe<DeviceDeleteAtPathInput>;
  _deleteElem?: InputMaybe<DeviceDeleteElemInput>;
  _deleteKey?: InputMaybe<DeviceDeleteKeyInput>;
  _prepend?: InputMaybe<DevicePrependInput>;
  _set?: InputMaybe<DeviceSetInput>;
  pkColumns: DevicePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDeviceManyArgs = {
  updates: Array<DeviceUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDeviceStatusArgs = {
  _append?: InputMaybe<DeviceStatusAppendInput>;
  _deleteAtPath?: InputMaybe<DeviceStatusDeleteAtPathInput>;
  _deleteElem?: InputMaybe<DeviceStatusDeleteElemInput>;
  _deleteKey?: InputMaybe<DeviceStatusDeleteKeyInput>;
  _prepend?: InputMaybe<DeviceStatusPrependInput>;
  _set?: InputMaybe<DeviceStatusSetInput>;
  where: DeviceStatusBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDeviceStatusByPkArgs = {
  _append?: InputMaybe<DeviceStatusAppendInput>;
  _deleteAtPath?: InputMaybe<DeviceStatusDeleteAtPathInput>;
  _deleteElem?: InputMaybe<DeviceStatusDeleteElemInput>;
  _deleteKey?: InputMaybe<DeviceStatusDeleteKeyInput>;
  _prepend?: InputMaybe<DeviceStatusPrependInput>;
  _set?: InputMaybe<DeviceStatusSetInput>;
  pkColumns: DeviceStatusPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDeviceStatusManyArgs = {
  updates: Array<DeviceStatusUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMediaArgs = {
  _inc?: InputMaybe<MediaIncInput>;
  _set?: InputMaybe<MediaSetInput>;
  where: MediaBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMediaByPkArgs = {
  _inc?: InputMaybe<MediaIncInput>;
  _set?: InputMaybe<MediaSetInput>;
  pkColumns: MediaPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMediaManyArgs = {
  updates: Array<MediaUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRoiArgs = {
  _append?: InputMaybe<RoiAppendInput>;
  _deleteAtPath?: InputMaybe<RoiDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RoiDeleteElemInput>;
  _deleteKey?: InputMaybe<RoiDeleteKeyInput>;
  _prepend?: InputMaybe<RoiPrependInput>;
  _set?: InputMaybe<RoiSetInput>;
  where: RoiBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRoiByPkArgs = {
  _append?: InputMaybe<RoiAppendInput>;
  _deleteAtPath?: InputMaybe<RoiDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RoiDeleteElemInput>;
  _deleteKey?: InputMaybe<RoiDeleteKeyInput>;
  _prepend?: InputMaybe<RoiPrependInput>;
  _set?: InputMaybe<RoiSetInput>;
  pkColumns: RoiPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRoiManyArgs = {
  updates: Array<RoiUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSiteArgs = {
  _append?: InputMaybe<SiteAppendInput>;
  _deleteAtPath?: InputMaybe<SiteDeleteAtPathInput>;
  _deleteElem?: InputMaybe<SiteDeleteElemInput>;
  _deleteKey?: InputMaybe<SiteDeleteKeyInput>;
  _prepend?: InputMaybe<SitePrependInput>;
  _set?: InputMaybe<SiteSetInput>;
  where: SiteBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSiteByPkArgs = {
  _append?: InputMaybe<SiteAppendInput>;
  _deleteAtPath?: InputMaybe<SiteDeleteAtPathInput>;
  _deleteElem?: InputMaybe<SiteDeleteElemInput>;
  _deleteKey?: InputMaybe<SiteDeleteKeyInput>;
  _prepend?: InputMaybe<SitePrependInput>;
  _set?: InputMaybe<SiteSetInput>;
  pkColumns: SitePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSiteManyArgs = {
  updates: Array<SiteUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserDeviceLinkArgs = {
  _set?: InputMaybe<UserDeviceLinkSetInput>;
  where: UserDeviceLinkBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserDeviceLinkByPkArgs = {
  _set?: InputMaybe<UserDeviceLinkSetInput>;
  pkColumns: UserDeviceLinkPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserDeviceLinkManyArgs = {
  updates: Array<UserDeviceLinkUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateZoneArgs = {
  _set?: InputMaybe<ZoneSetInput>;
  where: ZoneBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateZoneByPkArgs = {
  _set?: InputMaybe<ZoneSetInput>;
  pkColumns: ZonePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateZoneManyArgs = {
  updates: Array<ZoneUpdates>;
};


/** mutation root */
export type Mutation_RootUpsertCustomerS3BucketArgs = {
  input: CreateCustomerS3BucketInput;
};


/** mutation root */
export type Mutation_RootUpsertCustomerSecretArgs = {
  input: UpsertCustomerSecretInput;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "ApiKey" */
  apiKey: Array<ApiKey>;
  /** fetch aggregated fields from the table: "ApiKey" */
  apiKeyAggregate: ApiKeyAggregate;
  /** fetch data from the table: "ApiKey" using primary key columns */
  apiKeyByPk?: Maybe<ApiKey>;
  /** fetch data from the table: "AspNetRoleClaims" */
  aspNetRoleClaims: Array<AspNetRoleClaims>;
  /** fetch aggregated fields from the table: "AspNetRoleClaims" */
  aspNetRoleClaimsAggregate: AspNetRoleClaimsAggregate;
  /** fetch data from the table: "AspNetRoleClaims" using primary key columns */
  aspNetRoleClaimsByPk?: Maybe<AspNetRoleClaims>;
  /** fetch data from the table: "AspNetRoles" */
  aspNetRoles: Array<AspNetRoles>;
  /** fetch aggregated fields from the table: "AspNetRoles" */
  aspNetRolesAggregate: AspNetRolesAggregate;
  /** fetch data from the table: "AspNetRoles" using primary key columns */
  aspNetRolesByPk?: Maybe<AspNetRoles>;
  /** fetch data from the table: "AspNetUserClaims" */
  aspNetUserClaims: Array<AspNetUserClaims>;
  /** fetch aggregated fields from the table: "AspNetUserClaims" */
  aspNetUserClaimsAggregate: AspNetUserClaimsAggregate;
  /** fetch data from the table: "AspNetUserClaims" using primary key columns */
  aspNetUserClaimsByPk?: Maybe<AspNetUserClaims>;
  /** fetch data from the table: "AspNetUserLogins" */
  aspNetUserLogins: Array<AspNetUserLogins>;
  /** fetch aggregated fields from the table: "AspNetUserLogins" */
  aspNetUserLoginsAggregate: AspNetUserLoginsAggregate;
  /** fetch data from the table: "AspNetUserLogins" using primary key columns */
  aspNetUserLoginsByPk?: Maybe<AspNetUserLogins>;
  /** An array relationship */
  aspNetUserRoles: Array<AspNetUserRoles>;
  /** An aggregate relationship */
  aspNetUserRolesAggregate: AspNetUserRolesAggregate;
  /** fetch data from the table: "AspNetUserRoles" using primary key columns */
  aspNetUserRolesByPk?: Maybe<AspNetUserRoles>;
  /** fetch data from the table: "AspNetUserTokens" */
  aspNetUserTokens: Array<AspNetUserTokens>;
  /** fetch aggregated fields from the table: "AspNetUserTokens" */
  aspNetUserTokensAggregate: AspNetUserTokensAggregate;
  /** fetch data from the table: "AspNetUserTokens" using primary key columns */
  aspNetUserTokensByPk?: Maybe<AspNetUserTokens>;
  /** fetch data from the table: "AspNetUsers" */
  aspNetUsers: Array<AspNetUsers>;
  /** fetch aggregated fields from the table: "AspNetUsers" */
  aspNetUsersAggregate: AspNetUsersAggregate;
  /** fetch data from the table: "AspNetUsers" using primary key columns */
  aspNetUsersByPk?: Maybe<AspNetUsers>;
  /** fetch data from the table: "AuditLog" */
  auditLog: Array<AuditLog>;
  /** fetch aggregated fields from the table: "AuditLog" */
  auditLogAggregate: AuditLogAggregate;
  /** fetch data from the table: "AuditLog" using primary key columns */
  auditLogByPk?: Maybe<AuditLog>;
  /** fetch data from the table: "Customer" */
  customer: Array<Customer>;
  /** fetch aggregated fields from the table: "Customer" */
  customerAggregate: CustomerAggregate;
  /** fetch data from the table: "Customer" using primary key columns */
  customerByPk?: Maybe<Customer>;
  /** fetch data from the table: "Device" */
  device: Array<Device>;
  /** fetch aggregated fields from the table: "Device" */
  deviceAggregate: DeviceAggregate;
  /** fetch data from the table: "Device" using primary key columns */
  deviceByPk?: Maybe<Device>;
  /** fetch data from the table: "DeviceLastImage" */
  deviceLastImage: Array<DeviceLastImage>;
  /** fetch aggregated fields from the table: "DeviceLastImage" */
  deviceLastImageAggregate: DeviceLastImageAggregate;
  /** fetch data from the table: "DeviceLastMedia" */
  deviceLastMedia: Array<DeviceLastMedia>;
  /** fetch aggregated fields from the table: "DeviceLastMedia" */
  deviceLastMediaAggregate: DeviceLastMediaAggregate;
  /** fetch data from the table: "DeviceStatus" */
  deviceStatus: Array<DeviceStatus>;
  /** fetch aggregated fields from the table: "DeviceStatus" */
  deviceStatusAggregate: DeviceStatusAggregate;
  /** fetch data from the table: "DeviceStatus" using primary key columns */
  deviceStatusByPk?: Maybe<DeviceStatus>;
  /** An array relationship */
  media: Array<Media>;
  /** An aggregate relationship */
  mediaAggregate: MediaAggregate;
  /** fetch data from the table: "Media" using primary key columns */
  mediaByPk?: Maybe<Media>;
  /** fetch data from the table: "Roi" */
  roi: Array<Roi>;
  /** fetch aggregated fields from the table: "Roi" */
  roiAggregate: RoiAggregate;
  /** fetch data from the table: "Roi" using primary key columns */
  roiByPk?: Maybe<Roi>;
  senpicSnZones: Array<SnZone>;
  serverTime: Scalars['String']['output'];
  /** fetch data from the table: "Site" */
  site: Array<Site>;
  /** fetch aggregated fields from the table: "Site" */
  siteAggregate: SiteAggregate;
  /** fetch data from the table: "Site" using primary key columns */
  siteByPk?: Maybe<Site>;
  snZones: Array<SnZone>;
  /** fetch data from the table: "UserDeviceLink" */
  userDeviceLink: Array<UserDeviceLink>;
  /** fetch aggregated fields from the table: "UserDeviceLink" */
  userDeviceLinkAggregate: UserDeviceLinkAggregate;
  /** fetch data from the table: "UserDeviceLink" using primary key columns */
  userDeviceLinkByPk?: Maybe<UserDeviceLink>;
  /** fetch data from the table: "Zone" */
  zone: Array<Zone>;
  /** fetch aggregated fields from the table: "Zone" */
  zoneAggregate: ZoneAggregate;
  /** fetch data from the table: "Zone" using primary key columns */
  zoneByPk?: Maybe<Zone>;
};


export type Query_RootApiKeyArgs = {
  distinctOn?: InputMaybe<Array<ApiKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderBy>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


export type Query_RootApiKeyAggregateArgs = {
  distinctOn?: InputMaybe<Array<ApiKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderBy>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


export type Query_RootApiKeyByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAspNetRoleClaimsArgs = {
  distinctOn?: InputMaybe<Array<AspNetRoleClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetRoleClaimsOrderBy>>;
  where?: InputMaybe<AspNetRoleClaimsBoolExp>;
};


export type Query_RootAspNetRoleClaimsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetRoleClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetRoleClaimsOrderBy>>;
  where?: InputMaybe<AspNetRoleClaimsBoolExp>;
};


export type Query_RootAspNetRoleClaimsByPkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootAspNetRolesArgs = {
  distinctOn?: InputMaybe<Array<AspNetRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetRolesOrderBy>>;
  where?: InputMaybe<AspNetRolesBoolExp>;
};


export type Query_RootAspNetRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetRolesOrderBy>>;
  where?: InputMaybe<AspNetRolesBoolExp>;
};


export type Query_RootAspNetRolesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAspNetUserClaimsArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserClaimsOrderBy>>;
  where?: InputMaybe<AspNetUserClaimsBoolExp>;
};


export type Query_RootAspNetUserClaimsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserClaimsOrderBy>>;
  where?: InputMaybe<AspNetUserClaimsBoolExp>;
};


export type Query_RootAspNetUserClaimsByPkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootAspNetUserLoginsArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserLoginsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserLoginsOrderBy>>;
  where?: InputMaybe<AspNetUserLoginsBoolExp>;
};


export type Query_RootAspNetUserLoginsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserLoginsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserLoginsOrderBy>>;
  where?: InputMaybe<AspNetUserLoginsBoolExp>;
};


export type Query_RootAspNetUserLoginsByPkArgs = {
  loginProvider: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
};


export type Query_RootAspNetUserRolesArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserRolesOrderBy>>;
  where?: InputMaybe<AspNetUserRolesBoolExp>;
};


export type Query_RootAspNetUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserRolesOrderBy>>;
  where?: InputMaybe<AspNetUserRolesBoolExp>;
};


export type Query_RootAspNetUserRolesByPkArgs = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootAspNetUserTokensArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserTokensOrderBy>>;
  where?: InputMaybe<AspNetUserTokensBoolExp>;
};


export type Query_RootAspNetUserTokensAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserTokensOrderBy>>;
  where?: InputMaybe<AspNetUserTokensBoolExp>;
};


export type Query_RootAspNetUserTokensByPkArgs = {
  loginProvider: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Query_RootAspNetUsersArgs = {
  distinctOn?: InputMaybe<Array<AspNetUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUsersOrderBy>>;
  where?: InputMaybe<AspNetUsersBoolExp>;
};


export type Query_RootAspNetUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUsersOrderBy>>;
  where?: InputMaybe<AspNetUsersBoolExp>;
};


export type Query_RootAspNetUsersByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootAuditLogArgs = {
  distinctOn?: InputMaybe<Array<AuditLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditLogOrderBy>>;
  where?: InputMaybe<AuditLogBoolExp>;
};


export type Query_RootAuditLogAggregateArgs = {
  distinctOn?: InputMaybe<Array<AuditLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditLogOrderBy>>;
  where?: InputMaybe<AuditLogBoolExp>;
};


export type Query_RootAuditLogByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustomerArgs = {
  distinctOn?: InputMaybe<Array<CustomerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerOrderBy>>;
  where?: InputMaybe<CustomerBoolExp>;
};


export type Query_RootCustomerAggregateArgs = {
  distinctOn?: InputMaybe<Array<CustomerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerOrderBy>>;
  where?: InputMaybe<CustomerBoolExp>;
};


export type Query_RootCustomerByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDeviceArgs = {
  distinctOn?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type Query_RootDeviceAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type Query_RootDeviceByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDeviceLastImageArgs = {
  distinctOn?: InputMaybe<Array<DeviceLastImageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceLastImageOrderBy>>;
  where?: InputMaybe<DeviceLastImageBoolExp>;
};


export type Query_RootDeviceLastImageAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceLastImageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceLastImageOrderBy>>;
  where?: InputMaybe<DeviceLastImageBoolExp>;
};


export type Query_RootDeviceLastMediaArgs = {
  distinctOn?: InputMaybe<Array<DeviceLastMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceLastMediaOrderBy>>;
  where?: InputMaybe<DeviceLastMediaBoolExp>;
};


export type Query_RootDeviceLastMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceLastMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceLastMediaOrderBy>>;
  where?: InputMaybe<DeviceLastMediaBoolExp>;
};


export type Query_RootDeviceStatusArgs = {
  distinctOn?: InputMaybe<Array<DeviceStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceStatusOrderBy>>;
  where?: InputMaybe<DeviceStatusBoolExp>;
};


export type Query_RootDeviceStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceStatusOrderBy>>;
  where?: InputMaybe<DeviceStatusBoolExp>;
};


export type Query_RootDeviceStatusByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMediaArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Query_RootMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Query_RootMediaByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoiArgs = {
  distinctOn?: InputMaybe<Array<RoiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoiOrderBy>>;
  where?: InputMaybe<RoiBoolExp>;
};


export type Query_RootRoiAggregateArgs = {
  distinctOn?: InputMaybe<Array<RoiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoiOrderBy>>;
  where?: InputMaybe<RoiBoolExp>;
};


export type Query_RootRoiByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSenpicSnZonesArgs = {
  deviceId: Scalars['UUID']['input'];
  distanceWithinMeters: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type Query_RootSiteArgs = {
  distinctOn?: InputMaybe<Array<SiteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SiteOrderBy>>;
  where?: InputMaybe<SiteBoolExp>;
};


export type Query_RootSiteAggregateArgs = {
  distinctOn?: InputMaybe<Array<SiteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SiteOrderBy>>;
  where?: InputMaybe<SiteBoolExp>;
};


export type Query_RootSiteByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSnZonesArgs = {
  deviceId: Scalars['UUID']['input'];
  distanceWithinMeters: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type Query_RootUserDeviceLinkArgs = {
  distinctOn?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserDeviceLinkOrderBy>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};


export type Query_RootUserDeviceLinkAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserDeviceLinkOrderBy>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};


export type Query_RootUserDeviceLinkByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootZoneArgs = {
  distinctOn?: InputMaybe<Array<ZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZoneOrderBy>>;
  where?: InputMaybe<ZoneBoolExp>;
};


export type Query_RootZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZoneOrderBy>>;
  where?: InputMaybe<ZoneBoolExp>;
};


export type Query_RootZoneByPkArgs = {
  id: Scalars['uuid']['input'];
};

export type RoiAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RoiSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RoiBoolExp>;
  predicate: IntComparisonExp;
};

export type SiteAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SiteSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SiteBoolExp>;
  predicate: IntComparisonExp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "ApiKey" */
  apiKey: Array<ApiKey>;
  /** fetch aggregated fields from the table: "ApiKey" */
  apiKeyAggregate: ApiKeyAggregate;
  /** fetch data from the table: "ApiKey" using primary key columns */
  apiKeyByPk?: Maybe<ApiKey>;
  /** fetch data from the table in a streaming manner: "ApiKey" */
  apiKeyStream: Array<ApiKey>;
  /** fetch data from the table: "AspNetRoleClaims" */
  aspNetRoleClaims: Array<AspNetRoleClaims>;
  /** fetch aggregated fields from the table: "AspNetRoleClaims" */
  aspNetRoleClaimsAggregate: AspNetRoleClaimsAggregate;
  /** fetch data from the table: "AspNetRoleClaims" using primary key columns */
  aspNetRoleClaimsByPk?: Maybe<AspNetRoleClaims>;
  /** fetch data from the table in a streaming manner: "AspNetRoleClaims" */
  aspNetRoleClaimsStream: Array<AspNetRoleClaims>;
  /** fetch data from the table: "AspNetRoles" */
  aspNetRoles: Array<AspNetRoles>;
  /** fetch aggregated fields from the table: "AspNetRoles" */
  aspNetRolesAggregate: AspNetRolesAggregate;
  /** fetch data from the table: "AspNetRoles" using primary key columns */
  aspNetRolesByPk?: Maybe<AspNetRoles>;
  /** fetch data from the table in a streaming manner: "AspNetRoles" */
  aspNetRolesStream: Array<AspNetRoles>;
  /** fetch data from the table: "AspNetUserClaims" */
  aspNetUserClaims: Array<AspNetUserClaims>;
  /** fetch aggregated fields from the table: "AspNetUserClaims" */
  aspNetUserClaimsAggregate: AspNetUserClaimsAggregate;
  /** fetch data from the table: "AspNetUserClaims" using primary key columns */
  aspNetUserClaimsByPk?: Maybe<AspNetUserClaims>;
  /** fetch data from the table in a streaming manner: "AspNetUserClaims" */
  aspNetUserClaimsStream: Array<AspNetUserClaims>;
  /** fetch data from the table: "AspNetUserLogins" */
  aspNetUserLogins: Array<AspNetUserLogins>;
  /** fetch aggregated fields from the table: "AspNetUserLogins" */
  aspNetUserLoginsAggregate: AspNetUserLoginsAggregate;
  /** fetch data from the table: "AspNetUserLogins" using primary key columns */
  aspNetUserLoginsByPk?: Maybe<AspNetUserLogins>;
  /** fetch data from the table in a streaming manner: "AspNetUserLogins" */
  aspNetUserLoginsStream: Array<AspNetUserLogins>;
  /** An array relationship */
  aspNetUserRoles: Array<AspNetUserRoles>;
  /** An aggregate relationship */
  aspNetUserRolesAggregate: AspNetUserRolesAggregate;
  /** fetch data from the table: "AspNetUserRoles" using primary key columns */
  aspNetUserRolesByPk?: Maybe<AspNetUserRoles>;
  /** fetch data from the table in a streaming manner: "AspNetUserRoles" */
  aspNetUserRolesStream: Array<AspNetUserRoles>;
  /** fetch data from the table: "AspNetUserTokens" */
  aspNetUserTokens: Array<AspNetUserTokens>;
  /** fetch aggregated fields from the table: "AspNetUserTokens" */
  aspNetUserTokensAggregate: AspNetUserTokensAggregate;
  /** fetch data from the table: "AspNetUserTokens" using primary key columns */
  aspNetUserTokensByPk?: Maybe<AspNetUserTokens>;
  /** fetch data from the table in a streaming manner: "AspNetUserTokens" */
  aspNetUserTokensStream: Array<AspNetUserTokens>;
  /** fetch data from the table: "AspNetUsers" */
  aspNetUsers: Array<AspNetUsers>;
  /** fetch aggregated fields from the table: "AspNetUsers" */
  aspNetUsersAggregate: AspNetUsersAggregate;
  /** fetch data from the table: "AspNetUsers" using primary key columns */
  aspNetUsersByPk?: Maybe<AspNetUsers>;
  /** fetch data from the table in a streaming manner: "AspNetUsers" */
  aspNetUsersStream: Array<AspNetUsers>;
  /** fetch data from the table: "AuditLog" */
  auditLog: Array<AuditLog>;
  /** fetch aggregated fields from the table: "AuditLog" */
  auditLogAggregate: AuditLogAggregate;
  /** fetch data from the table: "AuditLog" using primary key columns */
  auditLogByPk?: Maybe<AuditLog>;
  /** fetch data from the table in a streaming manner: "AuditLog" */
  auditLogStream: Array<AuditLog>;
  /** fetch data from the table: "Customer" */
  customer: Array<Customer>;
  /** fetch aggregated fields from the table: "Customer" */
  customerAggregate: CustomerAggregate;
  /** fetch data from the table: "Customer" using primary key columns */
  customerByPk?: Maybe<Customer>;
  /** fetch data from the table in a streaming manner: "Customer" */
  customerStream: Array<Customer>;
  /** fetch data from the table: "Device" */
  device: Array<Device>;
  /** fetch aggregated fields from the table: "Device" */
  deviceAggregate: DeviceAggregate;
  /** fetch data from the table: "Device" using primary key columns */
  deviceByPk?: Maybe<Device>;
  /** fetch data from the table: "DeviceLastImage" */
  deviceLastImage: Array<DeviceLastImage>;
  /** fetch aggregated fields from the table: "DeviceLastImage" */
  deviceLastImageAggregate: DeviceLastImageAggregate;
  /** fetch data from the table in a streaming manner: "DeviceLastImage" */
  deviceLastImageStream: Array<DeviceLastImage>;
  /** fetch data from the table: "DeviceLastMedia" */
  deviceLastMedia: Array<DeviceLastMedia>;
  /** fetch aggregated fields from the table: "DeviceLastMedia" */
  deviceLastMediaAggregate: DeviceLastMediaAggregate;
  /** fetch data from the table in a streaming manner: "DeviceLastMedia" */
  deviceLastMediaStream: Array<DeviceLastMedia>;
  /** fetch data from the table: "DeviceStatus" */
  deviceStatus: Array<DeviceStatus>;
  /** fetch aggregated fields from the table: "DeviceStatus" */
  deviceStatusAggregate: DeviceStatusAggregate;
  /** fetch data from the table: "DeviceStatus" using primary key columns */
  deviceStatusByPk?: Maybe<DeviceStatus>;
  /** fetch data from the table in a streaming manner: "DeviceStatus" */
  deviceStatusStream: Array<DeviceStatus>;
  /** fetch data from the table in a streaming manner: "Device" */
  deviceStream: Array<Device>;
  /** An array relationship */
  media: Array<Media>;
  /** An aggregate relationship */
  mediaAggregate: MediaAggregate;
  /** fetch data from the table: "Media" using primary key columns */
  mediaByPk?: Maybe<Media>;
  /** fetch data from the table in a streaming manner: "Media" */
  mediaStream: Array<Media>;
  /** fetch data from the table: "Roi" */
  roi: Array<Roi>;
  /** fetch aggregated fields from the table: "Roi" */
  roiAggregate: RoiAggregate;
  /** fetch data from the table: "Roi" using primary key columns */
  roiByPk?: Maybe<Roi>;
  /** fetch data from the table in a streaming manner: "Roi" */
  roiStream: Array<Roi>;
  /** fetch data from the table: "Site" */
  site: Array<Site>;
  /** fetch aggregated fields from the table: "Site" */
  siteAggregate: SiteAggregate;
  /** fetch data from the table: "Site" using primary key columns */
  siteByPk?: Maybe<Site>;
  /** fetch data from the table in a streaming manner: "Site" */
  siteStream: Array<Site>;
  /** fetch data from the table: "UserDeviceLink" */
  userDeviceLink: Array<UserDeviceLink>;
  /** fetch aggregated fields from the table: "UserDeviceLink" */
  userDeviceLinkAggregate: UserDeviceLinkAggregate;
  /** fetch data from the table: "UserDeviceLink" using primary key columns */
  userDeviceLinkByPk?: Maybe<UserDeviceLink>;
  /** fetch data from the table in a streaming manner: "UserDeviceLink" */
  userDeviceLinkStream: Array<UserDeviceLink>;
  /** fetch data from the table: "Zone" */
  zone: Array<Zone>;
  /** fetch aggregated fields from the table: "Zone" */
  zoneAggregate: ZoneAggregate;
  /** fetch data from the table: "Zone" using primary key columns */
  zoneByPk?: Maybe<Zone>;
  /** fetch data from the table in a streaming manner: "Zone" */
  zoneStream: Array<Zone>;
};


export type Subscription_RootApiKeyArgs = {
  distinctOn?: InputMaybe<Array<ApiKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderBy>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


export type Subscription_RootApiKeyAggregateArgs = {
  distinctOn?: InputMaybe<Array<ApiKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderBy>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


export type Subscription_RootApiKeyByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootApiKeyStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ApiKeyStreamCursorInput>>;
  where?: InputMaybe<ApiKeyBoolExp>;
};


export type Subscription_RootAspNetRoleClaimsArgs = {
  distinctOn?: InputMaybe<Array<AspNetRoleClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetRoleClaimsOrderBy>>;
  where?: InputMaybe<AspNetRoleClaimsBoolExp>;
};


export type Subscription_RootAspNetRoleClaimsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetRoleClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetRoleClaimsOrderBy>>;
  where?: InputMaybe<AspNetRoleClaimsBoolExp>;
};


export type Subscription_RootAspNetRoleClaimsByPkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAspNetRoleClaimsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AspNetRoleClaimsStreamCursorInput>>;
  where?: InputMaybe<AspNetRoleClaimsBoolExp>;
};


export type Subscription_RootAspNetRolesArgs = {
  distinctOn?: InputMaybe<Array<AspNetRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetRolesOrderBy>>;
  where?: InputMaybe<AspNetRolesBoolExp>;
};


export type Subscription_RootAspNetRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetRolesOrderBy>>;
  where?: InputMaybe<AspNetRolesBoolExp>;
};


export type Subscription_RootAspNetRolesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAspNetRolesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AspNetRolesStreamCursorInput>>;
  where?: InputMaybe<AspNetRolesBoolExp>;
};


export type Subscription_RootAspNetUserClaimsArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserClaimsOrderBy>>;
  where?: InputMaybe<AspNetUserClaimsBoolExp>;
};


export type Subscription_RootAspNetUserClaimsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserClaimsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserClaimsOrderBy>>;
  where?: InputMaybe<AspNetUserClaimsBoolExp>;
};


export type Subscription_RootAspNetUserClaimsByPkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAspNetUserClaimsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AspNetUserClaimsStreamCursorInput>>;
  where?: InputMaybe<AspNetUserClaimsBoolExp>;
};


export type Subscription_RootAspNetUserLoginsArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserLoginsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserLoginsOrderBy>>;
  where?: InputMaybe<AspNetUserLoginsBoolExp>;
};


export type Subscription_RootAspNetUserLoginsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserLoginsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserLoginsOrderBy>>;
  where?: InputMaybe<AspNetUserLoginsBoolExp>;
};


export type Subscription_RootAspNetUserLoginsByPkArgs = {
  loginProvider: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
};


export type Subscription_RootAspNetUserLoginsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AspNetUserLoginsStreamCursorInput>>;
  where?: InputMaybe<AspNetUserLoginsBoolExp>;
};


export type Subscription_RootAspNetUserRolesArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserRolesOrderBy>>;
  where?: InputMaybe<AspNetUserRolesBoolExp>;
};


export type Subscription_RootAspNetUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserRolesOrderBy>>;
  where?: InputMaybe<AspNetUserRolesBoolExp>;
};


export type Subscription_RootAspNetUserRolesByPkArgs = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Subscription_RootAspNetUserRolesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AspNetUserRolesStreamCursorInput>>;
  where?: InputMaybe<AspNetUserRolesBoolExp>;
};


export type Subscription_RootAspNetUserTokensArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserTokensOrderBy>>;
  where?: InputMaybe<AspNetUserTokensBoolExp>;
};


export type Subscription_RootAspNetUserTokensAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUserTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUserTokensOrderBy>>;
  where?: InputMaybe<AspNetUserTokensBoolExp>;
};


export type Subscription_RootAspNetUserTokensByPkArgs = {
  loginProvider: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type Subscription_RootAspNetUserTokensStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AspNetUserTokensStreamCursorInput>>;
  where?: InputMaybe<AspNetUserTokensBoolExp>;
};


export type Subscription_RootAspNetUsersArgs = {
  distinctOn?: InputMaybe<Array<AspNetUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUsersOrderBy>>;
  where?: InputMaybe<AspNetUsersBoolExp>;
};


export type Subscription_RootAspNetUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AspNetUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AspNetUsersOrderBy>>;
  where?: InputMaybe<AspNetUsersBoolExp>;
};


export type Subscription_RootAspNetUsersByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAspNetUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AspNetUsersStreamCursorInput>>;
  where?: InputMaybe<AspNetUsersBoolExp>;
};


export type Subscription_RootAuditLogArgs = {
  distinctOn?: InputMaybe<Array<AuditLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditLogOrderBy>>;
  where?: InputMaybe<AuditLogBoolExp>;
};


export type Subscription_RootAuditLogAggregateArgs = {
  distinctOn?: InputMaybe<Array<AuditLogSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditLogOrderBy>>;
  where?: InputMaybe<AuditLogBoolExp>;
};


export type Subscription_RootAuditLogByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuditLogStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuditLogStreamCursorInput>>;
  where?: InputMaybe<AuditLogBoolExp>;
};


export type Subscription_RootCustomerArgs = {
  distinctOn?: InputMaybe<Array<CustomerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerOrderBy>>;
  where?: InputMaybe<CustomerBoolExp>;
};


export type Subscription_RootCustomerAggregateArgs = {
  distinctOn?: InputMaybe<Array<CustomerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerOrderBy>>;
  where?: InputMaybe<CustomerBoolExp>;
};


export type Subscription_RootCustomerByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustomerStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CustomerStreamCursorInput>>;
  where?: InputMaybe<CustomerBoolExp>;
};


export type Subscription_RootDeviceArgs = {
  distinctOn?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type Subscription_RootDeviceAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrderBy>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type Subscription_RootDeviceByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDeviceLastImageArgs = {
  distinctOn?: InputMaybe<Array<DeviceLastImageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceLastImageOrderBy>>;
  where?: InputMaybe<DeviceLastImageBoolExp>;
};


export type Subscription_RootDeviceLastImageAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceLastImageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceLastImageOrderBy>>;
  where?: InputMaybe<DeviceLastImageBoolExp>;
};


export type Subscription_RootDeviceLastImageStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DeviceLastImageStreamCursorInput>>;
  where?: InputMaybe<DeviceLastImageBoolExp>;
};


export type Subscription_RootDeviceLastMediaArgs = {
  distinctOn?: InputMaybe<Array<DeviceLastMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceLastMediaOrderBy>>;
  where?: InputMaybe<DeviceLastMediaBoolExp>;
};


export type Subscription_RootDeviceLastMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceLastMediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceLastMediaOrderBy>>;
  where?: InputMaybe<DeviceLastMediaBoolExp>;
};


export type Subscription_RootDeviceLastMediaStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DeviceLastMediaStreamCursorInput>>;
  where?: InputMaybe<DeviceLastMediaBoolExp>;
};


export type Subscription_RootDeviceStatusArgs = {
  distinctOn?: InputMaybe<Array<DeviceStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceStatusOrderBy>>;
  where?: InputMaybe<DeviceStatusBoolExp>;
};


export type Subscription_RootDeviceStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<DeviceStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceStatusOrderBy>>;
  where?: InputMaybe<DeviceStatusBoolExp>;
};


export type Subscription_RootDeviceStatusByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDeviceStatusStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DeviceStatusStreamCursorInput>>;
  where?: InputMaybe<DeviceStatusBoolExp>;
};


export type Subscription_RootDeviceStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DeviceStreamCursorInput>>;
  where?: InputMaybe<DeviceBoolExp>;
};


export type Subscription_RootMediaArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Subscription_RootMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Subscription_RootMediaByPkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMediaStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MediaStreamCursorInput>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Subscription_RootRoiArgs = {
  distinctOn?: InputMaybe<Array<RoiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoiOrderBy>>;
  where?: InputMaybe<RoiBoolExp>;
};


export type Subscription_RootRoiAggregateArgs = {
  distinctOn?: InputMaybe<Array<RoiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoiOrderBy>>;
  where?: InputMaybe<RoiBoolExp>;
};


export type Subscription_RootRoiByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRoiStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoiStreamCursorInput>>;
  where?: InputMaybe<RoiBoolExp>;
};


export type Subscription_RootSiteArgs = {
  distinctOn?: InputMaybe<Array<SiteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SiteOrderBy>>;
  where?: InputMaybe<SiteBoolExp>;
};


export type Subscription_RootSiteAggregateArgs = {
  distinctOn?: InputMaybe<Array<SiteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SiteOrderBy>>;
  where?: InputMaybe<SiteBoolExp>;
};


export type Subscription_RootSiteByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSiteStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SiteStreamCursorInput>>;
  where?: InputMaybe<SiteBoolExp>;
};


export type Subscription_RootUserDeviceLinkArgs = {
  distinctOn?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserDeviceLinkOrderBy>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};


export type Subscription_RootUserDeviceLinkAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserDeviceLinkOrderBy>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};


export type Subscription_RootUserDeviceLinkByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUserDeviceLinkStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserDeviceLinkStreamCursorInput>>;
  where?: InputMaybe<UserDeviceLinkBoolExp>;
};


export type Subscription_RootZoneArgs = {
  distinctOn?: InputMaybe<Array<ZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZoneOrderBy>>;
  where?: InputMaybe<ZoneBoolExp>;
};


export type Subscription_RootZoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<ZoneSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZoneOrderBy>>;
  where?: InputMaybe<ZoneBoolExp>;
};


export type Subscription_RootZoneByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootZoneStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ZoneStreamCursorInput>>;
  where?: InputMaybe<ZoneBoolExp>;
};

export type UserDeviceLinkAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserDeviceLinkSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserDeviceLinkBoolExp>;
  predicate: IntComparisonExp;
};

export type InsertAuditLogMutationVariables = Exact<{
  inputs: Array<AuditLogInsertInput> | AuditLogInsertInput;
}>;


export type InsertAuditLogMutation = { __typename?: 'mutation_root', insertAuditLog?: { __typename?: 'AuditLogMutationResponse', affectedRows: number } | null };

export type AuditLogQueryVariables = Exact<{
  orderBy: Array<AuditLogOrderBy> | AuditLogOrderBy;
  where: AuditLogBoolExp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type AuditLogQuery = { __typename?: 'query_root', auditLog: Array<{ __typename?: 'AuditLog', id: string, action: string, createdAt: string, entities?: any | null, actorType: string, data: any, aspNetUser?: { __typename?: 'AspNetUsers', userName?: string | null } | null }>, auditLogAggregate: { __typename?: 'AuditLogAggregate', aggregate?: { __typename?: 'AuditLogAggregateFields', count: number } | null } };

export type AllUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserQuery = { __typename?: 'query_root', aspNetUsers: Array<{ __typename?: 'AspNetUsers', sub: string, userName?: string | null, aspNetUserRoles: Array<{ __typename?: 'AspNetUserRoles', aspNetRole: { __typename?: 'AspNetRoles', name?: string | null, normalizedName?: string | null } }> }> };

export type DeleteSitesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type DeleteSitesMutation = { __typename?: 'mutation_root', deleteSite?: { __typename?: 'SiteMutationResponse', affectedRows: number } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type CreateCustomerMutationVariables = Exact<{
  input: CustomerInsertInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type CreateCustomerMutation = { __typename?: 'mutation_root', insertCustomerOne?: { __typename?: 'Customer', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type CreateSiteMutationVariables = Exact<{
  inputs: SiteInsertInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type CreateSiteMutation = { __typename?: 'mutation_root', insertSiteOne?: { __typename?: 'Site', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type UpdateCustomerMutationVariables = Exact<{
  pkColumnInput: CustomerPkColumnsInput;
  setInput: CustomerSetInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'mutation_root', updateCustomerByPk?: { __typename?: 'Customer', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type CreateDeviceInBulkMutationVariables = Exact<{
  deviceInsertInputs: Array<DeviceInsertInput> | DeviceInsertInput;
  siteInsertInputs: Array<SiteInsertInput> | SiteInsertInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type CreateDeviceInBulkMutation = { __typename?: 'mutation_root', insertSite?: { __typename?: 'SiteMutationResponse', affectedRows: number } | null, insertDevice?: { __typename?: 'DeviceMutationResponse', returning: Array<{ __typename?: 'Device', id: string }> } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type DeleteCustomerMutation = { __typename?: 'mutation_root', deleteCustomerByPk?: { __typename?: 'Customer', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type UpsertCustomerS3BucketMutationVariables = Exact<{
  customerId: Scalars['UUID']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type UpsertCustomerS3BucketMutation = { __typename?: 'mutation_root', upsertCustomerS3Bucket: string, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type UpsertCustomerSecretMutationVariables = Exact<{
  input: UpsertCustomerSecretInput;
  invalidateCacheInput: InvalidateCustomerSecretCacheInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type UpsertCustomerSecretMutation = { __typename?: 'mutation_root', upsertCustomerSecret: { __typename?: 'UpsertCustomerSecretPayload', uri: string }, invalidateCustomerSecretCache: { __typename?: 'InvalidateCustomerSecretCachePayload', success: boolean }, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type DeleteCustomerSecretMutationVariables = Exact<{
  input: DeleteCustomerSecretInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type DeleteCustomerSecretMutation = { __typename?: 'mutation_root', deleteCustomerSecret: { __typename?: 'DeleteCustomerSecretPayload', name: string }, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type CreateCustomerApiKeysMutationMutationVariables = Exact<{
  input: CreateCustomerApiKeysInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type CreateCustomerApiKeysMutationMutation = { __typename?: 'mutation_root', createCustomerApiKeys: { __typename?: 'CreateCustomerApiKeysPayload', apiKeys: Array<{ __typename?: 'CreateCustomerApiKeysPayloadItem', customerId: string, key: string, reference?: string | null, roleId?: string | null }> }, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type AllCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCustomersQuery = { __typename?: 'query_root', customer: Array<{ __typename?: 'Customer', name: string, id: string }> };

export type CustomerQueryVariables = Exact<{
  orderBy: Array<CustomerOrderBy> | CustomerOrderBy;
  where: CustomerBoolExp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type CustomerQuery = { __typename?: 'query_root', customer: Array<{ __typename?: 'Customer', id: string, name: string, config: any, sites: Array<{ __typename?: 'Site', devicesAggregate: { __typename?: 'DeviceAggregate', aggregate?: { __typename?: 'DeviceAggregateFields', count: number } | null } }> }>, customerAggregate: { __typename?: 'CustomerAggregate', aggregate?: { __typename?: 'CustomerAggregateFields', count: number } | null } };

export type CustomerByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CustomerByPkQuery = { __typename?: 'query_root', customerByPk?: { __typename?: 'Customer', id: string, name: string, storagePath: string, config: any, sites: Array<{ __typename?: 'Site', id: string, name: string, devices: Array<{ __typename?: 'Device', id: string }> }>, apiKeys: Array<{ __typename?: 'ApiKey', id: any, key: string, reference?: string | null, description?: string | null, roleId?: string | null }>, sitesAggregate: { __typename?: 'SiteAggregate', aggregate?: { __typename?: 'SiteAggregateFields', count: number } | null } } | null };

export type DevicesByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DevicesByIdsQuery = { __typename?: 'query_root', device: Array<{ __typename?: 'Device', id: string, shortId: string, name?: string | null, serial: string, site?: { __typename?: 'Site', name: string, config: any } | null, apiKeys: Array<{ __typename?: 'ApiKey', key: string, reference?: string | null, roleId?: string | null }> }> };

export type AllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRolesQuery = { __typename?: 'query_root', aspNetRoles: Array<{ __typename?: 'AspNetRoles', id: string, name?: string | null, normalizedName?: string | null }> };

export type DeviceTestQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceTestQuery = { __typename?: 'query_root', device: Array<{ __typename?: 'Device', id: string, name?: string | null, data: any, serial: string, products: any, config: any, siteId?: string | null }> };

export type DeviceByPkTestQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeviceByPkTestQuery = { __typename?: 'query_root', deviceByPk?: { __typename?: 'Device', id: string, name?: string | null, data: any, serial: string, config: any, products: any, siteId?: string | null } | null };

export type CreateDeviceMutationVariables = Exact<{
  input: DeviceInsertInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type CreateDeviceMutation = { __typename?: 'mutation_root', insertDeviceOne?: { __typename?: 'Device', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type UpdateDeviceMutationVariables = Exact<{
  devicePkColumnInput: DevicePkColumnsInput;
  setInput: DeviceSetInput;
  auditLogInput: AuditLogInsertInput;
  invalidateInput: InvalidateDeviceCacheInput;
}>;


export type UpdateDeviceMutation = { __typename?: 'mutation_root', updateDeviceByPk?: { __typename?: 'Device', id: string } | null, invalidateDeviceCache: { __typename?: 'InvalidateDeviceCachePayload', items: Array<{ __typename?: 'InvalidateDeviceCachePayloadItem', deviceId: string }> }, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type RefreshDeviceCacheMutationVariables = Exact<{
  invalidateInput: InvalidateDeviceCacheInput;
}>;


export type RefreshDeviceCacheMutation = { __typename?: 'mutation_root', invalidateDeviceCache: { __typename?: 'InvalidateDeviceCachePayload', items: Array<{ __typename?: 'InvalidateDeviceCachePayloadItem', deviceId: string }> } };

export type CreateUserDeviceLinkMutationVariables = Exact<{
  input: UserDeviceLinkInsertInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type CreateUserDeviceLinkMutation = { __typename?: 'mutation_root', insertUserDeviceLinkOne?: { __typename?: 'UserDeviceLink', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type BulkAssignUserToDevicesMutationVariables = Exact<{
  inputs: Array<UserDeviceLinkInsertInput> | UserDeviceLinkInsertInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type BulkAssignUserToDevicesMutation = { __typename?: 'mutation_root', insertUserDeviceLink?: { __typename?: 'UserDeviceLinkMutationResponse', affectedRows: number } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type CreateDeviceApiKeysMutationMutationVariables = Exact<{
  input: CreateDeviceApiKeysInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type CreateDeviceApiKeysMutationMutation = { __typename?: 'mutation_root', createDeviceApiKeys: { __typename?: 'CreateDeviceApiKeysPayload', apiKeys: Array<{ __typename?: 'CreateDeviceApiKeysPayloadItem', deviceId: string, key: string, reference?: string | null }> }, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type DeleteApiKeyMutation = { __typename?: 'mutation_root', deleteApiKeyByPk?: { __typename?: 'ApiKey', id: any } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type DeleteUserDeviceLinkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type DeleteUserDeviceLinkMutation = { __typename?: 'mutation_root', deleteUserDeviceLinkByPk?: { __typename?: 'UserDeviceLink', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type CreateUpdateRoiMutationMutationVariables = Exact<{
  zoneInsertInputs: Array<ZoneInsertInput> | ZoneInsertInput;
  roiInsertInputs: Array<RoiInsertInput> | RoiInsertInput;
  deleteRoiInputs: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  updateRoiInputs: Array<RoiUpdates> | RoiUpdates;
  auditLogInput: AuditLogInsertInput;
}>;


export type CreateUpdateRoiMutationMutation = { __typename?: 'mutation_root', insertZone?: { __typename?: 'ZoneMutationResponse', affectedRows: number } | null, insertRoi?: { __typename?: 'RoiMutationResponse', affectedRows: number } | null, deleteRoi?: { __typename?: 'RoiMutationResponse', affectedRows: number } | null, updateRoiMany?: Array<{ __typename?: 'RoiMutationResponse', affectedRows: number } | null> | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type DeleteDeviceMutationVariables = Exact<{
  apiKeyIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  deviceId: Scalars['uuid']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type DeleteDeviceMutation = { __typename?: 'mutation_root', deleteApiKey?: { __typename?: 'ApiKeyMutationResponse', affectedRows: number } | null, deleteDeviceByPk?: { __typename?: 'Device', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type MediaBaseFragment = { __typename?: 'Media', id: any, mediaId?: string | null, uri: string, kind: string, time: string, mimeRootType?: string | null, mimeSubType?: string | null } & { ' $fragmentName'?: 'MediaBaseFragment' };

export type DeviceBaseFragment = { __typename?: 'Device', id: string, shortId: string, name?: string | null, data: any, serial: string, products: any, config: any, siteId?: string | null, lastMedia?: { __typename?: 'DeviceLastMedia', lastOriginalMediaTime?: string | null, lastOriginalMediaId?: string | null, media?: (
      { __typename?: 'Media' }
      & { ' $fragmentRefs'?: { 'MediaBaseFragment': MediaBaseFragment } }
    ) | null } | null, site?: { __typename?: 'Site', id: string, name: string, geometry?: any | null, config: any, customer: { __typename?: 'Customer', name: string } } | null, userDeviceLinks: Array<{ __typename?: 'UserDeviceLink', aspNetUser: { __typename?: 'AspNetUsers', id: string, userName?: string | null } }>, lastOriginalMedia: Array<(
    { __typename?: 'Media' }
    & { ' $fragmentRefs'?: { 'MediaBaseFragment': MediaBaseFragment } }
  )>, lastProcessedMedia: Array<(
    { __typename?: 'Media' }
    & { ' $fragmentRefs'?: { 'MediaBaseFragment': MediaBaseFragment } }
  )> } & { ' $fragmentName'?: 'DeviceBaseFragment' };

export type DeviceWithoutZoneQueryVariables = Exact<{
  orderBy: Array<DeviceOrderBy> | DeviceOrderBy;
  where: DeviceBoolExp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type DeviceWithoutZoneQuery = { __typename?: 'query_root', device: Array<(
    { __typename?: 'Device' }
    & { ' $fragmentRefs'?: { 'DeviceBaseFragment': DeviceBaseFragment } }
  )>, deviceAggregate: { __typename?: 'DeviceAggregate', aggregate?: { __typename?: 'DeviceAggregateFields', count: number } | null } };

export type DeviceWithZoneQueryVariables = Exact<{
  orderBy: Array<DeviceOrderBy> | DeviceOrderBy;
  where: DeviceBoolExp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type DeviceWithZoneQuery = { __typename?: 'query_root', device: Array<(
    { __typename?: 'Device', apiKeys: Array<{ __typename?: 'ApiKey', key: string, reference?: string | null, description?: string | null }>, rois: Array<{ __typename?: 'Roi', name: string, config: any, zone?: { __typename?: 'Zone', key: string } | null }> }
    & { ' $fragmentRefs'?: { 'DeviceBaseFragment': DeviceBaseFragment } }
  )>, deviceAggregate: { __typename?: 'DeviceAggregate', aggregate?: { __typename?: 'DeviceAggregateFields', count: number } | null } };

export type DeviceWithZoneQueryNoApiKeyDescriptionQueryVariables = Exact<{
  orderBy: Array<DeviceOrderBy> | DeviceOrderBy;
  where: DeviceBoolExp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type DeviceWithZoneQueryNoApiKeyDescriptionQuery = { __typename?: 'query_root', device: Array<(
    { __typename?: 'Device', apiKeys: Array<{ __typename?: 'ApiKey', key: string, reference?: string | null }>, rois: Array<{ __typename?: 'Roi', name: string, config: any, zone?: { __typename?: 'Zone', key: string } | null }> }
    & { ' $fragmentRefs'?: { 'DeviceBaseFragment': DeviceBaseFragment } }
  )>, deviceAggregate: { __typename?: 'DeviceAggregate', aggregate?: { __typename?: 'DeviceAggregateFields', count: number } | null } };

export type DeviceByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeviceByPkQuery = { __typename?: 'query_root', deviceByPk?: { __typename?: 'Device', id: string, shortId: string, name?: string | null, data: any, serial: string, config: any, products: any, siteId?: string | null, apiKeys: Array<{ __typename?: 'ApiKey', key: string, id: any, reference?: string | null, description?: string | null }>, site?: { __typename?: 'Site', id: string, name: string, geometry?: any | null, config: any } | null } | null };

export type DeviceByPkQueryNoApiKeyDescriptionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeviceByPkQueryNoApiKeyDescriptionQuery = { __typename?: 'query_root', deviceByPk?: { __typename?: 'Device', id: string, shortId: string, name?: string | null, data: any, serial: string, config: any, products: any, siteId?: string | null, apiKeys: Array<{ __typename?: 'ApiKey', key: string, id: any, reference?: string | null }>, site?: { __typename?: 'Site', id: string, name: string, geometry?: any | null, config: any } | null } | null };

export type UserDeviceLinksByDeviceQueryVariables = Exact<{
  deviceId: Scalars['uuid']['input'];
}>;


export type UserDeviceLinksByDeviceQuery = { __typename?: 'query_root', userDeviceLink: Array<{ __typename?: 'UserDeviceLink', id: string, userId: string }> };

export type UserDeviceLinksByUserAndDevicesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  deviceIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UserDeviceLinksByUserAndDevicesQuery = { __typename?: 'query_root', userDeviceLink: Array<{ __typename?: 'UserDeviceLink', deviceId: string }> };

export type RoiByDeviceQueryVariables = Exact<{
  deviceId: Scalars['uuid']['input'];
}>;


export type RoiByDeviceQuery = { __typename?: 'query_root', roi: Array<{ __typename?: 'Roi', id: string, name: string, config: any, zoneId?: string | null }> };

export type CustomerByDeviceQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CustomerByDeviceQuery = { __typename?: 'query_root', deviceByPk?: { __typename?: 'Device', site?: { __typename?: 'Site', customer: { __typename?: 'Customer', config: any } } | null } | null };

export type LiveImageQueryVariables = Exact<{
  deviceId: Scalars['uuid']['input'];
}>;


export type LiveImageQuery = { __typename?: 'query_root', originalMedia: Array<(
    { __typename?: 'Media' }
    & { ' $fragmentRefs'?: { 'MediaBaseFragment': MediaBaseFragment } }
  )>, processedMedia: Array<(
    { __typename?: 'Media' }
    & { ' $fragmentRefs'?: { 'MediaBaseFragment': MediaBaseFragment } }
  )>, maskedMedia: Array<(
    { __typename?: 'Media' }
    & { ' $fragmentRefs'?: { 'MediaBaseFragment': MediaBaseFragment } }
  )> };

export type SurroundingImagesQueryVariables = Exact<{
  beforeFilter: MediaBoolExp;
  afterFilter: MediaBoolExp;
}>;


export type SurroundingImagesQuery = { __typename?: 'query_root', beforeImages: Array<(
    { __typename?: 'Media' }
    & { ' $fragmentRefs'?: { 'MediaBaseFragment': MediaBaseFragment } }
  )>, afterImages: Array<(
    { __typename?: 'Media' }
    & { ' $fragmentRefs'?: { 'MediaBaseFragment': MediaBaseFragment } }
  )> };

export type AuditLogByEntityQueryVariables = Exact<{
  orderBy: Array<AuditLogOrderBy> | AuditLogOrderBy;
  where: AuditLogBoolExp;
}>;


export type AuditLogByEntityQuery = { __typename?: 'query_root', auditLog: Array<{ __typename?: 'AuditLog', id: string, action: string, createdAt: string, actorType: string, entities?: any | null, data: any, aspNetUser?: { __typename?: 'AspNetUsers', userName?: string | null } | null }> };

export type ImageFilterCountsQueryVariables = Exact<{
  whereBefore: MediaBoolExp;
  whereAfter: MediaBoolExp;
}>;


export type ImageFilterCountsQuery = { __typename?: 'query_root', beforeTimestampCount: { __typename?: 'MediaAggregate', aggregate?: { __typename?: 'MediaAggregateFields', count: number } | null }, afterTimestampCount: { __typename?: 'MediaAggregate', aggregate?: { __typename?: 'MediaAggregateFields', count: number } | null } };

export type DeviceMediaFromTimeQueryVariables = Exact<{
  deviceId: Scalars['uuid']['input'];
  fromTime: Scalars['timestamptz']['input'];
  limit: Scalars['Int']['input'];
  kind: Scalars['String']['input'];
}>;


export type DeviceMediaFromTimeQuery = { __typename?: 'query_root', media: Array<{ __typename?: 'Media', id: any, mediaId?: string | null, uri: string, kind: string, time: string, mimeRootType?: string | null, mimeSubType?: string | null }> };

export type DeviceMediaBeforeTimeQueryVariables = Exact<{
  deviceId: Scalars['uuid']['input'];
  beforeTime: Scalars['timestamptz']['input'];
  limit: Scalars['Int']['input'];
  kind: Scalars['String']['input'];
}>;


export type DeviceMediaBeforeTimeQuery = { __typename?: 'query_root', media: Array<{ __typename?: 'Media', id: any, mediaId?: string | null, uri: string, kind: string, time: string, mimeRootType?: string | null, mimeSubType?: string | null }> };

export type LatestDeviceImageQueryVariables = Exact<{
  where?: InputMaybe<MediaBoolExp>;
}>;


export type LatestDeviceImageQuery = { __typename?: 'query_root', media: Array<{ __typename?: 'Media', id: any }> };

export type UserByRoleQueryVariables = Exact<{
  role: Scalars['String']['input'];
}>;


export type UserByRoleQuery = { __typename?: 'query_root', aspNetUsers: Array<{ __typename?: 'AspNetUsers', id: string, userName?: string | null, normalizedUserName?: string | null, aspNetUserRoles: Array<{ __typename?: 'AspNetUserRoles', aspNetRole: { __typename?: 'AspNetRoles', id: string, name?: string | null, normalizedName?: string | null } }> }> };

export type SnZoneQueryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  distanceWithinMeters: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
}>;


export type SnZoneQueryQuery = { __typename?: 'query_root', snZones: Array<{ __typename?: 'SnZone', polygon: string, zoneKey: string, polygonId: number, zoneName: string }> };

export type ZoneQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ZoneQueryQuery = { __typename?: 'query_root', zone: Array<{ __typename?: 'Zone', id: string, key: string }> };

export type DevicesQueryVariables = Exact<{
  where: DeviceBoolExp;
}>;


export type DevicesQuery = { __typename?: 'query_root', device: Array<(
    { __typename?: 'Device', apiKeys: Array<{ __typename?: 'ApiKey', key: string, reference?: string | null, description?: string | null }>, rois: Array<{ __typename?: 'Roi', name: string, config: any, zone?: { __typename?: 'Zone', key: string } | null }> }
    & { ' $fragmentRefs'?: { 'DeviceBaseFragment': DeviceBaseFragment } }
  )> };

export type DevicesQueryNoApiKeyDescriptionQueryVariables = Exact<{
  where: DeviceBoolExp;
}>;


export type DevicesQueryNoApiKeyDescriptionQuery = { __typename?: 'query_root', device: Array<(
    { __typename?: 'Device', apiKeys: Array<{ __typename?: 'ApiKey', key: string, reference?: string | null }>, rois: Array<{ __typename?: 'Roi', name: string, config: any, zone?: { __typename?: 'Zone', key: string } | null }> }
    & { ' $fragmentRefs'?: { 'DeviceBaseFragment': DeviceBaseFragment } }
  )> };

export type AssignedDevicesToSiteMutationVariables = Exact<{
  siteId: Scalars['uuid']['input'];
  deviceIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type AssignedDevicesToSiteMutation = { __typename?: 'mutation_root', updateDeviceMany?: Array<{ __typename?: 'DeviceMutationResponse', affectedRows: number } | null> | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type UnassignedDevicesFromSiteMutationVariables = Exact<{
  deviceIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type UnassignedDevicesFromSiteMutation = { __typename?: 'mutation_root', updateDeviceMany?: Array<{ __typename?: 'DeviceMutationResponse', affectedRows: number } | null> | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type UpdateSiteMutationVariables = Exact<{
  pkColumnInput: SitePkColumnsInput;
  setInput: SiteSetInput;
  auditLogInput: AuditLogInsertInput;
}>;


export type UpdateSiteMutation = { __typename?: 'mutation_root', updateSiteByPk?: { __typename?: 'Site', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type DeleteSiteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  auditLogInput: AuditLogInsertInput;
}>;


export type DeleteSiteMutation = { __typename?: 'mutation_root', deleteSiteByPk?: { __typename?: 'Site', id: string } | null, insertAuditLogOne?: { __typename?: 'AuditLog', id: string } | null };

export type SiteQueryVariables = Exact<{
  orderBy: Array<SiteOrderBy> | SiteOrderBy;
  where: SiteBoolExp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type SiteQuery = { __typename?: 'query_root', site: Array<{ __typename?: 'Site', id: string, name: string, config: any, geometry?: any | null, userData?: any | null, customer: { __typename?: 'Customer', name: string } }>, siteAggregate: { __typename?: 'SiteAggregate', aggregate?: { __typename?: 'SiteAggregateFields', count: number } | null } };

export type AllCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCustomerQuery = { __typename?: 'query_root', customer: Array<{ __typename?: 'Customer', id: string, name: string, config: any, sites: Array<{ __typename?: 'Site', config: any }> }> };

export type SiteByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SiteByPkQuery = { __typename?: 'query_root', siteByPk?: { __typename?: 'Site', id: string, name: string, config: any, geometry?: any | null, userData?: any | null, customerId: string, devices: Array<{ __typename?: 'Device', id: string, name?: string | null, serial: string, products: any, config: any }>, customer: { __typename?: 'Customer', id: string, name: string }, devicesAggregate: { __typename?: 'DeviceAggregate', aggregate?: { __typename?: 'DeviceAggregateFields', count: number } | null } } | null };

export type UnassignedDeviceQueryVariables = Exact<{ [key: string]: never; }>;


export type UnassignedDeviceQuery = { __typename?: 'query_root', device: Array<{ __typename?: 'Device', id: string, name?: string | null, serial: string, products: any, siteId?: string | null }>, deviceAggregate: { __typename?: 'DeviceAggregate', aggregate?: { __typename?: 'DeviceAggregateFields', count: number } | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const MediaBaseFragmentDoc = new TypedDocumentString(`
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}
    `, {"fragmentName":"MediaBase"}) as unknown as TypedDocumentString<MediaBaseFragment, unknown>;
export const DeviceBaseFragmentDoc = new TypedDocumentString(`
    fragment DeviceBase on Device {
  id
  shortId
  name
  data
  serial
  products
  config
  siteId
  lastMedia {
    lastOriginalMediaTime
    lastOriginalMediaId
    media {
      ...MediaBase
    }
  }
  site {
    id
    name
    geometry
    customer {
      name
    }
    config
  }
  userDeviceLinks {
    aspNetUser {
      id
      userName
    }
  }
  lastOriginalMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Original"}}
  ) {
    ...MediaBase
  }
  lastProcessedMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Processed"}}
  ) {
    ...MediaBase
  }
}
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}`, {"fragmentName":"DeviceBase"}) as unknown as TypedDocumentString<DeviceBaseFragment, unknown>;
export const InsertAuditLogDocument = new TypedDocumentString(`
    mutation insertAuditLog($inputs: [AuditLogInsertInput!]!) {
  insertAuditLog(objects: $inputs) {
    affectedRows
  }
}
    `) as unknown as TypedDocumentString<InsertAuditLogMutation, InsertAuditLogMutationVariables>;
export const AuditLogDocument = new TypedDocumentString(`
    query auditLog($orderBy: [AuditLogOrderBy!]!, $where: AuditLogBoolExp!, $limit: Int!, $offset: Int!) {
  auditLog(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
    id
    action
    createdAt
    entities
    actorType
    data
    aspNetUser {
      userName
    }
  }
  auditLogAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<AuditLogQuery, AuditLogQueryVariables>;
export const AllUserDocument = new TypedDocumentString(`
    query allUser {
  aspNetUsers(orderBy: {userName: ASC}) {
    sub
    userName
    aspNetUserRoles {
      aspNetRole {
        name
        normalizedName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AllUserQuery, AllUserQueryVariables>;
export const DeleteSitesDocument = new TypedDocumentString(`
    mutation deleteSites($ids: [uuid!]!, $auditLogInput: AuditLogInsertInput!) {
  deleteSite(where: {id: {_in: $ids}}) {
    affectedRows
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteSitesMutation, DeleteSitesMutationVariables>;
export const CreateCustomerDocument = new TypedDocumentString(`
    mutation createCustomer($input: CustomerInsertInput!, $auditLogInput: AuditLogInsertInput!) {
  insertCustomerOne(object: $input) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateSiteDocument = new TypedDocumentString(`
    mutation createSite($inputs: SiteInsertInput!, $auditLogInput: AuditLogInsertInput!) {
  insertSiteOne(object: $inputs) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateSiteMutation, CreateSiteMutationVariables>;
export const UpdateCustomerDocument = new TypedDocumentString(`
    mutation updateCustomer($pkColumnInput: CustomerPkColumnsInput!, $setInput: CustomerSetInput!, $auditLogInput: AuditLogInsertInput!) {
  updateCustomerByPk(pkColumns: $pkColumnInput, _set: $setInput) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const CreateDeviceInBulkDocument = new TypedDocumentString(`
    mutation createDeviceInBulk($deviceInsertInputs: [DeviceInsertInput!]!, $siteInsertInputs: [SiteInsertInput!]!, $auditLogInput: AuditLogInsertInput!) {
  insertSite(objects: $siteInsertInputs) {
    affectedRows
  }
  insertDevice(objects: $deviceInsertInputs) {
    returning {
      id
    }
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateDeviceInBulkMutation, CreateDeviceInBulkMutationVariables>;
export const DeleteCustomerDocument = new TypedDocumentString(`
    mutation deleteCustomer($id: uuid!, $auditLogInput: AuditLogInsertInput!) {
  deleteCustomerByPk(id: $id) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const UpsertCustomerS3BucketDocument = new TypedDocumentString(`
    mutation upsertCustomerS3Bucket($customerId: UUID!, $auditLogInput: AuditLogInsertInput!) {
  upsertCustomerS3Bucket(input: {customerId: $customerId})
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpsertCustomerS3BucketMutation, UpsertCustomerS3BucketMutationVariables>;
export const UpsertCustomerSecretDocument = new TypedDocumentString(`
    mutation upsertCustomerSecret($input: UpsertCustomerSecretInput!, $invalidateCacheInput: InvalidateCustomerSecretCacheInput!, $auditLogInput: AuditLogInsertInput!) {
  upsertCustomerSecret(input: $input) {
    uri
  }
  invalidateCustomerSecretCache(input: $invalidateCacheInput) {
    success
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpsertCustomerSecretMutation, UpsertCustomerSecretMutationVariables>;
export const DeleteCustomerSecretDocument = new TypedDocumentString(`
    mutation deleteCustomerSecret($input: DeleteCustomerSecretInput!, $auditLogInput: AuditLogInsertInput!) {
  deleteCustomerSecret(input: $input) {
    name
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteCustomerSecretMutation, DeleteCustomerSecretMutationVariables>;
export const CreateCustomerApiKeysMutationDocument = new TypedDocumentString(`
    mutation createCustomerApiKeysMutation($input: CreateCustomerApiKeysInput!, $auditLogInput: AuditLogInsertInput!) {
  createCustomerApiKeys(input: $input) {
    apiKeys {
      customerId
      key
      reference
      roleId
    }
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateCustomerApiKeysMutationMutation, CreateCustomerApiKeysMutationMutationVariables>;
export const AllCustomersDocument = new TypedDocumentString(`
    query allCustomers {
  customer(orderBy: {name: ASC}) {
    name
    id
  }
}
    `) as unknown as TypedDocumentString<AllCustomersQuery, AllCustomersQueryVariables>;
export const CustomerDocument = new TypedDocumentString(`
    query customer($orderBy: [CustomerOrderBy!]!, $where: CustomerBoolExp!, $limit: Int!, $offset: Int!) {
  customer(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
    id
    name
    config
    sites {
      devicesAggregate {
        aggregate {
          count
        }
      }
    }
  }
  customerAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<CustomerQuery, CustomerQueryVariables>;
export const CustomerByPkDocument = new TypedDocumentString(`
    query customerByPk($id: uuid!) {
  customerByPk(id: $id) {
    id
    name
    storagePath
    config
    sites {
      id
      name
      devices {
        id
      }
    }
    apiKeys(orderBy: {createdAt: ASC}) {
      id
      key
      reference
      description
      roleId
    }
    sitesAggregate {
      aggregate {
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CustomerByPkQuery, CustomerByPkQueryVariables>;
export const DevicesByIdsDocument = new TypedDocumentString(`
    query devicesByIds($ids: [uuid!]) {
  device(where: {id: {_in: $ids}}) {
    id
    shortId
    name
    serial
    site {
      name
      config
    }
    apiKeys(orderBy: {createdAt: ASC}) {
      key
      reference
      roleId
    }
  }
}
    `) as unknown as TypedDocumentString<DevicesByIdsQuery, DevicesByIdsQueryVariables>;
export const AllRolesDocument = new TypedDocumentString(`
    query allRoles {
  aspNetRoles(orderBy: {name: ASC}) {
    id
    name
    normalizedName
  }
}
    `) as unknown as TypedDocumentString<AllRolesQuery, AllRolesQueryVariables>;
export const DeviceTestDocument = new TypedDocumentString(`
    query deviceTest {
  device {
    id
    name
    data
    serial
    products
    config
    siteId
  }
}
    `) as unknown as TypedDocumentString<DeviceTestQuery, DeviceTestQueryVariables>;
export const DeviceByPkTestDocument = new TypedDocumentString(`
    query deviceByPkTest($id: uuid!) {
  deviceByPk(id: $id) {
    id
    name
    data
    serial
    config
    products
    siteId
  }
}
    `) as unknown as TypedDocumentString<DeviceByPkTestQuery, DeviceByPkTestQueryVariables>;
export const CreateDeviceDocument = new TypedDocumentString(`
    mutation createDevice($input: DeviceInsertInput!, $auditLogInput: AuditLogInsertInput!) {
  insertDeviceOne(object: $input) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const UpdateDeviceDocument = new TypedDocumentString(`
    mutation updateDevice($devicePkColumnInput: DevicePkColumnsInput!, $setInput: DeviceSetInput!, $auditLogInput: AuditLogInsertInput!, $invalidateInput: InvalidateDeviceCacheInput!) {
  updateDeviceByPk(pkColumns: $devicePkColumnInput, _set: $setInput) {
    id
  }
  invalidateDeviceCache(input: $invalidateInput) {
    items {
      deviceId
    }
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateDeviceMutation, UpdateDeviceMutationVariables>;
export const RefreshDeviceCacheDocument = new TypedDocumentString(`
    mutation refreshDeviceCache($invalidateInput: InvalidateDeviceCacheInput!) {
  invalidateDeviceCache(input: $invalidateInput) {
    items {
      deviceId
    }
  }
}
    `) as unknown as TypedDocumentString<RefreshDeviceCacheMutation, RefreshDeviceCacheMutationVariables>;
export const CreateUserDeviceLinkDocument = new TypedDocumentString(`
    mutation createUserDeviceLink($input: UserDeviceLinkInsertInput!, $auditLogInput: AuditLogInsertInput!) {
  insertUserDeviceLinkOne(object: $input) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateUserDeviceLinkMutation, CreateUserDeviceLinkMutationVariables>;
export const BulkAssignUserToDevicesDocument = new TypedDocumentString(`
    mutation bulkAssignUserToDevices($inputs: [UserDeviceLinkInsertInput!]!, $auditLogInput: AuditLogInsertInput!) {
  insertUserDeviceLink(objects: $inputs) {
    affectedRows
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<BulkAssignUserToDevicesMutation, BulkAssignUserToDevicesMutationVariables>;
export const CreateDeviceApiKeysMutationDocument = new TypedDocumentString(`
    mutation createDeviceApiKeysMutation($input: CreateDeviceApiKeysInput!, $auditLogInput: AuditLogInsertInput!) {
  createDeviceApiKeys(input: $input) {
    apiKeys {
      deviceId
      key
      reference
    }
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateDeviceApiKeysMutationMutation, CreateDeviceApiKeysMutationMutationVariables>;
export const DeleteApiKeyDocument = new TypedDocumentString(`
    mutation deleteApiKey($id: bigint!, $auditLogInput: AuditLogInsertInput!) {
  deleteApiKeyByPk(id: $id) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const DeleteUserDeviceLinkDocument = new TypedDocumentString(`
    mutation deleteUserDeviceLink($id: uuid!, $auditLogInput: AuditLogInsertInput!) {
  deleteUserDeviceLinkByPk(id: $id) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteUserDeviceLinkMutation, DeleteUserDeviceLinkMutationVariables>;
export const CreateUpdateRoiMutationDocument = new TypedDocumentString(`
    mutation createUpdateRoiMutation($zoneInsertInputs: [ZoneInsertInput!]!, $roiInsertInputs: [RoiInsertInput!]!, $deleteRoiInputs: [uuid!]!, $updateRoiInputs: [RoiUpdates!]!, $auditLogInput: AuditLogInsertInput!) {
  insertZone(objects: $zoneInsertInputs) {
    affectedRows
  }
  insertRoi(objects: $roiInsertInputs) {
    affectedRows
  }
  deleteRoi(where: {id: {_in: $deleteRoiInputs}}) {
    affectedRows
  }
  updateRoiMany(updates: $updateRoiInputs) {
    affectedRows
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateUpdateRoiMutationMutation, CreateUpdateRoiMutationMutationVariables>;
export const DeleteDeviceDocument = new TypedDocumentString(`
    mutation deleteDevice($apiKeyIds: [bigint!]!, $deviceId: uuid!, $auditLogInput: AuditLogInsertInput!) {
  deleteApiKey(where: {id: {_in: $apiKeyIds}}) {
    affectedRows
  }
  deleteDeviceByPk(id: $deviceId) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteDeviceMutation, DeleteDeviceMutationVariables>;
export const DeviceWithoutZoneDocument = new TypedDocumentString(`
    query deviceWithoutZone($orderBy: [DeviceOrderBy!]!, $where: DeviceBoolExp!, $limit: Int!, $offset: Int!) {
  device(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
    ...DeviceBase
  }
  deviceAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}
fragment DeviceBase on Device {
  id
  shortId
  name
  data
  serial
  products
  config
  siteId
  lastMedia {
    lastOriginalMediaTime
    lastOriginalMediaId
    media {
      ...MediaBase
    }
  }
  site {
    id
    name
    geometry
    customer {
      name
    }
    config
  }
  userDeviceLinks {
    aspNetUser {
      id
      userName
    }
  }
  lastOriginalMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Original"}}
  ) {
    ...MediaBase
  }
  lastProcessedMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Processed"}}
  ) {
    ...MediaBase
  }
}`) as unknown as TypedDocumentString<DeviceWithoutZoneQuery, DeviceWithoutZoneQueryVariables>;
export const DeviceWithZoneDocument = new TypedDocumentString(`
    query deviceWithZone($orderBy: [DeviceOrderBy!]!, $where: DeviceBoolExp!, $limit: Int!, $offset: Int!) {
  device(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
    ...DeviceBase
    apiKeys(orderBy: {createdAt: ASC}) {
      key
      reference
      description
    }
    rois {
      name
      config
      zone {
        key
      }
    }
  }
  deviceAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}
fragment DeviceBase on Device {
  id
  shortId
  name
  data
  serial
  products
  config
  siteId
  lastMedia {
    lastOriginalMediaTime
    lastOriginalMediaId
    media {
      ...MediaBase
    }
  }
  site {
    id
    name
    geometry
    customer {
      name
    }
    config
  }
  userDeviceLinks {
    aspNetUser {
      id
      userName
    }
  }
  lastOriginalMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Original"}}
  ) {
    ...MediaBase
  }
  lastProcessedMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Processed"}}
  ) {
    ...MediaBase
  }
}`) as unknown as TypedDocumentString<DeviceWithZoneQuery, DeviceWithZoneQueryVariables>;
export const DeviceWithZoneQueryNoApiKeyDescriptionDocument = new TypedDocumentString(`
    query deviceWithZoneQueryNoApiKeyDescription($orderBy: [DeviceOrderBy!]!, $where: DeviceBoolExp!, $limit: Int!, $offset: Int!) {
  device(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
    ...DeviceBase
    apiKeys(orderBy: {createdAt: ASC}) {
      key
      reference
    }
    rois {
      name
      config
      zone {
        key
      }
    }
  }
  deviceAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}
fragment DeviceBase on Device {
  id
  shortId
  name
  data
  serial
  products
  config
  siteId
  lastMedia {
    lastOriginalMediaTime
    lastOriginalMediaId
    media {
      ...MediaBase
    }
  }
  site {
    id
    name
    geometry
    customer {
      name
    }
    config
  }
  userDeviceLinks {
    aspNetUser {
      id
      userName
    }
  }
  lastOriginalMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Original"}}
  ) {
    ...MediaBase
  }
  lastProcessedMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Processed"}}
  ) {
    ...MediaBase
  }
}`) as unknown as TypedDocumentString<DeviceWithZoneQueryNoApiKeyDescriptionQuery, DeviceWithZoneQueryNoApiKeyDescriptionQueryVariables>;
export const DeviceByPkDocument = new TypedDocumentString(`
    query deviceByPk($id: uuid!) {
  deviceByPk(id: $id) {
    id
    shortId
    name
    data
    serial
    config
    products
    siteId
    apiKeys(orderBy: {createdAt: ASC}) {
      key
      id
      reference
      description
    }
    site {
      id
      name
      geometry
      config
    }
  }
}
    `) as unknown as TypedDocumentString<DeviceByPkQuery, DeviceByPkQueryVariables>;
export const DeviceByPkQueryNoApiKeyDescriptionDocument = new TypedDocumentString(`
    query deviceByPkQueryNoApiKeyDescription($id: uuid!) {
  deviceByPk(id: $id) {
    id
    shortId
    name
    data
    serial
    config
    products
    siteId
    apiKeys(orderBy: {createdAt: ASC}) {
      key
      id
      reference
    }
    site {
      id
      name
      geometry
      config
    }
  }
}
    `) as unknown as TypedDocumentString<DeviceByPkQueryNoApiKeyDescriptionQuery, DeviceByPkQueryNoApiKeyDescriptionQueryVariables>;
export const UserDeviceLinksByDeviceDocument = new TypedDocumentString(`
    query userDeviceLinksByDevice($deviceId: uuid!) {
  userDeviceLink(where: {deviceId: {_eq: $deviceId}}) {
    id
    userId
  }
}
    `) as unknown as TypedDocumentString<UserDeviceLinksByDeviceQuery, UserDeviceLinksByDeviceQueryVariables>;
export const UserDeviceLinksByUserAndDevicesDocument = new TypedDocumentString(`
    query userDeviceLinksByUserAndDevices($userId: String!, $deviceIds: [uuid!]!) {
  userDeviceLink(where: {userId: {_eq: $userId}, deviceId: {_in: $deviceIds}}) {
    deviceId
  }
}
    `) as unknown as TypedDocumentString<UserDeviceLinksByUserAndDevicesQuery, UserDeviceLinksByUserAndDevicesQueryVariables>;
export const RoiByDeviceDocument = new TypedDocumentString(`
    query roiByDevice($deviceId: uuid!) {
  roi(where: {deviceId: {_eq: $deviceId}}) {
    id
    name
    config
    zoneId
  }
}
    `) as unknown as TypedDocumentString<RoiByDeviceQuery, RoiByDeviceQueryVariables>;
export const CustomerByDeviceDocument = new TypedDocumentString(`
    query customerByDevice($id: uuid!) {
  deviceByPk(id: $id) {
    site {
      customer {
        config
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CustomerByDeviceQuery, CustomerByDeviceQueryVariables>;
export const LiveImageDocument = new TypedDocumentString(`
    query liveImage($deviceId: uuid!) {
  originalMedia: media(
    where: {deviceId: {_eq: $deviceId}, kind: {_eq: "Original"}}
    orderBy: {time: DESC}
    limit: 2
  ) {
    ...MediaBase
  }
  processedMedia: media(
    where: {deviceId: {_eq: $deviceId}, kind: {_eq: "Processed"}}
    orderBy: {time: DESC}
    limit: 2
  ) {
    ...MediaBase
  }
  maskedMedia: media(
    where: {deviceId: {_eq: $deviceId}, kind: {_eq: "Masked"}}
    orderBy: {time: DESC}
    limit: 2
  ) {
    ...MediaBase
  }
}
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}`) as unknown as TypedDocumentString<LiveImageQuery, LiveImageQueryVariables>;
export const SurroundingImagesDocument = new TypedDocumentString(`
    query surroundingImages($beforeFilter: MediaBoolExp!, $afterFilter: MediaBoolExp!) {
  beforeImages: media(
    where: $beforeFilter
    orderBy: {time: DESC}
    limit: 2
    offset: 0
  ) {
    ...MediaBase
  }
  afterImages: media(
    where: $afterFilter
    orderBy: {time: ASC}
    limit: 2
    offset: 0
  ) {
    ...MediaBase
  }
}
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}`) as unknown as TypedDocumentString<SurroundingImagesQuery, SurroundingImagesQueryVariables>;
export const AuditLogByEntityDocument = new TypedDocumentString(`
    query auditLogByEntity($orderBy: [AuditLogOrderBy!]!, $where: AuditLogBoolExp!) {
  auditLog(orderBy: $orderBy, where: $where) {
    id
    action
    createdAt
    actorType
    entities
    data
    aspNetUser {
      userName
    }
  }
}
    `) as unknown as TypedDocumentString<AuditLogByEntityQuery, AuditLogByEntityQueryVariables>;
export const ImageFilterCountsDocument = new TypedDocumentString(`
    query imageFilterCounts($whereBefore: MediaBoolExp!, $whereAfter: MediaBoolExp!) {
  beforeTimestampCount: mediaAggregate(where: $whereBefore) {
    aggregate {
      count
    }
  }
  afterTimestampCount: mediaAggregate(where: $whereAfter) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<ImageFilterCountsQuery, ImageFilterCountsQueryVariables>;
export const DeviceMediaFromTimeDocument = new TypedDocumentString(`
    query deviceMediaFromTime($deviceId: uuid!, $fromTime: timestamptz!, $limit: Int!, $kind: String!) {
  media(
    where: {deviceId: {_eq: $deviceId}, time: {_gte: $fromTime}, kind: {_eq: $kind}}
    orderBy: {time: ASC}
    limit: $limit
  ) {
    id
    mediaId
    uri
    kind
    time
    mimeRootType
    mimeSubType
  }
}
    `) as unknown as TypedDocumentString<DeviceMediaFromTimeQuery, DeviceMediaFromTimeQueryVariables>;
export const DeviceMediaBeforeTimeDocument = new TypedDocumentString(`
    query deviceMediaBeforeTime($deviceId: uuid!, $beforeTime: timestamptz!, $limit: Int!, $kind: String!) {
  media(
    where: {deviceId: {_eq: $deviceId}, time: {_lt: $beforeTime}, kind: {_eq: $kind}}
    orderBy: {time: DESC}
    limit: $limit
  ) {
    id
    mediaId
    uri
    kind
    time
    mimeRootType
    mimeSubType
  }
}
    `) as unknown as TypedDocumentString<DeviceMediaBeforeTimeQuery, DeviceMediaBeforeTimeQueryVariables>;
export const LatestDeviceImageDocument = new TypedDocumentString(`
    query latestDeviceImage($where: MediaBoolExp) {
  media(offset: 0, limit: 1, orderBy: {time: DESC}, where: $where) {
    id
  }
}
    `) as unknown as TypedDocumentString<LatestDeviceImageQuery, LatestDeviceImageQueryVariables>;
export const UserByRoleDocument = new TypedDocumentString(`
    query userByRole($role: String!) {
  aspNetUsers(where: {aspNetUserRoles: {aspNetRole: {name: {_eq: $role}}}}) {
    id
    userName
    normalizedUserName
    aspNetUserRoles {
      aspNetRole {
        id
        name
        normalizedName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UserByRoleQuery, UserByRoleQueryVariables>;
export const SnZoneQueryDocument = new TypedDocumentString(`
    query snZoneQuery($id: UUID!, $distanceWithinMeters: Float!, $longitude: Float!, $latitude: Float!) {
  snZones(
    deviceId: $id
    distanceWithinMeters: $distanceWithinMeters
    longitude: $longitude
    latitude: $latitude
  ) {
    polygon
    zoneKey
    polygonId
    zoneName
  }
}
    `) as unknown as TypedDocumentString<SnZoneQueryQuery, SnZoneQueryQueryVariables>;
export const ZoneQueryDocument = new TypedDocumentString(`
    query zoneQuery {
  zone {
    id
    key
  }
}
    `) as unknown as TypedDocumentString<ZoneQueryQuery, ZoneQueryQueryVariables>;
export const DevicesDocument = new TypedDocumentString(`
    query devices($where: DeviceBoolExp!) {
  device(where: $where) {
    ...DeviceBase
    apiKeys {
      key
      reference
      description
    }
    rois {
      name
      config
      zone {
        key
      }
    }
  }
}
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}
fragment DeviceBase on Device {
  id
  shortId
  name
  data
  serial
  products
  config
  siteId
  lastMedia {
    lastOriginalMediaTime
    lastOriginalMediaId
    media {
      ...MediaBase
    }
  }
  site {
    id
    name
    geometry
    customer {
      name
    }
    config
  }
  userDeviceLinks {
    aspNetUser {
      id
      userName
    }
  }
  lastOriginalMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Original"}}
  ) {
    ...MediaBase
  }
  lastProcessedMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Processed"}}
  ) {
    ...MediaBase
  }
}`) as unknown as TypedDocumentString<DevicesQuery, DevicesQueryVariables>;
export const DevicesQueryNoApiKeyDescriptionDocument = new TypedDocumentString(`
    query devicesQueryNoApiKeyDescription($where: DeviceBoolExp!) {
  device(where: $where) {
    ...DeviceBase
    apiKeys {
      key
      reference
    }
    rois {
      name
      config
      zone {
        key
      }
    }
  }
}
    fragment MediaBase on Media {
  id
  mediaId
  uri
  kind
  time
  mimeRootType
  mimeSubType
}
fragment DeviceBase on Device {
  id
  shortId
  name
  data
  serial
  products
  config
  siteId
  lastMedia {
    lastOriginalMediaTime
    lastOriginalMediaId
    media {
      ...MediaBase
    }
  }
  site {
    id
    name
    geometry
    customer {
      name
    }
    config
  }
  userDeviceLinks {
    aspNetUser {
      id
      userName
    }
  }
  lastOriginalMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Original"}}
  ) {
    ...MediaBase
  }
  lastProcessedMedia: media(
    limit: 1
    orderBy: {time: DESC}
    where: {kind: {_eq: "Processed"}}
  ) {
    ...MediaBase
  }
}`) as unknown as TypedDocumentString<DevicesQueryNoApiKeyDescriptionQuery, DevicesQueryNoApiKeyDescriptionQueryVariables>;
export const AssignedDevicesToSiteDocument = new TypedDocumentString(`
    mutation assignedDevicesToSite($siteId: uuid!, $deviceIds: [uuid!]!, $auditLogInput: AuditLogInsertInput!) {
  updateDeviceMany(
    updates: {_set: {siteId: $siteId}, where: {id: {_in: $deviceIds}}}
  ) {
    affectedRows
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<AssignedDevicesToSiteMutation, AssignedDevicesToSiteMutationVariables>;
export const UnassignedDevicesFromSiteDocument = new TypedDocumentString(`
    mutation unassignedDevicesFromSite($deviceIds: [uuid!]!, $auditLogInput: AuditLogInsertInput!) {
  updateDeviceMany(
    updates: {_set: {siteId: null}, where: {id: {_in: $deviceIds}}}
  ) {
    affectedRows
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<UnassignedDevicesFromSiteMutation, UnassignedDevicesFromSiteMutationVariables>;
export const UpdateSiteDocument = new TypedDocumentString(`
    mutation updateSite($pkColumnInput: SitePkColumnsInput!, $setInput: SiteSetInput!, $auditLogInput: AuditLogInsertInput!) {
  updateSiteByPk(pkColumns: $pkColumnInput, _set: $setInput) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const DeleteSiteDocument = new TypedDocumentString(`
    mutation deleteSite($id: uuid!, $auditLogInput: AuditLogInsertInput!) {
  deleteSiteByPk(id: $id) {
    id
  }
  insertAuditLogOne(object: $auditLogInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteSiteMutation, DeleteSiteMutationVariables>;
export const SiteDocument = new TypedDocumentString(`
    query site($orderBy: [SiteOrderBy!]!, $where: SiteBoolExp!, $limit: Int!, $offset: Int!) {
  site(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
    id
    name
    config
    geometry
    customer {
      name
    }
    userData
  }
  siteAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<SiteQuery, SiteQueryVariables>;
export const AllCustomerDocument = new TypedDocumentString(`
    query allCustomer {
  customer(orderBy: {name: ASC}) {
    id
    name
    config
    sites(limit: 1) {
      config
    }
  }
}
    `) as unknown as TypedDocumentString<AllCustomerQuery, AllCustomerQueryVariables>;
export const SiteByPkDocument = new TypedDocumentString(`
    query siteByPk($id: uuid!) {
  siteByPk(id: $id) {
    id
    name
    config
    geometry
    devices {
      id
      name
      serial
      products
      config
    }
    customer {
      id
      name
    }
    devicesAggregate {
      aggregate {
        count
      }
    }
    userData
    customerId
  }
}
    `) as unknown as TypedDocumentString<SiteByPkQuery, SiteByPkQueryVariables>;
export const UnassignedDeviceDocument = new TypedDocumentString(`
    query unassignedDevice {
  device(where: {siteId: {_isNull: true}}) {
    id
    name
    serial
    products
    siteId
  }
  deviceAggregate(where: {siteId: {_isNull: true}}) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<UnassignedDeviceQuery, UnassignedDeviceQueryVariables>;